var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import G6, { Arrow, registerEdge, registerNode, TreeGraph } from "@antv/g6";
export { Menu, Minimap, ToolBar } from "@antv/g6";
import { ref } from "vue";
var NameString = /* @__PURE__ */ ((NameString2) => {
  NameString2["linkEdgeCircle"] = "link-edge-dot";
  NameString2["linkCircle"] = "link-circle";
  NameString2["linkGroup"] = "link-group";
  NameString2["linkSelectDot"] = "link-select-dot";
  NameString2["edgeLink"] = "edge-link";
  NameString2["edgeLinkDot"] = "edge-link-dot";
  NameString2["edgeLinkPath"] = "edge-link-path";
  NameString2["edgeTitleBg"] = "edge-title-bg";
  NameString2["edgeTitle"] = "edge-title";
  NameString2["edgeTitleGroup"] = "edge-title-group";
  NameString2["edgeArrowUp"] = "edge-arrow-up";
  NameString2["edgeArrowDown"] = "edge-arrow-down";
  NameString2["collapseCircle"] = "collapse-circle";
  NameString2["collapseClick"] = "collapse-click";
  NameString2["nodeWrapper"] = "node-wrapper";
  NameString2["nodeContainer"] = "node-container";
  NameString2["textCusor"] = "text-cusor";
  return NameString2;
})(NameString || {});
var IDString = /* @__PURE__ */ ((IDString2) => {
  IDString2["linkTargetDot"] = "link-target-dot";
  IDString2["linkSourceDot"] = "link-source-dot";
  IDString2["linkMouseNode"] = "link-mouse-node";
  return IDString2;
})(IDString || {});
var NodeType = /* @__PURE__ */ ((NodeType2) => {
  NodeType2["defaultNode"] = "mindmap-node";
  NodeType2["labelNode"] = "label-node";
  NodeType2["linkEdge"] = "edge-quadratic";
  NodeType2["defaultEdge"] = "round-poly";
  NodeType2["shrinkRoot"] = "shrink-root";
  return NodeType2;
})(NodeType || {});
const nameHideRoot = "hide-root";
var EventName = /* @__PURE__ */ ((EventName2) => {
  EventName2["change"] = "change";
  return EventName2;
})(EventName || {});
var MindmapEvent = /* @__PURE__ */ ((MindmapEvent2) => {
  MindmapEvent2["loaded"] = "loaded";
  MindmapEvent2["canvasClick"] = "canvas-click";
  MindmapEvent2["nodeMove"] = "node-move";
  MindmapEvent2["nodeTitleChange"] = "node-title-change";
  MindmapEvent2["nodeTitleBlur"] = "node-title-blur";
  MindmapEvent2["nodeAdd"] = "node-add";
  MindmapEvent2["nodeCollapsed"] = "node-collapsed";
  MindmapEvent2["nodeDelete"] = "node-delete";
  MindmapEvent2["nodeSelect"] = "node-select";
  MindmapEvent2["nodeCorrelation"] = "node-correlation";
  MindmapEvent2["nodeChangeRoot"] = "node-change-root";
  MindmapEvent2["nodeShowEdges"] = "node-show-edges";
  MindmapEvent2["edgeClickShowLabel"] = "edge-click-show-label";
  MindmapEvent2["edgeExist"] = "edge-exist";
  MindmapEvent2["edgeAdd"] = "edge-add";
  MindmapEvent2["edgeChange"] = "edge-change";
  MindmapEvent2["edgeDelete"] = "edge-delete";
  MindmapEvent2["edgeTitleChange"] = "edge-edit-change";
  MindmapEvent2["edgeClick"] = "edge-click";
  MindmapEvent2["labelClick"] = "lable-click";
  MindmapEvent2["labelDoubleClick"] = "lable-double-click";
  MindmapEvent2["edgeCreate"] = "edge-create";
  MindmapEvent2["openQuadtree"] = "open-quadtree";
  MindmapEvent2["focus"] = "editor-focus";
  MindmapEvent2["blur"] = "editor-blur";
  return MindmapEvent2;
})(MindmapEvent || {});
const resizeObserver = {
  mounted(el, binding) {
    const debounce = (fn, delay = 0) => {
      let t = null;
      return function() {
        clearTimeout(t);
        const context = this;
        t = setTimeout(function() {
          fn.apply(context);
        }, delay);
      };
    };
    el._resizer = new window.ResizeObserver(debounce(binding.value, Number(binding.arg) || 16));
    el._resizer.observe(el);
  },
  unmounted(el) {
    el._resizer.disconnect();
  }
};
var toString = {}.toString;
var isType = function(value, type) {
  return toString.call(value) === "[object " + type + "]";
};
var isFunction = function(value) {
  return isType(value, "Function");
};
var isArray = function(value) {
  return Array.isArray ? Array.isArray(value) : isType(value, "Array");
};
var isObject = function(value) {
  var type = typeof value;
  return value !== null && type === "object" || type === "function";
};
function each(elements, func) {
  if (!elements) {
    return;
  }
  var rst;
  if (isArray(elements)) {
    for (var i = 0, len = elements.length; i < len; i++) {
      rst = func(elements[i], i);
      if (rst === false) {
        break;
      }
    }
  } else if (isObject(elements)) {
    for (var k in elements) {
      if (elements.hasOwnProperty(k)) {
        rst = func(elements[k], k);
        if (rst === false) {
          break;
        }
      }
    }
  }
}
var isObjectLike = function(value) {
  return typeof value === "object" && value !== null;
};
var isPlainObject = function(value) {
  if (!isObjectLike(value) || !isType(value, "Object")) {
    return false;
  }
  if (Object.getPrototypeOf(value) === null) {
    return true;
  }
  var proto = value;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(value) === proto;
};
var isString = function(str) {
  return isType(str, "String");
};
function wrapBehavior(obj, action) {
  if (obj["_wrap_" + action]) {
    return obj["_wrap_" + action];
  }
  var method = function(e) {
    obj[action](e);
  };
  obj["_wrap_" + action] = method;
  return method;
}
var values = Object.values ? function(obj) {
  return Object.values(obj);
} : function(obj) {
  var result = [];
  each(obj, function(value, key) {
    if (!(isFunction(obj) && key === "prototype")) {
      result.push(value);
    }
  });
  return result;
};
function _mix(dist, obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key) && key !== "constructor" && obj[key] !== void 0) {
      dist[key] = obj[key];
    }
  }
}
function mix(dist, src1, src2, src3) {
  if (src1)
    _mix(dist, src1);
  if (src2)
    _mix(dist, src2);
  if (src3)
    _mix(dist, src3);
  return dist;
}
var memoize = function(f, resolver) {
  if (!isFunction(f)) {
    throw new TypeError("Expected a function");
  }
  var memoized = function() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var key = resolver ? resolver.apply(this, args) : args[0];
    var cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = f.apply(this, args);
    cache.set(key, result);
    return result;
  };
  memoized.cache = /* @__PURE__ */ new Map();
  return memoized;
};
var MAX_MIX_LEVEL = 5;
function _deepMix(dist, src, level, maxLevel) {
  level = level || 0;
  maxLevel = maxLevel || MAX_MIX_LEVEL;
  for (var key in src) {
    if (src.hasOwnProperty(key)) {
      var value = src[key];
      if (value !== null && isPlainObject(value)) {
        if (!isPlainObject(dist[key])) {
          dist[key] = {};
        }
        if (level < maxLevel) {
          _deepMix(dist[key], value, level + 1, maxLevel);
        } else {
          dist[key] = src[key];
        }
      } else if (isArray(value)) {
        dist[key] = [];
        dist[key] = dist[key].concat(value);
      } else if (value !== void 0) {
        dist[key] = value;
      }
    }
  }
}
var deepMix = function(rst) {
  var args = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }
  for (var i = 0; i < args.length; i += 1) {
    _deepMix(rst, args[i]);
  }
  return rst;
};
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++)
    s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
      r[k] = a[j];
  return r;
}
var ctx;
var measureTextWidth = memoize(function(text, font) {
  if (font === void 0) {
    font = {};
  }
  var fontSize = font.fontSize, fontFamily = font.fontFamily, fontWeight = font.fontWeight, fontStyle = font.fontStyle, fontVariant = font.fontVariant;
  if (!ctx) {
    ctx = document.createElement("canvas").getContext("2d");
  }
  ctx.font = [fontStyle, fontVariant, fontWeight, fontSize + "px", fontFamily].join(" ");
  return ctx.measureText(isString(text) ? text : "").width;
}, function(text, font) {
  if (font === void 0) {
    font = {};
  }
  return __spreadArrays([text], values(font)).join("");
});
const distance$1 = (p1, p2) => Math.abs(p1.x - p2.x) + Math.abs(p1.y - p2.y);
const isBending = (p0, p1, p2) => !(p0.x === p1.x && p1.x === p2.x || p0.y === p1.y && p1.y === p2.y);
const getBorderRadiusPoints = (p0, p1, p2, r) => {
  const d0 = distance$1(p0, p1);
  const d1 = distance$1(p2, p1);
  if (d0 < r) {
    r = d0;
  }
  if (d1 < r) {
    r = d1;
  }
  const ps = {
    x: p1.x - r / d0 * (p1.x - p0.x),
    y: p1.y - r / d0 * (p1.y - p0.y)
  };
  const pt = {
    x: p1.x - r / d1 * (p1.x - p2.x),
    y: p1.y - r / d1 * (p1.y - p2.y)
  };
  return [ps, pt];
};
const getPathWithBorderRadiusByPolyline = (points, borderRadius) => {
  const pathSegments = [];
  const startPoint = points[0];
  pathSegments.push(`M${startPoint.x} ${startPoint.y}`);
  points.forEach((p2, i) => {
    const p1 = points[i + 1];
    const p22 = points[i + 2];
    if (p1 && p22) {
      if (isBending(p2, p1, p22) && i === 1) {
        const [ps, pt] = getBorderRadiusPoints(p2, p1, p22, borderRadius);
        pathSegments.push(`L${ps.x} ${ps.y}`);
        pathSegments.push(`Q${p1.x} ${p1.y} ${pt.x} ${pt.y}`);
        pathSegments.push(`L${pt.x} ${pt.y}`);
      } else {
        pathSegments.push(`L${p1.x} ${p1.y}`);
      }
    } else if (p1) {
      pathSegments.push(`L${p1.x} ${p1.y}`);
    }
  });
  return pathSegments.join("");
};
const ArrowType = {
  1: {
    path: Arrow.triangle(6, 8, 0),
    d: 0,
    lineWidth: 0
  },
  2: {
    path: Arrow.vee(6, 8, 0),
    d: 0,
    lineWidth: 0
  },
  3: {
    path: Arrow.circle(3, 0),
    d: 0,
    lineWidth: 0
  },
  4: {
    path: Arrow.rect(8, 8, 0),
    d: 0,
    lineWidth: 0
  },
  5: {
    path: Arrow.triangleRect(6, 8, 6, 2, 4, -4),
    d: 4,
    lineWidth: 0
  }
};
registerEdge("round-poly", {
  getShapeStyle(cfg) {
    return mix({ radius: 10, stroke: "rgb(19, 128, 255)", lineAppendWidth: 10 }, cfg.style || {});
  },
  draw(cfg, group) {
    const style = this.getShapeStyle(cfg);
    let { startPoint, endPoint, sourceNode, targetNode } = cfg;
    const sourceModel = sourceNode.getModel();
    const targetModel = targetNode.getModel();
    if (!sourceModel.style.visible || !targetModel.style.visible) {
      const shape = group.addShape("rect", {
        attrs: {
          x: 0,
          y: 0,
          width: 0,
          height: 0,
          fill: "transparent"
        }
      });
      return shape;
    }
    let startArrow = false;
    let endArrow = false;
    let delp = 0;
    if (sourceModel.edgeConfig) {
      const config = sourceModel.edgeConfig[targetModel.id];
      if (config) {
        if (config.color) {
          style.stroke = config.color;
        }
        if (config.arrowType) {
          if (!config.orientation) {
            startArrow = endArrow = __spreadValues({}, ArrowType[config.arrowType]);
          } else if (config.orientation === -1) {
            startArrow = __spreadValues({}, ArrowType[config.arrowType]);
          } else if (config.orientation === 1) {
            endArrow = __spreadValues({}, ArrowType[config.arrowType]);
          }
          if (startArrow) {
            startArrow.fill = style.stroke;
            startArrow.stroke = style.stroke;
          }
          if (endArrow) {
            endArrow.fill = style.stroke;
            endArrow.stroke = style.stroke;
          }
          if (config.arrowType === 6) {
            delp = 6;
          }
        }
      }
    }
    if (sourceModel.type === NodeType.shrinkRoot) {
      startArrow = void 0;
    }
    let start = startPoint;
    let end = endPoint;
    let isLeft = false;
    start.x += delp;
    end.x -= delp;
    if (startPoint.x < endPoint.x) {
      if (sourceNode) {
        start = sourceNode.get("anchorPointsCache")[0];
      }
      if (targetNode) {
        end = targetNode.get("anchorPointsCache")[1];
      }
    } else {
      isLeft = true;
      if (sourceNode) {
        start = sourceNode.get("anchorPointsCache")[1];
      }
      if (targetNode) {
        end = targetNode.get("anchorPointsCache")[0];
      }
    }
    let offsetX = Math.min(Math.abs(start.x - end.x) * 1 / 3, 40);
    const endOffsetX = 0;
    if (isLeft) {
      offsetX = -offsetX;
    }
    let points = [
      __spreadValues({}, start),
      {
        x: start.x + offsetX,
        y: start.y
      },
      {
        x: start.x + offsetX,
        y: end.y
      },
      {
        x: end.x + endOffsetX,
        y: end.y
      }
    ];
    let path = getPathWithBorderRadiusByPolyline(points, style.radius);
    if (sourceModel.type === NodeType.shrinkRoot) {
      startArrow = {
        path: Arrow.circle(3, 0),
        d: 0,
        fill: style.stroke
      };
    }
    return group.addShape("path", {
      attrs: __spreadProps(__spreadValues({}, style), {
        path,
        cursor: "pointer",
        startArrow,
        endArrow,
        lineDash: sourceModel.type === NodeType.shrinkRoot ? [10, 1] : void 0
      })
    });
  }
});
ref("rgb(19, 128, 255)");
ref("red");
ref("green");
ref("rgb(61, 204, 61)");
ref("rgb(245,245,245)");
ref("transparent");
ref("#ffffff");
ref("#333");
ref("#333");
ref(2);
ref("rgb(19, 128, 255)");
ref(false);
ref(false);
ref(false);
ref(false);
ref(1);
const radius = 4;
const paddingH = 10;
const addRadius = 10;
const dotRadius = 4;
const maxFontCount = 12;
ref([]);
ref(null);
ref(null);
ref("cubic-horizontal");
ref(false);
const placeholderText = "\u65B0\u5EFA\u6A21\u578B";
ref(false);
ref([]);
ref(false);
const controlMoveDirection = ref(false);
ref(false);
const dragMoveSize = { width: 40, height: 20 };
var ARRAY_TYPE = typeof Float32Array !== "undefined" ? Float32Array : Array;
if (!Math.hypot)
  Math.hypot = function() {
    var y = 0, i = arguments.length;
    while (i--) {
      y += arguments[i] * arguments[i];
    }
    return Math.sqrt(y);
  };
function multiply(out, a, b) {
  var a00 = a[0], a01 = a[1], a02 = a[2];
  var a10 = a[3], a11 = a[4], a12 = a[5];
  var a20 = a[6], a21 = a[7], a22 = a[8];
  var b00 = b[0], b01 = b[1], b02 = b[2];
  var b10 = b[3], b11 = b[4], b12 = b[5];
  var b20 = b[6], b21 = b[7], b22 = b[8];
  out[0] = b00 * a00 + b01 * a10 + b02 * a20;
  out[1] = b00 * a01 + b01 * a11 + b02 * a21;
  out[2] = b00 * a02 + b01 * a12 + b02 * a22;
  out[3] = b10 * a00 + b11 * a10 + b12 * a20;
  out[4] = b10 * a01 + b11 * a11 + b12 * a21;
  out[5] = b10 * a02 + b11 * a12 + b12 * a22;
  out[6] = b20 * a00 + b21 * a10 + b22 * a20;
  out[7] = b20 * a01 + b21 * a11 + b22 * a21;
  out[8] = b20 * a02 + b21 * a12 + b22 * a22;
  return out;
}
function fromTranslation(out, v) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 1;
  out[5] = 0;
  out[6] = v[0];
  out[7] = v[1];
  out[8] = 1;
  return out;
}
function fromRotation(out, rad) {
  var s = Math.sin(rad), c = Math.cos(rad);
  out[0] = c;
  out[1] = s;
  out[2] = 0;
  out[3] = -s;
  out[4] = c;
  out[5] = 0;
  out[6] = 0;
  out[7] = 0;
  out[8] = 1;
  return out;
}
function fromScaling(out, v) {
  out[0] = v[0];
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = v[1];
  out[5] = 0;
  out[6] = 0;
  out[7] = 0;
  out[8] = 1;
  return out;
}
function create() {
  var out = new ARRAY_TYPE(2);
  if (ARRAY_TYPE != Float32Array) {
    out[0] = 0;
    out[1] = 0;
  }
  return out;
}
function normalize$1(out, a) {
  var x = a[0], y = a[1];
  var len = x * x + y * y;
  if (len > 0) {
    len = 1 / Math.sqrt(len);
  }
  out[0] = a[0] * len;
  out[1] = a[1] * len;
  return out;
}
(function() {
  var vec = create();
  return function(a, stride, offset, count, fn, arg) {
    var i, l;
    if (!stride) {
      stride = 2;
    }
    if (!offset) {
      offset = 0;
    }
    if (count) {
      l = Math.min(count * stride + offset, a.length);
    } else {
      l = a.length;
    }
    for (i = offset; i < l; i += stride) {
      vec[0] = a[i];
      vec[1] = a[i + 1];
      fn(vec, vec, arg);
      a[i] = vec[0];
      a[i + 1] = vec[1];
    }
    return a;
  };
})();
function leftTranslate(out, a, v) {
  var transMat = [0, 0, 0, 0, 0, 0, 0, 0, 0];
  fromTranslation(transMat, v);
  return multiply(out, transMat, a);
}
function leftRotate(out, a, rad) {
  var rotateMat = [0, 0, 0, 0, 0, 0, 0, 0, 0];
  fromRotation(rotateMat, rad);
  return multiply(out, rotateMat, a);
}
function leftScale(out, a, v) {
  var scaleMat = [0, 0, 0, 0, 0, 0, 0, 0, 0];
  fromScaling(scaleMat, v);
  return multiply(out, scaleMat, a);
}
function leftMultiply(out, a, a1) {
  return multiply(out, a1, a);
}
function transform(m, actions) {
  var matrix = m ? [].concat(m) : [1, 0, 0, 0, 1, 0, 0, 0, 1];
  for (var i = 0, len = actions.length; i < len; i++) {
    var action = actions[i];
    switch (action[0]) {
      case "t":
        leftTranslate(matrix, matrix, [action[1], action[2]]);
        break;
      case "s":
        leftScale(matrix, matrix, [action[1], action[2]]);
        break;
      case "r":
        leftRotate(matrix, matrix, action[1]);
        break;
      case "m":
        leftMultiply(matrix, matrix, action[1]);
        break;
    }
  }
  return matrix;
}
const setArrowPosition = (node, x, y, angle) => {
  let matrix = [1, 0, 0, 0, 1, 0, 0, 0, 1];
  matrix = transform(matrix, [["r", angle], ["t", x, y]]);
  node.setMatrix(matrix);
};
const getDotPoints = ({ width, height, beforeWidth, afterWidth }, offset = 0) => {
  return [
    { x: -offset + beforeWidth, y: height * 0.5 },
    { x: (beforeWidth + afterWidth + width) * 0.5, y: -offset },
    { x: beforeWidth + offset + width + afterWidth, y: height * 0.5 },
    { x: (beforeWidth + afterWidth + width) * 0.5, y: offset + height }
  ];
};
const getDotPoint = ({ width, height, beforeWidth, afterWidth }, index, offset = 0) => {
  if (index === 0)
    return { x: -offset + beforeWidth, y: height * 0.5 };
  else if (index === 1)
    return { x: (beforeWidth + afterWidth + width) * 0.5, y: -offset };
  else if (index === 2)
    return { x: beforeWidth + afterWidth + offset + width, y: height * 0.5 };
  else
    return { x: (beforeWidth + afterWidth + width) * 0.5, y: offset + height };
};
const getCanvasPointByNode = (node, index) => {
  const { style: { width, height, beforeWidth, afterWidth } } = node.getModel();
  const { x, y } = node.getBBox();
  const pos = getDotPoint({ width, height, beforeWidth, afterWidth }, index);
  return { x: pos.x + x + dotRadius * 0.5, y: pos.y + y + dotRadius * 0.5 };
};
const getLinkId = (source, target) => {
  return `link-${source}-${target}`;
};
const getRotateByPoint = (p1, p2) => {
  const radian = (p2.x - p1.x > 0 ? Math.PI : 0) + Math.atan((p2.y - p1.y) / (p2.x - p1.x));
  return radian;
};
const getDragPoint = (start, end, control, percent = 0.5) => {
  const t = percent;
  const x = Math.pow(1 - t, 2) * start.x + 2 * t * (1 - t) * control.x + Math.pow(t, 2) * end.x;
  const y = Math.pow(1 - t, 2) * start.y + 2 * t * (1 - t) * control.y + Math.pow(t, 2) * end.y;
  return { x, y };
};
const getControlPoint = (start, end, point, percent) => {
  const t = percent;
  const x = (point.x - Math.pow(1 - t, 2) * start.x - Math.pow(t, 2) * end.x) / (2 * t * (1 - t));
  const y = (point.y - Math.pow(1 - t, 2) * start.y - Math.pow(t, 2) * end.y) / (2 * t * (1 - t));
  return { x, y };
};
const getBezierPath = (start, end, control) => {
  return [
    ["M", start.x, start.y],
    ["Q", control.x, control.y, end.x, end.y]
  ];
};
const getBezierParams = (start, end, control) => {
  let percent = 0, offset = 0;
  if (start.x === end.x && start.y === end.y) {
    percent = 0;
    offset = 0;
  } else if (start.x === end.x) {
    offset = start.x - control.x;
    percent = (control.y - start.y) / (end.y - start.y);
  } else if (start.y === end.y) {
    offset = control.y - start.y;
    percent = (control.x - start.x) / (end.x - start.x);
  } else {
    let dir = [0, 0];
    normalize$1(dir, [end.x - start.x, end.y - start.y]);
    const normal = {
      x: -dir[1],
      y: dir[0]
    };
    const lineFunc = (x, y) => {
      return normal.x * (x - start.x) + normal.y * (y - start.y);
    };
    const k = (end.y - start.y) / (end.x - start.x);
    let cx = (k * k * start.x + k * (control.y - start.y) + control.x) / (k * k + 1);
    offset = lineFunc(control.x, control.y);
    percent = (cx - start.x) / (end.x - start.x);
  }
  return {
    offset,
    percent
  };
};
const getControlPointByParams = (startPoint, endPoint, percent = 0, offset = 0) => {
  const point = {
    x: (1 - percent) * startPoint.x + percent * endPoint.x,
    y: (1 - percent) * startPoint.y + percent * endPoint.y
  };
  let tangent = [0, 0];
  normalize$1(tangent, [endPoint.x - startPoint.x, endPoint.y - startPoint.y]);
  if (!tangent || !tangent[0] && !tangent[1]) {
    tangent = [0, 0];
  }
  const perpendicular = [-tangent[1] * offset, tangent[0] * offset];
  point.x += perpendicular[0];
  point.y += perpendicular[1];
  return point;
};
const defaultTextStyle = {
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: 16,
  fontFamily: '"Microsoft YaHei", "PingFang SC", "Microsoft JhengHei", sans-serif',
  textBaseline: "top",
  lineHeight: 25,
  fill: "#000"
};
const EdgeTextPadding = {
  v: 8,
  h: 8
};
const IconLabelSize = {
  width: 20
};
const defaultLabelText = "\u8BF7\u8F93\u5165\u6807\u7B7E";
const distance = (p1, p2) => {
  const vx = p1.x - p2.x;
  const vy = p1.y - p2.y;
  return Math.sqrt(vx * vx + vy * vy);
};
const BROWSER_ALIASES_MAP = {
  "Amazon Silk": "amazon_silk",
  "Android Browser": "android",
  Bada: "bada",
  BlackBerry: "blackberry",
  Chrome: "chrome",
  Chromium: "chromium",
  Electron: "electron",
  Epiphany: "epiphany",
  Firefox: "firefox",
  Focus: "focus",
  Generic: "generic",
  "Google Search": "google_search",
  Googlebot: "googlebot",
  "Internet Explorer": "ie",
  "K-Meleon": "k_meleon",
  Maxthon: "maxthon",
  "Microsoft Edge": "edge",
  "MZ Browser": "mz",
  "NAVER Whale Browser": "naver",
  Opera: "opera",
  "Opera Coast": "opera_coast",
  PhantomJS: "phantomjs",
  Puffin: "puffin",
  QupZilla: "qupzilla",
  QQ: "qq",
  QQLite: "qqlite",
  Safari: "safari",
  Sailfish: "sailfish",
  "Samsung Internet for Android": "samsung_internet",
  SeaMonkey: "seamonkey",
  Sleipnir: "sleipnir",
  Swing: "swing",
  Tizen: "tizen",
  "UC Browser": "uc",
  Vivaldi: "vivaldi",
  "WebOS Browser": "webos",
  WeChat: "wechat",
  "Yandex Browser": "yandex",
  Roku: "roku"
};
const BROWSER_MAP = {
  amazon_silk: "Amazon Silk",
  android: "Android Browser",
  bada: "Bada",
  blackberry: "BlackBerry",
  chrome: "Chrome",
  chromium: "Chromium",
  electron: "Electron",
  epiphany: "Epiphany",
  firefox: "Firefox",
  focus: "Focus",
  generic: "Generic",
  googlebot: "Googlebot",
  google_search: "Google Search",
  ie: "Internet Explorer",
  k_meleon: "K-Meleon",
  maxthon: "Maxthon",
  edge: "Microsoft Edge",
  mz: "MZ Browser",
  naver: "NAVER Whale Browser",
  opera: "Opera",
  opera_coast: "Opera Coast",
  phantomjs: "PhantomJS",
  puffin: "Puffin",
  qupzilla: "QupZilla",
  qq: "QQ Browser",
  qqlite: "QQ Browser Lite",
  safari: "Safari",
  sailfish: "Sailfish",
  samsung_internet: "Samsung Internet for Android",
  seamonkey: "SeaMonkey",
  sleipnir: "Sleipnir",
  swing: "Swing",
  tizen: "Tizen",
  uc: "UC Browser",
  vivaldi: "Vivaldi",
  webos: "WebOS Browser",
  wechat: "WeChat",
  yandex: "Yandex Browser"
};
const PLATFORMS_MAP = {
  tablet: "tablet",
  mobile: "mobile",
  desktop: "desktop",
  tv: "tv"
};
const OS_MAP = {
  WindowsPhone: "Windows Phone",
  Windows: "Windows",
  MacOS: "macOS",
  iOS: "iOS",
  Android: "Android",
  WebOS: "WebOS",
  BlackBerry: "BlackBerry",
  Bada: "Bada",
  Tizen: "Tizen",
  Linux: "Linux",
  ChromeOS: "Chrome OS",
  PlayStation4: "PlayStation 4",
  Roku: "Roku"
};
const ENGINE_MAP = {
  EdgeHTML: "EdgeHTML",
  Blink: "Blink",
  Trident: "Trident",
  Presto: "Presto",
  Gecko: "Gecko",
  WebKit: "WebKit"
};
class Utils {
  static getFirstMatch(regexp, ua) {
    const match = ua.match(regexp);
    return match && match.length > 0 && match[1] || "";
  }
  static getSecondMatch(regexp, ua) {
    const match = ua.match(regexp);
    return match && match.length > 1 && match[2] || "";
  }
  static matchAndReturnConst(regexp, ua, _const) {
    if (regexp.test(ua)) {
      return _const;
    }
    return void 0;
  }
  static getWindowsVersionName(version) {
    switch (version) {
      case "NT":
        return "NT";
      case "XP":
        return "XP";
      case "NT 5.0":
        return "2000";
      case "NT 5.1":
        return "XP";
      case "NT 5.2":
        return "2003";
      case "NT 6.0":
        return "Vista";
      case "NT 6.1":
        return "7";
      case "NT 6.2":
        return "8";
      case "NT 6.3":
        return "8.1";
      case "NT 10.0":
        return "10";
      default:
        return void 0;
    }
  }
  static getMacOSVersionName(version) {
    const v = version.split(".").splice(0, 2).map((s) => parseInt(s, 10) || 0);
    v.push(0);
    if (v[0] !== 10)
      return void 0;
    switch (v[1]) {
      case 5:
        return "Leopard";
      case 6:
        return "Snow Leopard";
      case 7:
        return "Lion";
      case 8:
        return "Mountain Lion";
      case 9:
        return "Mavericks";
      case 10:
        return "Yosemite";
      case 11:
        return "El Capitan";
      case 12:
        return "Sierra";
      case 13:
        return "High Sierra";
      case 14:
        return "Mojave";
      case 15:
        return "Catalina";
      default:
        return void 0;
    }
  }
  static getAndroidVersionName(version) {
    const v = version.split(".").splice(0, 2).map((s) => parseInt(s, 10) || 0);
    v.push(0);
    if (v[0] === 1 && v[1] < 5)
      return void 0;
    if (v[0] === 1 && v[1] < 6)
      return "Cupcake";
    if (v[0] === 1 && v[1] >= 6)
      return "Donut";
    if (v[0] === 2 && v[1] < 2)
      return "Eclair";
    if (v[0] === 2 && v[1] === 2)
      return "Froyo";
    if (v[0] === 2 && v[1] > 2)
      return "Gingerbread";
    if (v[0] === 3)
      return "Honeycomb";
    if (v[0] === 4 && v[1] < 1)
      return "Ice Cream Sandwich";
    if (v[0] === 4 && v[1] < 4)
      return "Jelly Bean";
    if (v[0] === 4 && v[1] >= 4)
      return "KitKat";
    if (v[0] === 5)
      return "Lollipop";
    if (v[0] === 6)
      return "Marshmallow";
    if (v[0] === 7)
      return "Nougat";
    if (v[0] === 8)
      return "Oreo";
    if (v[0] === 9)
      return "Pie";
    return void 0;
  }
  static getVersionPrecision(version) {
    return version.split(".").length;
  }
  static compareVersions(versionA, versionB, isLoose = false) {
    const versionAPrecision = Utils.getVersionPrecision(versionA);
    const versionBPrecision = Utils.getVersionPrecision(versionB);
    let precision = Math.max(versionAPrecision, versionBPrecision);
    let lastPrecision = 0;
    const chunks = Utils.map([versionA, versionB], (version) => {
      const delta = precision - Utils.getVersionPrecision(version);
      const _version = version + new Array(delta + 1).join(".0");
      return Utils.map(_version.split("."), (chunk) => new Array(20 - chunk.length).join("0") + chunk).reverse();
    });
    if (isLoose) {
      lastPrecision = precision - Math.min(versionAPrecision, versionBPrecision);
    }
    precision -= 1;
    while (precision >= lastPrecision) {
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      }
      if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === lastPrecision) {
          return 0;
        }
        precision -= 1;
      } else if (chunks[0][precision] < chunks[1][precision]) {
        return -1;
      }
    }
    return void 0;
  }
  static map(arr, iterator) {
    const result = [];
    let i;
    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }
    for (i = 0; i < arr.length; i += 1) {
      result.push(iterator(arr[i]));
    }
    return result;
  }
  static find(arr, predicate) {
    let i;
    let l;
    if (Array.prototype.find) {
      return Array.prototype.find.call(arr, predicate);
    }
    for (i = 0, l = arr.length; i < l; i += 1) {
      const value = arr[i];
      if (predicate(value, i)) {
        return value;
      }
    }
    return void 0;
  }
  static assign(obj, ...assigners) {
    const result = obj;
    let i;
    let l;
    if (Object.assign) {
      return Object.assign(obj, ...assigners);
    }
    for (i = 0, l = assigners.length; i < l; i += 1) {
      const assigner = assigners[i];
      if (typeof assigner === "object" && assigner !== null) {
        const keys = Object.keys(assigner);
        keys.forEach((key) => {
          result[key] = assigner[key];
        });
      }
    }
    return obj;
  }
  static getBrowserAlias(browserName) {
    return BROWSER_ALIASES_MAP[browserName];
  }
  static getBrowserTypeByAlias(browserAlias) {
    return BROWSER_MAP[browserAlias] || "";
  }
}
const commonVersionIdentifier = /version\/(\d+(\.?_?\d+)+)/i;
const browsersList = [
  {
    test: [/googlebot/i],
    describe(ua) {
      const browser2 = {
        name: "Googlebot"
      };
      const version = Utils.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/opera/i],
    describe(ua) {
      const browser2 = {
        name: "Opera"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/opr\/|opios/i],
    describe(ua) {
      const browser2 = {
        name: "Opera"
      };
      const version = Utils.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/SamsungBrowser/i],
    describe(ua) {
      const browser2 = {
        name: "Samsung Internet for Android"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/Whale/i],
    describe(ua) {
      const browser2 = {
        name: "NAVER Whale Browser"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/MZBrowser/i],
    describe(ua) {
      const browser2 = {
        name: "MZ Browser"
      };
      const version = Utils.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/focus/i],
    describe(ua) {
      const browser2 = {
        name: "Focus"
      };
      const version = Utils.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/swing/i],
    describe(ua) {
      const browser2 = {
        name: "Swing"
      };
      const version = Utils.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/coast/i],
    describe(ua) {
      const browser2 = {
        name: "Opera Coast"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/opt\/\d+(?:.?_?\d+)+/i],
    describe(ua) {
      const browser2 = {
        name: "Opera Touch"
      };
      const version = Utils.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/yabrowser/i],
    describe(ua) {
      const browser2 = {
        name: "Yandex Browser"
      };
      const version = Utils.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/ucbrowser/i],
    describe(ua) {
      const browser2 = {
        name: "UC Browser"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/Maxthon|mxios/i],
    describe(ua) {
      const browser2 = {
        name: "Maxthon"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/epiphany/i],
    describe(ua) {
      const browser2 = {
        name: "Epiphany"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/puffin/i],
    describe(ua) {
      const browser2 = {
        name: "Puffin"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/sleipnir/i],
    describe(ua) {
      const browser2 = {
        name: "Sleipnir"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/k-meleon/i],
    describe(ua) {
      const browser2 = {
        name: "K-Meleon"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/micromessenger/i],
    describe(ua) {
      const browser2 = {
        name: "WeChat"
      };
      const version = Utils.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/qqbrowser/i],
    describe(ua) {
      const browser2 = {
        name: /qqbrowserlite/i.test(ua) ? "QQ Browser Lite" : "QQ Browser"
      };
      const version = Utils.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/msie|trident/i],
    describe(ua) {
      const browser2 = {
        name: "Internet Explorer"
      };
      const version = Utils.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/\sedg\//i],
    describe(ua) {
      const browser2 = {
        name: "Microsoft Edge"
      };
      const version = Utils.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/edg([ea]|ios)/i],
    describe(ua) {
      const browser2 = {
        name: "Microsoft Edge"
      };
      const version = Utils.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/vivaldi/i],
    describe(ua) {
      const browser2 = {
        name: "Vivaldi"
      };
      const version = Utils.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/seamonkey/i],
    describe(ua) {
      const browser2 = {
        name: "SeaMonkey"
      };
      const version = Utils.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/sailfish/i],
    describe(ua) {
      const browser2 = {
        name: "Sailfish"
      };
      const version = Utils.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/silk/i],
    describe(ua) {
      const browser2 = {
        name: "Amazon Silk"
      };
      const version = Utils.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/phantom/i],
    describe(ua) {
      const browser2 = {
        name: "PhantomJS"
      };
      const version = Utils.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/slimerjs/i],
    describe(ua) {
      const browser2 = {
        name: "SlimerJS"
      };
      const version = Utils.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(ua) {
      const browser2 = {
        name: "BlackBerry"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/(web|hpw)[o0]s/i],
    describe(ua) {
      const browser2 = {
        name: "WebOS Browser"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/bada/i],
    describe(ua) {
      const browser2 = {
        name: "Bada"
      };
      const version = Utils.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/tizen/i],
    describe(ua) {
      const browser2 = {
        name: "Tizen"
      };
      const version = Utils.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/qupzilla/i],
    describe(ua) {
      const browser2 = {
        name: "QupZilla"
      };
      const version = Utils.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/firefox|iceweasel|fxios/i],
    describe(ua) {
      const browser2 = {
        name: "Firefox"
      };
      const version = Utils.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/electron/i],
    describe(ua) {
      const browser2 = {
        name: "Electron"
      };
      const version = Utils.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/MiuiBrowser/i],
    describe(ua) {
      const browser2 = {
        name: "Miui"
      };
      const version = Utils.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/chromium/i],
    describe(ua) {
      const browser2 = {
        name: "Chromium"
      };
      const version = Utils.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/chrome|crios|crmo/i],
    describe(ua) {
      const browser2 = {
        name: "Chrome"
      };
      const version = Utils.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/GSA/i],
    describe(ua) {
      const browser2 = {
        name: "Google Search"
      };
      const version = Utils.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test(parser) {
      const notLikeAndroid = !parser.test(/like android/i);
      const butAndroid = parser.test(/android/i);
      return notLikeAndroid && butAndroid;
    },
    describe(ua) {
      const browser2 = {
        name: "Android Browser"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/playstation 4/i],
    describe(ua) {
      const browser2 = {
        name: "PlayStation 4"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/safari|applewebkit/i],
    describe(ua) {
      const browser2 = {
        name: "Safari"
      };
      const version = Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version) {
        browser2.version = version;
      }
      return browser2;
    }
  },
  {
    test: [/.*/i],
    describe(ua) {
      const regexpWithoutDeviceSpec = /^(.*)\/(.*) /;
      const regexpWithDeviceSpec = /^(.*)\/(.*)[ \t]\((.*)/;
      const hasDeviceSpec = ua.search("\\(") !== -1;
      const regexp = hasDeviceSpec ? regexpWithDeviceSpec : regexpWithoutDeviceSpec;
      return {
        name: Utils.getFirstMatch(regexp, ua),
        version: Utils.getSecondMatch(regexp, ua)
      };
    }
  }
];
var osParsersList = [
  {
    test: [/Roku\/DVP/],
    describe(ua) {
      const version = Utils.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, ua);
      return {
        name: OS_MAP.Roku,
        version
      };
    }
  },
  {
    test: [/windows phone/i],
    describe(ua) {
      const version = Utils.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, ua);
      return {
        name: OS_MAP.WindowsPhone,
        version
      };
    }
  },
  {
    test: [/windows /i],
    describe(ua) {
      const version = Utils.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, ua);
      const versionName = Utils.getWindowsVersionName(version);
      return {
        name: OS_MAP.Windows,
        version,
        versionName
      };
    }
  },
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe(ua) {
      const result = {
        name: OS_MAP.iOS
      };
      const version = Utils.getSecondMatch(/(Version\/)(\d[\d.]+)/, ua);
      if (version) {
        result.version = version;
      }
      return result;
    }
  },
  {
    test: [/macintosh/i],
    describe(ua) {
      const version = Utils.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, ua).replace(/[_\s]/g, ".");
      const versionName = Utils.getMacOSVersionName(version);
      const os = {
        name: OS_MAP.MacOS,
        version
      };
      if (versionName) {
        os.versionName = versionName;
      }
      return os;
    }
  },
  {
    test: [/(ipod|iphone|ipad)/i],
    describe(ua) {
      const version = Utils.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, ua).replace(/[_\s]/g, ".");
      return {
        name: OS_MAP.iOS,
        version
      };
    }
  },
  {
    test(parser) {
      const notLikeAndroid = !parser.test(/like android/i);
      const butAndroid = parser.test(/android/i);
      return notLikeAndroid && butAndroid;
    },
    describe(ua) {
      const version = Utils.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, ua);
      const versionName = Utils.getAndroidVersionName(version);
      const os = {
        name: OS_MAP.Android,
        version
      };
      if (versionName) {
        os.versionName = versionName;
      }
      return os;
    }
  },
  {
    test: [/(web|hpw)[o0]s/i],
    describe(ua) {
      const version = Utils.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, ua);
      const os = {
        name: OS_MAP.WebOS
      };
      if (version && version.length) {
        os.version = version;
      }
      return os;
    }
  },
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(ua) {
      const version = Utils.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, ua) || Utils.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, ua) || Utils.getFirstMatch(/\bbb(\d+)/i, ua);
      return {
        name: OS_MAP.BlackBerry,
        version
      };
    }
  },
  {
    test: [/bada/i],
    describe(ua) {
      const version = Utils.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, ua);
      return {
        name: OS_MAP.Bada,
        version
      };
    }
  },
  {
    test: [/tizen/i],
    describe(ua) {
      const version = Utils.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, ua);
      return {
        name: OS_MAP.Tizen,
        version
      };
    }
  },
  {
    test: [/linux/i],
    describe() {
      return {
        name: OS_MAP.Linux
      };
    }
  },
  {
    test: [/CrOS/],
    describe() {
      return {
        name: OS_MAP.ChromeOS
      };
    }
  },
  {
    test: [/PlayStation 4/],
    describe(ua) {
      const version = Utils.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, ua);
      return {
        name: OS_MAP.PlayStation4,
        version
      };
    }
  }
];
var platformParsersList = [
  {
    test: [/googlebot/i],
    describe() {
      return {
        type: "bot",
        vendor: "Google"
      };
    }
  },
  {
    test: [/huawei/i],
    describe(ua) {
      const model = Utils.getFirstMatch(/(can-l01)/i, ua) && "Nova";
      const platform = {
        type: PLATFORMS_MAP.mobile,
        vendor: "Huawei"
      };
      if (model) {
        platform.model = model;
      }
      return platform;
    }
  },
  {
    test: [/nexus\s*(?:7|8|9|10).*/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: "Nexus"
      };
    }
  },
  {
    test: [/ipad/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: "Apple",
        model: "iPad"
      };
    }
  },
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: "Apple",
        model: "iPad"
      };
    }
  },
  {
    test: [/kftt build/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: "Amazon",
        model: "Kindle Fire HD 7"
      };
    }
  },
  {
    test: [/silk/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: "Amazon"
      };
    }
  },
  {
    test: [/tablet(?! pc)/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet
      };
    }
  },
  {
    test(parser) {
      const iDevice = parser.test(/ipod|iphone/i);
      const likeIDevice = parser.test(/like (ipod|iphone)/i);
      return iDevice && !likeIDevice;
    },
    describe(ua) {
      const model = Utils.getFirstMatch(/(ipod|iphone)/i, ua);
      return {
        type: PLATFORMS_MAP.mobile,
        vendor: "Apple",
        model
      };
    }
  },
  {
    test: [/nexus\s*[0-6].*/i, /galaxy nexus/i],
    describe() {
      return {
        type: PLATFORMS_MAP.mobile,
        vendor: "Nexus"
      };
    }
  },
  {
    test: [/[^-]mobi/i],
    describe() {
      return {
        type: PLATFORMS_MAP.mobile
      };
    }
  },
  {
    test(parser) {
      return parser.getBrowserName(true) === "blackberry";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.mobile,
        vendor: "BlackBerry"
      };
    }
  },
  {
    test(parser) {
      return parser.getBrowserName(true) === "bada";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.mobile
      };
    }
  },
  {
    test(parser) {
      return parser.getBrowserName() === "windows phone";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.mobile,
        vendor: "Microsoft"
      };
    }
  },
  {
    test(parser) {
      const osMajorVersion = Number(String(parser.getOSVersion()).split(".")[0]);
      return parser.getOSName(true) === "android" && osMajorVersion >= 3;
    },
    describe() {
      return {
        type: PLATFORMS_MAP.tablet
      };
    }
  },
  {
    test(parser) {
      return parser.getOSName(true) === "android";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.mobile
      };
    }
  },
  {
    test(parser) {
      return parser.getOSName(true) === "macos";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.desktop,
        vendor: "Apple"
      };
    }
  },
  {
    test(parser) {
      return parser.getOSName(true) === "windows";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.desktop
      };
    }
  },
  {
    test(parser) {
      return parser.getOSName(true) === "linux";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.desktop
      };
    }
  },
  {
    test(parser) {
      return parser.getOSName(true) === "playstation 4";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.tv
      };
    }
  },
  {
    test(parser) {
      return parser.getOSName(true) === "roku";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.tv
      };
    }
  }
];
var enginesParsersList = [
  {
    test(parser) {
      return parser.getBrowserName(true) === "microsoft edge";
    },
    describe(ua) {
      const isBlinkBased = /\sedg\//i.test(ua);
      if (isBlinkBased) {
        return {
          name: ENGINE_MAP.Blink
        };
      }
      const version = Utils.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, ua);
      return {
        name: ENGINE_MAP.EdgeHTML,
        version
      };
    }
  },
  {
    test: [/trident/i],
    describe(ua) {
      const engine = {
        name: ENGINE_MAP.Trident
      };
      const version = Utils.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        engine.version = version;
      }
      return engine;
    }
  },
  {
    test(parser) {
      return parser.test(/presto/i);
    },
    describe(ua) {
      const engine = {
        name: ENGINE_MAP.Presto
      };
      const version = Utils.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        engine.version = version;
      }
      return engine;
    }
  },
  {
    test(parser) {
      const isGecko = parser.test(/gecko/i);
      const likeGecko = parser.test(/like gecko/i);
      return isGecko && !likeGecko;
    },
    describe(ua) {
      const engine = {
        name: ENGINE_MAP.Gecko
      };
      const version = Utils.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        engine.version = version;
      }
      return engine;
    }
  },
  {
    test: [/(apple)?webkit\/537\.36/i],
    describe() {
      return {
        name: ENGINE_MAP.Blink
      };
    }
  },
  {
    test: [/(apple)?webkit/i],
    describe(ua) {
      const engine = {
        name: ENGINE_MAP.WebKit
      };
      const version = Utils.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, ua);
      if (version) {
        engine.version = version;
      }
      return engine;
    }
  }
];
class Parser {
  constructor(UA, skipParsing = false) {
    if (UA === void 0 || UA === null || UA === "") {
      throw new Error("UserAgent parameter can't be empty");
    }
    this._ua = UA;
    this.parsedResult = {};
    if (skipParsing !== true) {
      this.parse();
    }
  }
  getUA() {
    return this._ua;
  }
  test(regex) {
    return regex.test(this._ua);
  }
  parseBrowser() {
    this.parsedResult.browser = {};
    const browserDescriptor = Utils.find(browsersList, (_browser) => {
      if (typeof _browser.test === "function") {
        return _browser.test(this);
      }
      if (_browser.test instanceof Array) {
        return _browser.test.some((condition) => this.test(condition));
      }
      throw new Error("Browser's test function is not valid");
    });
    if (browserDescriptor) {
      this.parsedResult.browser = browserDescriptor.describe(this.getUA());
    }
    return this.parsedResult.browser;
  }
  getBrowser() {
    if (this.parsedResult.browser) {
      return this.parsedResult.browser;
    }
    return this.parseBrowser();
  }
  getBrowserName(toLowerCase) {
    if (toLowerCase) {
      return String(this.getBrowser().name).toLowerCase() || "";
    }
    return this.getBrowser().name || "";
  }
  getBrowserVersion() {
    return this.getBrowser().version;
  }
  getOS() {
    if (this.parsedResult.os) {
      return this.parsedResult.os;
    }
    return this.parseOS();
  }
  parseOS() {
    this.parsedResult.os = {};
    const os = Utils.find(osParsersList, (_os) => {
      if (typeof _os.test === "function") {
        return _os.test(this);
      }
      if (_os.test instanceof Array) {
        return _os.test.some((condition) => this.test(condition));
      }
      throw new Error("Browser's test function is not valid");
    });
    if (os) {
      this.parsedResult.os = os.describe(this.getUA());
    }
    return this.parsedResult.os;
  }
  getOSName(toLowerCase) {
    const { name } = this.getOS();
    if (toLowerCase) {
      return String(name).toLowerCase() || "";
    }
    return name || "";
  }
  getOSVersion() {
    return this.getOS().version;
  }
  getPlatform() {
    if (this.parsedResult.platform) {
      return this.parsedResult.platform;
    }
    return this.parsePlatform();
  }
  getPlatformType(toLowerCase = false) {
    const { type } = this.getPlatform();
    if (toLowerCase) {
      return String(type).toLowerCase() || "";
    }
    return type || "";
  }
  parsePlatform() {
    this.parsedResult.platform = {};
    const platform = Utils.find(platformParsersList, (_platform) => {
      if (typeof _platform.test === "function") {
        return _platform.test(this);
      }
      if (_platform.test instanceof Array) {
        return _platform.test.some((condition) => this.test(condition));
      }
      throw new Error("Browser's test function is not valid");
    });
    if (platform) {
      this.parsedResult.platform = platform.describe(this.getUA());
    }
    return this.parsedResult.platform;
  }
  getEngine() {
    if (this.parsedResult.engine) {
      return this.parsedResult.engine;
    }
    return this.parseEngine();
  }
  getEngineName(toLowerCase) {
    if (toLowerCase) {
      return String(this.getEngine().name).toLowerCase() || "";
    }
    return this.getEngine().name || "";
  }
  parseEngine() {
    this.parsedResult.engine = {};
    const engine = Utils.find(enginesParsersList, (_engine) => {
      if (typeof _engine.test === "function") {
        return _engine.test(this);
      }
      if (_engine.test instanceof Array) {
        return _engine.test.some((condition) => this.test(condition));
      }
      throw new Error("Browser's test function is not valid");
    });
    if (engine) {
      this.parsedResult.engine = engine.describe(this.getUA());
    }
    return this.parsedResult.engine;
  }
  parse() {
    this.parseBrowser();
    this.parseOS();
    this.parsePlatform();
    this.parseEngine();
    return this;
  }
  getResult() {
    return Utils.assign({}, this.parsedResult);
  }
  satisfies(checkTree) {
    const platformsAndOSes = {};
    let platformsAndOSCounter = 0;
    const browsers = {};
    let browsersCounter = 0;
    const allDefinitions = Object.keys(checkTree);
    allDefinitions.forEach((key) => {
      const currentDefinition = checkTree[key];
      if (typeof currentDefinition === "string") {
        browsers[key] = currentDefinition;
        browsersCounter += 1;
      } else if (typeof currentDefinition === "object") {
        platformsAndOSes[key] = currentDefinition;
        platformsAndOSCounter += 1;
      }
    });
    if (platformsAndOSCounter > 0) {
      const platformsAndOSNames = Object.keys(platformsAndOSes);
      const OSMatchingDefinition = Utils.find(platformsAndOSNames, (name) => this.isOS(name));
      if (OSMatchingDefinition) {
        const osResult = this.satisfies(platformsAndOSes[OSMatchingDefinition]);
        if (osResult !== void 0) {
          return osResult;
        }
      }
      const platformMatchingDefinition = Utils.find(platformsAndOSNames, (name) => this.isPlatform(name));
      if (platformMatchingDefinition) {
        const platformResult = this.satisfies(platformsAndOSes[platformMatchingDefinition]);
        if (platformResult !== void 0) {
          return platformResult;
        }
      }
    }
    if (browsersCounter > 0) {
      const browserNames = Object.keys(browsers);
      const matchingDefinition = Utils.find(browserNames, (name) => this.isBrowser(name, true));
      if (matchingDefinition !== void 0) {
        return this.compareVersion(browsers[matchingDefinition]);
      }
    }
    return void 0;
  }
  isBrowser(browserName, includingAlias = false) {
    const defaultBrowserName = this.getBrowserName().toLowerCase();
    let browserNameLower = browserName.toLowerCase();
    const alias = Utils.getBrowserTypeByAlias(browserNameLower);
    if (includingAlias && alias) {
      browserNameLower = alias.toLowerCase();
    }
    return browserNameLower === defaultBrowserName;
  }
  compareVersion(version) {
    let expectedResults = [0];
    let comparableVersion = version;
    let isLoose = false;
    const currentBrowserVersion = this.getBrowserVersion();
    if (typeof currentBrowserVersion !== "string") {
      return void 0;
    }
    if (version[0] === ">" || version[0] === "<") {
      comparableVersion = version.substr(1);
      if (version[1] === "=") {
        isLoose = true;
        comparableVersion = version.substr(2);
      } else {
        expectedResults = [];
      }
      if (version[0] === ">") {
        expectedResults.push(1);
      } else {
        expectedResults.push(-1);
      }
    } else if (version[0] === "=") {
      comparableVersion = version.substr(1);
    } else if (version[0] === "~") {
      isLoose = true;
      comparableVersion = version.substr(1);
    }
    return expectedResults.indexOf(Utils.compareVersions(currentBrowserVersion, comparableVersion, isLoose)) > -1;
  }
  isOS(osName) {
    return this.getOSName(true) === String(osName).toLowerCase();
  }
  isPlatform(platformType) {
    return this.getPlatformType(true) === String(platformType).toLowerCase();
  }
  isEngine(engineName) {
    return this.getEngineName(true) === String(engineName).toLowerCase();
  }
  is(anything, includingAlias = false) {
    return this.isBrowser(anything, includingAlias) || this.isOS(anything) || this.isPlatform(anything);
  }
  some(anythings = []) {
    return anythings.some((anything) => this.is(anything));
  }
}
/*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */
class Bowser {
  static getParser(UA, skipParsing = false) {
    if (typeof UA !== "string") {
      throw new Error("UserAgent should be a string");
    }
    return new Parser(UA, skipParsing);
  }
  static parse(UA) {
    return new Parser(UA).getResult();
  }
  static get BROWSER_MAP() {
    return BROWSER_MAP;
  }
  static get ENGINE_MAP() {
    return ENGINE_MAP;
  }
  static get OS_MAP() {
    return OS_MAP;
  }
  static get PLATFORMS_MAP() {
    return PLATFORMS_MAP;
  }
}
const browser = Bowser.getParser(window.navigator.userAgent).parsedResult;
const isWin = browser.os.name === "Windows";
const isSafari = browser.browser.name === "Safari";
const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
const p = [1, 2, 0, 3];
const drawLabel$1 = ({ style, edgeLabelBgStyle, edgeLabelTextStyle }, pos, group, key) => {
  const textGroup = group.addGroup({
    name: NameString.edgeTitleGroup
  });
  const size = { width: style.width, height: style.height };
  const textStyle = __spreadProps(__spreadValues({}, edgeLabelTextStyle), {
    x: pos.x - size.width * 0.5,
    y: pos.y + (isWin ? 2 : 0),
    text: style.text
  });
  const bgStyle = __spreadProps(__spreadValues({}, edgeLabelBgStyle), {
    width: size.width + EdgeTextPadding.h * 2,
    height: size.height + EdgeTextPadding.v * 2,
    x: pos.x - size.width * 0.5 - EdgeTextPadding.h,
    y: pos.y - size.height * 0.5 - EdgeTextPadding.v,
    radius: 4
  });
  const bg = textGroup.addShape("rect", {
    name: NameString.edgeTitleBg,
    attrs: __spreadProps(__spreadValues({}, bgStyle), {
      changeKey: key
    }),
    zIndex: 1,
    draggable: true
  });
  textGroup.addShape("text", {
    name: NameString.edgeTitle,
    attrs: __spreadValues({}, textStyle),
    zIndex: 2,
    capture: false
  });
  return bg;
};
const drawArrow = (style, pos, angle, group, name) => {
  let arrow = group.addShape("path", {
    name,
    attrs: style
  });
  setArrowPosition(arrow, pos.x, pos.y, angle);
};
registerEdge("edge-quadratic", {
  draw(cfg, group) {
    let {
      startPoint,
      endPoint,
      sourceNode,
      targetNode,
      startIndex,
      endIndex,
      selected,
      dragging,
      offset,
      curve,
      title,
      labelStyle,
      labelStyle1,
      labelStyle2,
      editType,
      labelType,
      style: {
        edgeLabelBgStyle,
        edgeLabelTextStyle,
        edgePathStyle,
        edgeDotStyle,
        circleDotStyle,
        arrowStyle
      }
    } = cfg;
    let start = startPoint, end = endPoint;
    let startOffsetX = 0;
    let endOffsetX = 0;
    const curvePosition = curve || 0.5;
    if (startIndex >= 0 && sourceNode && sourceNode.get("anchorPointsCache")[p[startIndex]]) {
      start = sourceNode.get("anchorPointsCache")[p[startIndex]];
      const model = sourceNode.getModel();
      if (startIndex === 0) {
        startOffsetX = model.style.beforeWidth;
      } else if (startIndex === 2) {
        startOffsetX = -model.style.afterWidth;
      }
    }
    if (endIndex >= 0 && targetNode && targetNode.get("anchorPointsCache")[p[endIndex]]) {
      end = targetNode.get("anchorPointsCache")[p[endIndex]];
      const model = targetNode.getModel();
      if (endIndex === 0) {
        endOffsetX = model.style.beforeWidth;
      } else if (endIndex === 2) {
        endOffsetX = -model.style.afterWidth;
      }
    }
    end = { x: parseInt(end.x + endOffsetX), y: end.y };
    start = { x: parseInt(start.x + startOffsetX), y: start.y };
    cfg.start = start;
    cfg.end = end;
    let dis = distance(start, end);
    let curveOffset = offset || dis * 0.3;
    const control = getControlPointByParams({ x: start.x, y: start.y }, { x: end.x, y: end.y }, curvePosition, curveOffset);
    const shapePath = group.addShape("path", {
      attrs: __spreadValues({
        lineDash: [2, 1],
        path: getBezierPath(start, end, control),
        endArrow: labelType !== 2 || labelType === 2 && editType === 0,
        startArrow: labelType === 2 && editType === 1,
        shadowBlur: 0,
        lineAppendWidth: 6
      }, edgePathStyle),
      zIndex: 1,
      draggable: false,
      name: NameString.edgeLinkPath
    });
    const dotPos = getDragPoint(start, end, control, 0.5);
    cfg.dotPos = dotPos;
    if (selected) {
      const circleStyle = __spreadValues(__spreadProps(__spreadValues({}, dotPos), {
        cursor: "pointer"
      }), edgeDotStyle);
      group.addShape("circle", {
        name: NameString.edgeLinkDot,
        attrs: __spreadValues({}, circleStyle),
        draggable: true,
        zIndex: 2
      });
    }
    if (dragging) {
      group.addShape("circle", {
        name: NameString.linkEdgeCircle,
        attrs: __spreadValues(__spreadProps(__spreadValues({}, start), {
          cursor: "pointer"
        }), circleDotStyle),
        zIndex: 99,
        draggable: true
      });
      group.addShape("circle", {
        name: NameString.linkEdgeCircle,
        attrs: __spreadValues(__spreadProps(__spreadValues({}, end), {
          cursor: "pointer"
        }), circleDotStyle),
        zIndex: 99,
        capture: false,
        draggable: true
      });
    }
    if (labelType == 2) {
      if (labelStyle1 && labelStyle2) {
        if (editType === 0 || editType === 2 || selected) {
          let dot = editType === 0 ? dotPos : getDragPoint(start, end, control, 0.2);
          drawLabel$1({ style: labelStyle1, edgeLabelBgStyle, edgeLabelTextStyle }, dot, group, "label1");
          if (selected) {
            let aPos = getDragPoint(start, end, control, 0.11);
            let aPos1 = getDragPoint(start, end, control, 0.1);
            let angle = getRotateByPoint(aPos, aPos1);
            drawArrow(arrowStyle, aPos, angle, group, NameString.edgeArrowUp);
          }
        }
        if (editType === 1 || editType === 2 || selected) {
          let dot = editType === 1 ? dotPos : getDragPoint(start, end, control, 0.8);
          drawLabel$1({ style: labelStyle2, edgeLabelBgStyle, edgeLabelTextStyle }, dot, group, "label2");
          if (selected) {
            let bPos = getDragPoint(start, end, control, 0.91);
            let bPos1 = getDragPoint(start, end, control, 0.9);
            let angle = Math.PI + getRotateByPoint(bPos, bPos1);
            drawArrow(arrowStyle, bPos, angle, group, NameString.edgeArrowDown);
          }
        }
      }
    } else if (editType === 0 || title) {
      drawLabel$1({ style: labelStyle, edgeLabelBgStyle, edgeLabelTextStyle }, dotPos, group, "title");
    }
    return shapePath;
  },
  setState(name, state, node) {
    if (name === "hover") {
      let path = node.getContainer().findAllByName(NameString.edgeLinkPath)[0];
      path.attr({
        shadowBlur: state ? 18 : 0
      });
    }
  }
});
registerEdge("edge-default", {
  options: {
    radius: 10,
    stroke: "rgb(19, 128, 255)"
  },
  getShapeStyle(cfg) {
    return mix(this.options, cfg.style || {});
  },
  draw(cfg, group) {
    const style = this.getShapeStyle(cfg);
    let { startPoint, endPoint, sourceNode, targetNode } = cfg;
    let start = startPoint;
    let end = endPoint;
    if (sourceNode) {
      if (sourceNode.getModel().side === "left") {
        start = sourceNode.get("anchorPointsCache")[1];
      } else {
        start = sourceNode.get("anchorPointsCache")[0];
      }
    }
    if (targetNode) {
      if (sourceNode.getModel().side === "left") {
        end = targetNode.get("anchorPointsCache")[1];
      } else {
        end = targetNode.get("anchorPointsCache")[0];
      }
    }
    let offsetX = Math.min(Math.abs(start.x - end.x) * 1 / 3, 40);
    let endOffsetX = -14;
    if (sourceNode.getModel().side === "left") {
      endOffsetX = 0;
      offsetX = Math.min(Math.abs(start.x - end.x) * 1 / 3, -80);
    }
    let points = [
      __spreadValues({}, start),
      {
        x: start.x + offsetX,
        y: start.y
      },
      {
        x: start.x + offsetX,
        y: end.y
      },
      {
        x: end.x + endOffsetX,
        y: end.y
      }
    ];
    let path = getPathWithBorderRadiusByPolyline(points, 10);
    return group.addShape("path", {
      attrs: __spreadProps(__spreadValues({}, style), {
        opacity: 0.6,
        path
      })
    });
  }
});
registerEdge("edge-round-link", {
  getShapeStyle(cfg) {
    return mix({ radius: 10, stroke: "rgb(19, 128, 255)" }, cfg.style || {});
  },
  draw(cfg, group) {
    const style = this.getShapeStyle(cfg);
    let { startPoint, endPoint, sourceNode, targetNode } = cfg;
    let start = startPoint;
    let end = endPoint;
    if (sourceNode) {
      start = sourceNode.get("anchorPointsCache")[0];
    }
    if (targetNode) {
      end = targetNode.get("anchorPointsCache")[1];
    }
    const offsetX = Math.min(Math.abs(start.x - end.x) * 1 / 3, 40);
    const endOffsetX = 0;
    let points = [
      __spreadValues({}, start),
      {
        x: start.x + offsetX,
        y: start.y
      },
      {
        x: start.x + offsetX,
        y: end.y
      },
      {
        x: end.x + endOffsetX,
        y: end.y
      }
    ];
    let path = getPathWithBorderRadiusByPolyline(points, style.radius);
    return group.addShape("path", {
      attrs: __spreadProps(__spreadValues({}, style), {
        path
      })
    });
  }
});
const isAWord = (str) => /^[a-zA-Z]+$/.test(str) && new RegExp("\\b" + str + "\\b", "g").test(str);
const splitText = (str) => {
  let res = [];
  str.split(/\b/).forEach((item) => {
    if (isAWord(item)) {
      res.push(item);
    } else {
      res = res.concat(item.split(""));
    }
  });
  return res;
};
class Shape {
  constructor(group) {
    this.group = group.addGroup();
    this.zIndex = 0;
  }
  Rect(name, attrs, rest = {}) {
    return this.group.addShape("rect", __spreadValues({
      name,
      attrs,
      zIndex: this.zIndex
    }, rest));
  }
  Circle(name, attrs, rest = {}) {
    return this.group.addShape("circle", {
      name,
      attrs,
      zIndex: this.zIndex
    });
  }
  Image(name, attrs, rest = {}) {
    return this.group.addShape("image", __spreadValues({
      name,
      attrs,
      zIndex: this.zIndex
    }, rest));
  }
  addText(name, attrs, rest) {
    return this.group.addShape("text", __spreadValues({
      name,
      attrs: __spreadValues({}, attrs)
    }, rest));
  }
  Text(name, attrs, maxWidth, rest = {}) {
    const { text } = attrs;
    let renderItems = [];
    const itemAttrs = Object.assign({}, defaultTextStyle, attrs);
    const x = itemAttrs.x || 0;
    let y = 0;
    const originy = y = (itemAttrs.y || 0) + (itemAttrs.lineHeight - itemAttrs.fontSize) / 2;
    splitText(text).forEach((item, index, arr) => {
      const textWidth = measureTextWidth(renderItems.join("") + item, itemAttrs);
      const textIndent = attrs.textIndent || 0;
      let isFirstLine = y === originy;
      if (textWidth + (isFirstLine ? textIndent : 0) > maxWidth) {
        this.group.addShape("text", __spreadProps(__spreadValues({
          name,
          attrs: Object.assign({}, itemAttrs, {
            x: isFirstLine ? x + textIndent : x,
            y,
            text: renderItems.join("")
          }),
          zIndex: this.zIndex
        }, rest), {
          capture: false
        }));
        renderItems = [item];
        y += itemAttrs.lineHeight;
        isFirstLine = false;
      } else {
        renderItems.push(item);
      }
      if (index === arr.length - 1) {
        this.group.addShape("text", __spreadProps(__spreadValues({
          name,
          attrs: Object.assign({}, itemAttrs, {
            x: isFirstLine ? x + textIndent : x,
            y,
            text: renderItems.join("")
          }),
          zIndex: this.zIndex
        }, rest), {
          capture: false
        }));
      }
    });
  }
  sync(cb) {
    cb(this);
  }
  inner() {
    this.group = this.group.addGroup();
    this.zIndex++;
  }
}
const diffY = isSafari ? -3 : isWin ? 2 : 0;
const isC = false;
function getAttribute(cfg) {
  var _a;
  const {
    width,
    height,
    nameHeight,
    descFontSize,
    descHeight,
    opacity = 1,
    imageIconWidth,
    descFontWeight,
    beforeWidth,
    afterWidth
  } = getShapeStyle(cfg);
  const { nodeStyle, btnStyle, btnTextStyle, style, btnTypeStyle, nameStyle } = cfg;
  const NameStyle = __spreadValues({
    x: beforeWidth + paddingH,
    y: height * 0.5 + (isWin ? 2 : 0),
    text: nameStyle.text,
    cursor: "pointer",
    opacity
  }, btnTextStyle);
  const ContainerStyle = {
    x: 0,
    y: 0,
    width: width + beforeWidth + afterWidth,
    height,
    fill: "transparent",
    stroke: "transparent",
    lineWidth: 0,
    cursor: "pointer"
  };
  const CusorStyle = {
    x: beforeWidth + paddingH + nameStyle.lastWidth,
    y: (isWin ? 2 : 0) + nameStyle.height - nameStyle.lineHeight + nameStyle.lineHeight * 0.1,
    width: 1,
    height: nameStyle.lineHeight * 0.8,
    fill: btnTextStyle.fill
  };
  const RectStyle = __spreadProps(__spreadValues({
    x: beforeWidth,
    y: 0,
    width: (nodeStyle == null ? void 0 : nodeStyle.width) || width,
    height: (nodeStyle == null ? void 0 : nodeStyle.height) || height,
    radius,
    cursor: "pointer",
    opacity
  }, btnStyle), {
    stroke: style.headIcon ? style.headIcon.fill : "transparent"
  });
  const TextStyle = __spreadValues({
    x: beforeWidth + paddingH,
    y: diffY + (isWin ? -1 : 0),
    text: cfg == null ? void 0 : cfg.title,
    cursor: "pointer",
    opacity,
    textIndent: imageIconWidth
  }, btnTextStyle);
  const IconStyle = __spreadProps(__spreadValues({
    x: beforeWidth + paddingH,
    y: cfg.style.height * 0.5,
    opacity,
    textAlign: "center",
    textBaseline: "middle"
  }, style.headIcon || {}), {
    text: (btnTypeStyle == null ? void 0 : btnTypeStyle.show) ? (_a = style.headIcon) == null ? void 0 : _a.text : void 0
  });
  const DescWrapper = {
    x: beforeWidth,
    y: nameHeight,
    width,
    height: descHeight,
    radius: [0, 0, radius, radius],
    fill: descHeight ? "rgba(255,255,255,0.3)" : "transparent",
    cursor: "pointer",
    stroke: "transparent",
    lineWidth: 2,
    opacity
  };
  const DescText = {
    x: beforeWidth + paddingH,
    y: nameHeight,
    text: cfg == null ? void 0 : cfg.desc,
    fontSize: descFontSize,
    fontWeight: descFontWeight,
    cursor: "pointer",
    opacity
  };
  return { ContainerStyle, RectStyle, TextStyle, DescWrapper, DescText, IconStyle, NameStyle, CusorStyle };
}
const getNode = (group, name) => group.findAllByName(name)[0];
const getWrapper = (group) => getNode(group, NameString.nodeWrapper);
function handleNodeHover(state, node) {
  const model = node.getModel();
  const { btnHoverStyle, btnStyle, collapsedNumberTextStyle, btnTextStyle, collapsedNumberStyle, btnTypeStyle, style } = model;
  const group = node.getContainer();
  if (node.hasState("selected") || model.collapse) {
    return;
  }
  const wrapper = getWrapper(group);
  const title = group.findAllByName("title")[0];
  if (btnHoverStyle.stroke) {
    if (state) {
      if (btnTypeStyle && style.headIcon && btnTypeStyle.hoverStroke) {
        wrapper == null ? void 0 : wrapper.attr("stroke", btnTypeStyle.hoverStroke);
      } else if (btnHoverStyle && btnHoverStyle.stroke) {
        wrapper == null ? void 0 : wrapper.attr("stroke", btnHoverStyle.stroke);
      } else if (style.headIcon && style.headIcon.fill) {
        wrapper == null ? void 0 : wrapper.attr("stroke", style.headIcon.fill);
      } else {
        wrapper == null ? void 0 : wrapper.attr("stroke", btnStyle.stroke);
      }
    } else if (style.headIcon && style.headIcon.fill) {
      wrapper == null ? void 0 : wrapper.attr("stroke", style.headIcon.fill);
    } else {
      wrapper == null ? void 0 : wrapper.attr("stroke", btnStyle.stroke);
    }
  }
  if (btnHoverStyle.fill) {
    wrapper == null ? void 0 : wrapper.attr("fill", state && btnHoverStyle.fill ? style.headIcon && btnTypeStyle && btnTypeStyle.hoverFill ? btnTypeStyle.hoverFill : btnHoverStyle.fill : btnStyle.fill);
  }
  if (style.headIcon && btnTypeStyle && btnTypeStyle.hoverTextColor) {
    title == null ? void 0 : title.attr("fill", state ? btnTypeStyle.hoverTextColor : btnTextStyle.fill);
  } else if (btnHoverStyle && btnHoverStyle.textColor) {
    title == null ? void 0 : title.attr("fill", state ? btnHoverStyle.textColor : btnTextStyle.fill);
  } else {
    title == null ? void 0 : title.attr("fill", btnTextStyle.fill);
  }
  const collapseGroup = group.findAllByName("collapse-group")[0];
  const collapseNode = group.findAllByName(NameString.collapseCircle)[0];
  const collapseText = group.findAllByName("collapse-text")[0];
  if (state) {
    collapseGroup && collapseGroup.show();
  } else if (!model.collapsed) {
    collapseGroup && collapseGroup.hide();
    return;
  }
  if (!model.collapsed) {
    collapseText == null ? void 0 : collapseText.attr({
      y: collapseNode.attrs.y - 0.8,
      text: model.children.length == 0 || model.children[0].visible === false ? "\uEAF3" : "\uEAF5"
    });
  } else {
    collapseNode == null ? void 0 : collapseNode.attr(__spreadValues({}, collapsedNumberStyle));
    collapseText == null ? void 0 : collapseText.attr(__spreadValues({
      y: collapseNode.attrs.y,
      text: model.children.length
    }, collapsedNumberTextStyle));
  }
}
function handleNodeSelected(state, node) {
  var _a, _b;
  const model = node.getModel();
  const { btnSelectedStyle, btnTypeStyle, btnStyle, style, btnTextStyle } = model;
  const group = node.getContainer();
  const wrapper = getWrapper(group);
  const title = group.findAllByName("title")[0];
  if (style.headIcon) {
    if (state && btnTypeStyle) {
      wrapper == null ? void 0 : wrapper.attr("fill", btnTypeStyle.selectedFill ? btnTypeStyle.selectedFill : btnStyle.fill);
      wrapper == null ? void 0 : wrapper.attr("stroke", btnTypeStyle.selectStroke ? btnTypeStyle.selectStroke : ((_a = style.headIcon) == null ? void 0 : _a.fill) || btnStyle.fill);
      title == null ? void 0 : title.attr("fill", btnTypeStyle.selectTextColor ? btnTypeStyle.selectTextColor : btnTextStyle.fill);
    } else {
      wrapper == null ? void 0 : wrapper.attr("fill", btnStyle.fill);
      wrapper == null ? void 0 : wrapper.attr("stroke", ((_b = style.headIcon) == null ? void 0 : _b.fill) || btnStyle.fill);
      title == null ? void 0 : title.attr("fill", btnTextStyle == null ? void 0 : btnTextStyle.fill);
    }
  } else {
    wrapper == null ? void 0 : wrapper.attr("stroke", state ? btnSelectedStyle.stroke && btnSelectedStyle.stroke : btnStyle.stroke);
    wrapper == null ? void 0 : wrapper.attr("fill", state && btnSelectedStyle.fill ? btnSelectedStyle.fill : btnStyle.fill);
    title == null ? void 0 : title.attr("fill", state && btnSelectedStyle.textColor ? btnSelectedStyle.textColor : btnTextStyle.fill);
  }
  const collapseGroup = group.findAllByName("collapse-group")[0];
  if (!state && !model.collapsed) {
    collapseGroup.hide();
    return;
  }
  const collapseNode = group.findAllByName(NameString.collapseCircle)[0];
  const collapseText = group.findAllByName("collapse-text")[0];
  if (!model.collapsed || model.children.length === 0 || model.children[0].visible === false) {
    collapseText == null ? void 0 : collapseText.attr({
      y: collapseNode.attrs.y - 0.8,
      text: (model.children.length == 0 || model.children[0].visible === false) && !isC ? "\uEAF3" : "\uEAF3"
    });
  } else {
    collapseText == null ? void 0 : collapseText.attr({
      y: collapseNode.attrs.y,
      text: model.children.length,
      textAlign: "center",
      textBaseline: "middle"
    });
  }
  if (state) {
    collapseGroup.show();
  }
}
function drawAdd(group, pos = { x: 0, y: 0 }, index, style) {
  const bgStyle = __spreadValues({
    x: pos.x,
    y: pos.y,
    r: 0,
    cursor: "pointer"
  }, style.btnStyle);
  const textStyle = __spreadProps(__spreadValues({}, style.btnTextStyle), {
    cursor: "pointer",
    textAlign: "center",
    textBaseline: "middle"
  });
  const circle = group.addShape("circle", {
    name: NameString.linkCircle,
    attrs: bgStyle,
    model: {
      index
    },
    draggable: true
  });
  const text = group.addShape("text", {
    name: "link-add",
    attrs: __spreadValues({
      x: bgStyle.x,
      y: bgStyle.y
    }, textStyle),
    capture: false
  });
  circle.animate((ratio) => {
    return {
      r: ratio * addRadius,
      opacity: ratio
    };
  }, {
    duration: 250
  });
  text.animate((ratio) => {
    return {
      fontSize: ratio * 18,
      opacity: ratio
    };
  }, {
    duration: 250
  });
}
function drawLinkBtn(state, node) {
  var _a, _b, _c, _d, _e;
  const {
    style: {
      beforeWidth,
      afterWidth,
      height
    },
    linkReadyStyle
  } = (_a = node._cfg) == null ? void 0 : _a.model;
  const width = ((_d = (_c = (_b = node._cfg) == null ? void 0 : _b.model.style) == null ? void 0 : _c.nodeStyle) == null ? void 0 : _d.width) || ((_e = node._cfg) == null ? void 0 : _e.model.style.width);
  const group = node.getContainer();
  let wrapper = getWrapper(group);
  wrapper == null ? void 0 : wrapper.attr("stroke", state ? linkReadyStyle.stroke : "transparent");
  const collapseGroup = group.findAllByName("collapse-group")[0];
  collapseGroup.hide();
  group.addGroup({
    name: NameString.linkGroup
  });
  const points = getDotPoints({
    beforeWidth,
    afterWidth,
    width,
    height
  }, addRadius + 10);
  points.forEach((pos, idx) => {
    drawAdd(group, pos, idx, linkReadyStyle);
  });
}
function drawCollapse(group, {
  side,
  style,
  collapsed,
  children,
  collapsedSelectedStyle,
  collapsedSelectedTextStyle,
  collapsedNumberStyle,
  collapsedNumberTextStyle
}) {
  const { beforeWidth, width, height } = style;
  let p2 = beforeWidth + width + collapsedSelectedStyle.r + 5;
  if (side === "left") {
    p2 = beforeWidth > 0 ? -beforeWidth - collapsedSelectedStyle.r : -beforeWidth - collapsedSelectedStyle.r - 12;
  }
  const container = group.addGroup({
    visible: children.length > 0 && collapsed && children[0].visible !== false,
    name: "collapse-group",
    capture: true,
    zIndex: 9
  });
  let bgStyle = __spreadValues({
    x: p2,
    y: height * 0.5,
    cursor: "pointer"
  }, collapsedSelectedStyle);
  let textStyle = __spreadValues({
    text: collapsed ? children.length > 0 && children[0].visible !== false ? children.length : "+" : "-",
    textAlign: "center",
    textBaseline: "middle"
  }, collapsedSelectedTextStyle);
  if (collapsed && children.length > 0 && children[0].visible !== false) {
    bgStyle = __spreadValues(__spreadValues({}, bgStyle), collapsedNumberStyle);
    textStyle = __spreadValues(__spreadValues({
      y: bgStyle.y
    }, textStyle), collapsedNumberTextStyle);
  }
  const clickRectStyle = {
    width: collapsedSelectedStyle.r * 2 + 10,
    height: collapsedSelectedStyle.r * 2 + 5,
    x: beforeWidth + width,
    y: height * 0.5 - collapsedSelectedStyle.r - 2.5,
    cursor: "pointer",
    capture: true,
    fill: "transparent"
  };
  container.addShape("rect", {
    name: NameString.collapseClick,
    attrs: clickRectStyle
  });
  container.addShape("circle", {
    name: NameString.collapseCircle,
    attrs: bgStyle,
    capture: false
  });
  container.addShape("text", {
    name: "collapse-text",
    attrs: __spreadValues({
      x: bgStyle.x,
      y: bgStyle.y - 2
    }, textStyle),
    capture: false
  });
}
function drawReadyLink(group, cfg) {
  const container = group.addGroup({
    name: "link-dot-group",
    capture: true,
    zIndex: 9
  });
  const { style: { width, height, beforeWidth, afterWidth }, readyLink, linkDotStyle } = cfg;
  let points = getDotPoints({ width, height, beforeWidth, afterWidth });
  points.forEach((pos, index) => {
    const attrs = __spreadValues(__spreadValues({}, pos), linkDotStyle);
    if (index === readyLink) {
      attrs.r = attrs.r * 1.25;
    }
    container.addShape("circle", {
      capture: false,
      name: "link-dot",
      attrs
    });
  });
  container.toFront();
}
function getShapeStyle(cfg) {
  const { depth, style } = cfg;
  let params = {};
  if (depth === 0) {
    params = Object.assign({}, style, style.root || {});
  } else if (depth === 1) {
    params = Object.assign({}, style, style.sub || {});
  } else {
    params = Object.assign({}, style, style.leaf || {});
  }
  return params;
}
const drawLabel = ({ labelStyle, linkLabelBgStyle, linkLabelTextStyle }, pos, group, key) => {
  const textGroup = group.addGroup();
  const size = { width: labelStyle.width, height: labelStyle.height };
  const textStyle = __spreadProps(__spreadValues({}, linkLabelTextStyle), {
    x: pos.x - size.width * 0.5,
    y: pos.y,
    text: labelStyle.text
  });
  const bgStyle = __spreadProps(__spreadValues({}, linkLabelBgStyle), {
    cursor: "pointer",
    width: size.width + EdgeTextPadding.h * 2,
    height: size.height + EdgeTextPadding.v * 2,
    x: pos.x - size.width * 0.5 - EdgeTextPadding.h,
    y: pos.y - size.height * 0.5 - EdgeTextPadding.v,
    radius: 4
  });
  const bg = textGroup.addShape("rect", {
    attrs: __spreadProps(__spreadValues({}, bgStyle), {
      changeKey: key
    }),
    zIndex: 1,
    draggable: true
  });
  textGroup.addShape("text", {
    attrs: __spreadValues({}, textStyle),
    zIndex: 2,
    capture: false
  });
  return bg;
};
registerNode("mindmap-node", {
  options: {},
  shapeType: "mindmap-node",
  labelPosition: "center",
  draw(cfg, group) {
    if (!cfg.label) {
      return this.drawMindmapNode(cfg, group);
    } else {
      return this.drawLabelNode(cfg, group);
    }
  },
  drawMindmapNode(cfg, group) {
    const { readyLink, isDoubleLabel, doubleIconStyle, doubleIconBg } = cfg;
    const visible = cfg.style.visible;
    const newNode = new Shape(group);
    if (!visible) {
      const shape = newNode.Rect(NameString.nodeWrapper, {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        fill: "transparent"
      });
      return shape;
    }
    const { ContainerStyle, RectStyle, NameStyle, DescWrapper, DescText, IconStyle, CusorStyle } = getAttribute(cfg);
    const maxNodeWidth = cfg.style.maxWidth;
    const { depth } = cfg;
    const rest = { draggable: false, capture: false };
    const keyShape = newNode.Rect(NameString.nodeContainer, ContainerStyle, { draggable: depth > 0 });
    if (readyLink) {
      RectStyle.lineWidth = 1;
      RectStyle.stroke = cfg.linkReadyStyle.stroke;
    }
    newNode.Rect(NameString.nodeWrapper, RectStyle, rest);
    if (IconStyle.text) {
      newNode.group.addShape("text", { attrs: IconStyle });
    }
    newNode.addText("title", NameStyle, rest);
    if (cfg.isFocus) {
      const cusor = newNode.Rect(NameString.textCusor, CusorStyle, rest);
      cusor.animate((r) => {
        return {
          opacity: r <= 0.5 ? 1 - r * 2 : r * 2 - 1
        };
      }, {
        duration: 1200,
        repeat: true
      });
    }
    if (DescText.text) {
      newNode.inner();
      newNode.Rect("desc-wrapper", DescWrapper, rest);
      newNode.Text("desc", DescText, maxNodeWidth, rest);
    }
    drawCollapse(group, cfg);
    if (readyLink >= 0) {
      drawReadyLink(group, cfg);
    }
    if (isDoubleLabel) {
      newNode.group.addShape("rect", {
        attrs: __spreadValues({
          width: IconLabelSize.width,
          height: IconLabelSize.width,
          y: cfg.style.height * 0.5 + (isWin ? 1 : 0) - IconLabelSize.width * 0.5,
          x: RectStyle.x + RectStyle.width - IconLabelSize.width - 4
        }, doubleIconBg)
      });
      newNode.group.addShape("text", {
        attrs: __spreadValues({
          x: RectStyle.x + RectStyle.width - IconLabelSize.width + 6,
          textAlign: "center",
          textBaseline: "middle",
          y: cfg.style.height * 0.5 + (isWin ? 1 : 0)
        }, doubleIconStyle)
      });
    }
    return keyShape;
  },
  drawLabelNode(cfg, group) {
    const { readyLink, label, labelStyle, style } = cfg;
    const visible = cfg.style.visible;
    const newNode = new Shape(group);
    if (!visible) {
      const shape = newNode.Rect(NameString.nodeWrapper, {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        fill: "transparent"
      });
      return shape;
    }
    const { ContainerStyle, RectStyle, NameStyle, DescWrapper, DescText, IconStyle } = getAttribute(cfg);
    if (label) {
      const cy = style.height * 0.5;
      drawLabel(cfg, { x: labelStyle.width * 0.5 + EdgeTextPadding.h, y: cy }, newNode.group, "");
      newNode.group.addShape("path", {
        attrs: {
          path: `M ${labelStyle.width + EdgeTextPadding.h * 2},${cy} L ${labelStyle.width + 16},${cy} L ${labelStyle.width + 28},${cy} Z`,
          stroke: "rgb(19, 128, 255)",
          lineWidth: 2
        }
      });
      RectStyle.x += labelStyle.width + EdgeTextPadding.h * 2;
      NameStyle.x += labelStyle.width + EdgeTextPadding.h * 2;
      RectStyle.y = cy - RectStyle.height * 0.5;
    }
    const maxNodeWidth = cfg.style.maxWidth;
    const { depth } = cfg;
    const rest = { draggable: false, capture: false };
    const keyShape = newNode.Rect(NameString.nodeContainer, ContainerStyle, { draggable: depth > 0 });
    if (readyLink) {
      RectStyle.lineWidth = 1;
      RectStyle.stroke = cfg.linkReadyStyle.stroke;
    }
    newNode.Rect(NameString.nodeWrapper, RectStyle, rest);
    if (cfg.iconPath) {
      newNode.inner();
      newNode.Image("icon", IconStyle, rest);
    }
    newNode.addText("title", NameStyle, rest);
    if (cfg.desc) {
      newNode.inner();
      newNode.Rect("desc-wrapper", DescWrapper, rest);
      newNode.Text("desc", DescText, maxNodeWidth, rest);
    }
    drawCollapse(group, cfg);
    if (readyLink >= 0) {
      drawReadyLink(group, cfg);
    }
    return keyShape;
  },
  getAnchorPoints(cfg) {
    return [
      [1, 0.5],
      [0, 0.5],
      [0.5, 0],
      [0.5, 1]
    ];
  },
  setState(name, state, node) {
    if (name === "hover")
      handleNodeHover(state, node);
    else if (name === "selected") {
      handleNodeSelected(state, node);
    } else if (name === "link" && state) {
      drawLinkBtn(state, node);
      node.toFront();
    }
  }
});
registerNode("shrink-root", {
  draw(cfg, group) {
    group = group.addGroup();
    const { shrinkRoot, lineStyle, style, hideNum } = cfg;
    const { ContainerStyle, RectStyle, NameStyle } = getAttribute(cfg);
    const width = shrinkRoot.width * Math.sqrt(2);
    RectStyle.width -= width + shrinkRoot.virtual + 4;
    ContainerStyle.cursor = void 0;
    RectStyle.cursor = void 0;
    NameStyle.cursor = void 0;
    const rect = group.addShape("rect", {
      attrs: ContainerStyle
    });
    group.addShape("rect", {
      attrs: RectStyle,
      capture: false,
      draggable: false
    });
    group.addShape("text", {
      attrs: NameStyle,
      capture: false,
      draggable: false
    });
    const x = RectStyle.x + RectStyle.width;
    const y = ContainerStyle.height * 0.5;
    group.addShape("path", {
      attrs: __spreadProps(__spreadValues({
        path: `M ${x} ${y} L ${x + shrinkRoot.virtual + style.afterWidth} ${y}`,
        stroke: "rgb(19, 128, 255)",
        lineDash: [10, 1],
        lineAppendWidth: 10
      }, lineStyle), {
        endArrow: {
          path: Arrow.circle(3, 0),
          d: 0,
          fill: lineStyle.stroke
        }
      })
    });
    const tl = group.addShape("rect", {
      name: "box-recover",
      attrs: __spreadProps(__spreadValues({
        radius: width * 0.5
      }, shrinkRoot), {
        cursor: "pointer"
      })
    });
    tl.rotate(Math.PI / 4);
    tl.translate(x + shrinkRoot.virtual + style.afterWidth + width * 0.5 + 2, RectStyle.height * 0.5 - width * 0.5);
    group.addShape("text", {
      attrs: {
        x: x + shrinkRoot.virtual + width * 0.5 + style.afterWidth + 2,
        textAlign: "center",
        textBaseline: "middle",
        fontFamily: shrinkRoot.fontFamily || "Arial",
        stroke: shrinkRoot.fontColor,
        fontSize: 14,
        y: ContainerStyle.height * 0.5,
        text: hideNum || 0
      },
      capture: false,
      draggable: false
    });
    return rect;
  },
  getAnchorPoints(cfg) {
    return [
      [1, 0.5],
      [0, 0.5],
      [0.5, 0],
      [0.5, 1]
    ];
  }
});
registerNode("node-dot", {
  draw(cfg, group) {
    return this.drawDragRect(cfg, group);
  },
  drawDragRect(cfg, group) {
    const circle = group.addShape("circle", {
      id: cfg.id,
      name: cfg.name,
      attrs: __spreadValues({
        x: -cfg.style.r * 0.5,
        y: -cfg.style.r * 0.5,
        cursor: "pointer"
      }, cfg.style),
      capture: cfg.capture || false,
      draggable: cfg.draggable || false
    });
    return circle;
  },
  getAnchorPoints(cfg) {
    return [
      [0.5, 0.5]
    ];
  }
});
registerNode("node-move", {
  draw(cfg, group) {
    const { dragMoveSize: dragMoveSize2, radius: radius2, themeColor, opacity } = cfg.style;
    const circle = group.addShape("rect", {
      attrs: {
        width: dragMoveSize2.width,
        height: dragMoveSize2.height,
        fill: themeColor,
        radius: radius2,
        opacity
      },
      capture: false
    });
    group.addShape("circle", {
      attrs: {
        y: 10,
        x: -10,
        r: 4,
        lineWidth: 2,
        stroke: themeColor,
        opacity
      }
    });
    return circle;
  },
  getAnchorPoints(cfg) {
    return [
      [0, 0.5],
      [1, 0.5]
    ];
  }
});
G6.registerBehavior("behavior-pc", {
  _mouseBegin: void 0,
  dragStatus: "",
  upClientInfo: [],
  lastClickTime: 0,
  moveLinkBegin: void 0,
  enableDelegate: true,
  edgeDragOffset: { x: 0, y: 0 },
  isDragging: false,
  getEvents() {
    return {
      "node:click": "onClickNode",
      "node:dblclick": "editNode",
      "node:mouseover": "onMouseOverNode",
      "node:mouseleave": "onMouseLeaveNode",
      "node:dragstart": "onDragStart",
      "node:dragend": "onDragEnd",
      "node:drag": "onDrag",
      "node:contextmenu": "contextMenu",
      "mousemove": "onCanvasMove",
      "wheel": "onWheel",
      "edge:click": "onClickEdge",
      "edge:mouseenter": "onEdgeEnter",
      "edge:mouseleave": "onEdgeLeave",
      "edge:dragstart": "onEdgeDragStart",
      "edge:drag": "onEdgeDrag",
      "edge:dblclick": "onEdgeDouble",
      "edge:dragend": "onEdgeDragEnd",
      "click": "onClick",
      "canvas:click": "onClickCanvas"
    };
  },
  onEdgeDouble(evt) {
    const name = evt.target.get("name");
    if (name === NameString.edgeTitleBg) {
      this.graph.edgeEditLabel(evt.item, evt.target);
    }
  },
  onClickEdge(evt) {
    if (this.graph.tempVariable.moveLinkEdge) {
      return;
    }
    const name = evt.item.getModel().name;
    if (evt.target.get("name") === NameString.edgeTitleBg)
      ;
    if (name === NameString.edgeLink) {
      this.graph.editClickEdge(evt.item, true);
    }
  },
  onEdgeDragStart(evt) {
    this.isDragging = true;
    const name = evt.target.get("name");
    if (name === NameString.edgeTitleBg) {
      const { dotPos } = evt.item.getModel();
      let pos = this.graph.getPointByClient(evt.clientX, evt.clientY);
      this.edgeDragOffset = {
        x: pos.x - dotPos.x,
        y: pos.y - dotPos.y
      };
    } else {
      this.edgeDragOffset = {
        x: 0,
        y: 0
      };
    }
  },
  onEdgeDrag(evt) {
    const name = evt.target.get("name");
    if (name === NameString.edgeLinkDot || name === NameString.edgeTitleBg) {
      let pos = this.graph.getPointByClient(evt.clientX, evt.clientY);
      const { start, end, labelStyle, labelStyle1, labelStyle2, labelType } = evt.item.getModel();
      pos.x -= this.edgeDragOffset.x;
      pos.y -= this.edgeDragOffset.y;
      const control = getControlPoint(start, end, pos, 0.5);
      const textBg = evt.item.getContainer().findAllByName(NameString.edgeTitleBg)[0];
      if (!labelType) {
        const text = evt.item.getContainer().findAllByName(NameString.edgeTitle)[0];
        textBg.attr({
          x: pos.x - labelStyle.width * 0.5 - EdgeTextPadding.h,
          y: pos.y - labelStyle.height * 0.5 - EdgeTextPadding.v
        });
        text.attr({
          x: pos.x - labelStyle.width * 0.5,
          y: pos.y
        });
      } else if (labelType === 2) {
        const text = evt.item.getContainer().findAllByName(NameString.edgeTitle);
        const changePos = (node, text2) => {
          const changeKey = node.attr("changeKey");
          let dPos;
          let style = changeKey === "label1" ? labelStyle1 : labelStyle2;
          if (textBg.length === 1) {
            dPos = pos;
          } else {
            dPos = getDragPoint(start, end, control, changeKey === "label1" ? 0.2 : 0.8);
          }
          node.attr({
            x: dPos.x - style.width * 0.5 - EdgeTextPadding.h,
            y: dPos.y - style.height * 0.5 - EdgeTextPadding.v
          });
          text2.attr({
            x: dPos.x - style.width * 0.5,
            y: dPos.y
          });
        };
        if (textBg[0]) {
          changePos(textBg[0], text[0]);
        }
        if (textBg[1]) {
          changePos(textBg[1], text[1]);
        }
      }
      if (textBg.length > 1) {
        const edgeArrowUp = evt.item.getContainer().findAllByName(NameString.edgeArrowUp)[0];
        const edgeArrowDown = evt.item.getContainer().findAllByName(NameString.edgeArrowDown)[0];
        if (edgeArrowUp) {
          let aPos = getDragPoint(start, end, control, 0.11);
          let aPos1 = getDragPoint(start, end, control, 0.1);
          let angle = getRotateByPoint(aPos, aPos1);
          setArrowPosition(edgeArrowUp, aPos.x, aPos.y, angle);
        }
        if (edgeArrowDown) {
          let aPos = getDragPoint(start, end, control, 0.91);
          let aPos1 = getDragPoint(start, end, control, 0.9);
          let angle = Math.PI + getRotateByPoint(aPos, aPos1);
          setArrowPosition(edgeArrowDown, aPos.x, aPos.y, angle);
        }
      }
      if (name === NameString.edgeTitleBg) {
        const dot = evt.item.getContainer().findAllByName(NameString.edgeLinkDot)[0];
        if (dot) {
          dot.attr(__spreadValues({}, pos));
        }
      } else {
        evt.target.attr(__spreadValues({}, pos));
      }
      const path = evt.item.getContainer().findAllByName(NameString.edgeLinkPath)[0];
      path.attr({
        path: getBezierPath(start, end, control)
      });
    }
  },
  onEdgeDragEnd(evt) {
    this.isDragging = false;
    const name = evt.target.get("name");
    if (name === NameString.edgeLinkDot || name === NameString.edgeTitleBg) {
      const pos = this.graph.getPointByClient(evt.clientX, evt.clientY);
      pos.x -= this.edgeDragOffset.x;
      pos.y -= this.edgeDragOffset.y;
      const { start, end } = evt.item.getModel();
      const control = getControlPoint(start, end, pos, 0.5);
      let be = getBezierParams(start, end, control);
      this.graph.modifyEdgeOptions({
        target: evt.item.getTarget().get("id"),
        source: evt.item.getSource().get("id"),
        offset: be.offset,
        curve: be.percent
      });
    }
  },
  onDragStart(evt) {
    this.isDragging = true;
    if (this.moveLinkBegin) {
      return;
    }
    const name = evt.target.get("name");
    if (name === NameString.linkSelectDot || name === NameString.linkCircle) {
      this.dragEdgeDot(evt);
      return;
    }
    if (name === NameString.nodeContainer) {
      this.dragNode(evt);
    }
  },
  onDrag(evt) {
    evt.target.get("name");
    if (this.moveLinkBegin) {
      this.linkMove(evt);
      return;
    }
    if (this._mouseBegin) {
      this.dragNodeMove(evt);
      return;
    }
  },
  onDragEnd(evt) {
    this.isDragging = false;
    if (this.moveLinkBegin) {
      this.graph.deleteLinkBtn();
      this.linkMoveEnd(evt);
      return;
    }
    if (this._mouseBegin) {
      const moveNodeId = this._mouseBegin.startNode.get("id");
      this.dragChangeOpacity(evt.item, 1);
      this.dragNodeEnd();
      if (moveNodeId) {
        const node = this.graph.findById(moveNodeId);
        if (node) {
          this.graph.editSelectedNode(node, true, true);
        }
      }
      this.graph.removeItem(this._mouseBegin.mouseEdge);
      this.graph.removeItem(this._mouseBegin.mouseNode);
      this._mouseBegin = void 0;
    }
    this.tempSelectNodeId = void 0;
  },
  hideEdgeHoverStatus() {
    if (!this.hoverNodeEdge || this.hoverNodeEdge.destroyed)
      return;
    const node = this.hoverNodeEdge.get("sourceNode");
    if (node) {
      node.setState("hover", false);
      node.toBack();
    }
    this.hoverNodeEdge = null;
  },
  onCanvasMove(evt) {
    if (this.moveLinkBegin) {
      this.linkMove(evt);
      evt.propagationStopped = true;
    }
  },
  onClick(evt) {
    if (this.moveLinkBegin) {
      this.linkMoveEnd(evt);
      evt.propagationStopped = true;
      return;
    }
  },
  dragEdgeDot(evt) {
    const { item: node } = evt;
    let name = evt.target.get("name");
    if (name === NameString.linkCircle) {
      const linkModel = evt.target.get("model");
      evt.propagationStopped = true;
      this.moveLinkBegin = {
        sourceNode: node,
        startIndex: linkModel.index
      };
      this.graph.closeLinkBtn();
      this.moveLinkBegin.mouseNode = this.graph.createLinkDot(evt.x, evt.y);
      this.moveLinkBegin.mouseNode.toFront();
      let edgeOptions = {
        id: "link-mouse-edge",
        source: this.moveLinkBegin.sourceNode.getModel().id,
        target: IDString.linkMouseNode,
        endIndex: 0,
        type: NodeType.linkEdge,
        startIndex: this.moveLinkBegin.startIndex,
        dragging: true
      };
      this.graph.tempVariable.moveLinkEdge = this.graph.createMouseLinkEdge(edgeOptions);
      this.graph.tempVariable.moveLinkEdge.toFront();
    } else if (name === NameString.linkSelectDot) {
      let selectNode = this.graph._curSelectedNode;
      if (!selectNode)
        return;
      evt.propagationStopped = true;
      const model = selectNode.getModel();
      if (node.get("id") === IDString.linkTargetDot || node.get("id") === IDString.linkSourceDot) {
        const { x, y } = node.getModel();
        this.moveLinkBegin = {
          sourceNode: selectNode.getSource(),
          targetNode: selectNode.getTarget(),
          startIndex: model.startIndex,
          endIndex: model.endIndex,
          modify: true,
          dotPoint: { x, y }
        };
        this.graph.tempVariable.moveLinkEdge = this.graph._curSelectedNode;
        this.moveLinkBegin.mouseNode = node;
      }
    }
  },
  onEdgeEnter(evt) {
    const name = evt.item.getModel().name;
    if (name === NameString.edgeLink) {
      this.graph.updateEdgeState(evt.item, { hover: true });
    }
    if (this.hoverNodeEdge)
      this.hideEdgeHoverStatus();
    this.hoverNodeEdge = evt.item;
    const node = this.hoverNodeEdge.get("sourceNode");
    node.toFront();
  },
  onEdgeLeave(evt) {
    const name = evt.item.getModel().name;
    if (name === NameString.edgeLink) {
      this.graph.updateEdgeState(evt.item, { hover: false });
    }
    if (this.hoverNodeEdge && evt.item.get("id") === this.hoverNodeEdge.get("id")) {
      clearTimeout(this.hideEdgeHoverTimer);
      const sourceNode = evt.item.get("sourceNode");
      this.hideEdgeHoverTimer = setTimeout(() => {
        clearTimeout(this.hideEdgeHoverTimer);
        if (this.hoverNode && (this.hoverNode.destroyed || this.hoverNode.get("id") === sourceNode.get("id")))
          return;
        this.hideEdgeHoverStatus();
      }, 300);
    }
  },
  onWheel() {
    this.graph.editDisabled();
  },
  linkMove(evt) {
    let end = this.graph.getPointByClient(evt.clientX, evt.clientY);
    if (this.moveLinkBegin) {
      this.graph.updateItem(this.moveLinkBegin.mouseNode, {
        x: end.x,
        y: end.y
      }, false);
      const isDragTarget = this.moveLinkBegin.mouseNode.get("id") !== IDString.linkSourceDot;
      let nodes = this.graph.getNodes();
      let isSelected = false, isLinkDot = false;
      for (let i = 0; i < nodes.length; ++i) {
        let node = nodes[i];
        let model = node.get("model");
        if (model.type === NodeType.defaultNode && model.style.visible) {
          let rect = {
            x: model.x - 10,
            y: model.y - 10,
            width: model.style.width + 40,
            height: model.style.height + 40
          };
          if (end.x > rect.x && end.x < rect.x + rect.width && end.y > rect.y && end.y < rect.y + rect.height) {
            const isValid = !isDragTarget && node.get("id") !== this.moveLinkBegin.targetNode.get("id") || isDragTarget && node.get("id") !== this.moveLinkBegin.sourceNode.get("id");
            if (isValid) {
              if (this.moveLinkBegin.curSelectNode && this.moveLinkBegin.curSelectNode.get("id") !== node.get("id")) {
                this.graph.updateItem(this.moveLinkBegin.curSelectNode, {
                  readyLink: void 0
                }, false);
              }
              this.moveLinkBegin.curSelectNode = node;
              isSelected = true;
              let readyLink = -1;
              const { x, y, style: { width, height, beforeWidth, afterWidth } } = node.get("model");
              const points = getDotPoints({ width, height, beforeWidth, afterWidth });
              for (let k = 0; k < points.length; ++k) {
                let pos = points[k];
                let dis = distance(end, { x: x + pos.x, y: y + pos.y });
                if (dis < 30) {
                  isLinkDot = true;
                  const edgeModel = this.graph.tempVariable.moveLinkEdge.getModel();
                  if (isDragTarget && (edgeModel.target !== model.id || edgeModel.endIndex !== k)) {
                    this.graph.updateItem(this.graph.tempVariable.moveLinkEdge, {
                      target: model.id,
                      endIndex: k
                    }, false);
                  } else if (!isDragTarget && (edgeModel.source !== model.id || edgeModel.startIndex !== k)) {
                    this.graph.updateItem(this.graph.tempVariable.moveLinkEdge, {
                      source: model.id,
                      startIndex: k
                    }, false);
                  }
                  readyLink = k;
                  break;
                }
              }
              if (model.readyLink !== readyLink) {
                this.graph.updateItem(node, {
                  readyLink
                }, false);
              }
            }
            break;
          }
        }
      }
      if (!isLinkDot) {
        if (!isDragTarget) {
          this.graph.updateItem(this.graph.tempVariable.moveLinkEdge, {
            source: this.moveLinkBegin.mouseNode.get("id"),
            startIndex: void 0
          }, false);
        } else {
          this.graph.updateItem(this.graph.tempVariable.moveLinkEdge, {
            target: this.moveLinkBegin.mouseNode.get("id"),
            endIndex: void 0
          }, false);
        }
      }
      if (!isSelected) {
        if (this.moveLinkBegin.curSelectNode) {
          this.graph.updateItem(this.moveLinkBegin.curSelectNode, {
            readyLink: void 0
          }, false);
          this.moveLinkBegin.curSelectNode = void 0;
        }
      }
    }
  },
  linkMoveEnd() {
    if (this.moveLinkBegin.mouseNode) {
      const { moveLinkEdge } = this.graph.tempVariable;
      if (moveLinkEdge) {
        let edgeModel = moveLinkEdge.get("model");
        if (edgeModel.target === IDString.linkTargetDot) {
          this.dragLinkReset(true, true);
          return;
        } else if (edgeModel.source === IDString.linkSourceDot) {
          this.dragLinkReset(true, false);
          return;
        } else if (edgeModel.target === IDString.linkMouseNode) {
          this.dragLinkReset(false, false);
          return;
        }
        const options = {
          startIndex: edgeModel.startIndex,
          endIndex: edgeModel.endIndex,
          target: edgeModel.target,
          source: edgeModel.source
        };
        if (this.moveLinkBegin.sourceNode && this.moveLinkBegin.targetNode) {
          const old = {
            startIndex: this.moveLinkBegin.startIndex,
            endIndex: this.moveLinkBegin.endIndex,
            target: this.moveLinkBegin.targetNode.get("id"),
            source: this.moveLinkBegin.sourceNode.get("id")
          };
          if (old.startIndex === options.startIndex && old.endIndex === options.endIndex && old.target === options.target && old.source === options.source) {
            this.dragLinkReset(false, false);
            this.graph.resetEdge(__spreadValues(__spreadValues({}, edgeModel), options));
            return;
          }
          if ((old.target !== options.target || old.source !== options.source) && this.graph.exsitLink(options.source, options.target)) {
            this.dragLinkReset(false, false);
            this.graph.resetEdge(__spreadValues(__spreadValues({}, edgeModel), old));
            return;
          }
          const modify = {
            old,
            options
          };
          this.dragLinkReset(false, false);
          this.graph.modifyEdgeTargetOrSource(modify);
          return;
        } else {
          this.dragLinkReset(false, false);
          this.graph.createEdge(options);
        }
      }
    }
  },
  dragLinkReset(reset = false, isTarget = false) {
    const { moveLinkEdge } = this.graph.tempVariable;
    if (this.moveLinkBegin.curSelectNode) {
      this.graph.updateItem(this.moveLinkBegin.curSelectNode, {
        readyLink: void 0
      }, false);
    }
    if (reset) {
      if (isTarget) {
        this.graph.updateItem(moveLinkEdge, {
          target: this.moveLinkBegin.targetNode.get("id"),
          endIndex: this.moveLinkBegin.endIndex
        }, false);
      } else {
        this.graph.updateItem(moveLinkEdge, {
          source: this.moveLinkBegin.sourceNode.get("id"),
          startIndex: this.moveLinkBegin.startIndex
        }, false);
      }
      this.graph.updateItem(this.moveLinkBegin.mouseNode, __spreadValues({}, this.moveLinkBegin.dotPoint));
      this.moveLinkBegin.mouseNode.toFront();
    } else {
      const dotId = this.moveLinkBegin.mouseNode.get("id");
      this.graph.cancelSelect();
      if (dotId === IDString.linkSourceDot || dotId === IDString.linkTargetDot) {
        this.moveLinkBegin.mouseNode = void 0;
        if (!this.graph.tempVariable.moveLinkEdge.destroyed) {
          this.graph.removeItem(this.graph.tempVariable.moveLinkEdge, false);
        }
      } else {
        this.graph.removeItem(this.graph.tempVariable.moveLinkEdge, false);
        this.graph.removeItem(this.moveLinkBegin.mouseNode, false);
      }
      this.graph.tempVariable.moveLinkEdge = void 0;
      this.moveLinkBegin.mouseNode = void 0;
    }
    if (this.moveLinkBegin.sourceNode) {
      this.moveLinkBegin.sourceNode.toBack();
    }
    if (this.moveLinkBegin.targetNode) {
      this.moveLinkBegin.targetNode.toBack();
    }
    this.graph.tempVariable.moveLinkEdge = void 0;
    this.moveLinkBegin = void 0;
  },
  onClickCanvas(evt) {
    this.graph.cancelSelect();
    this.graph.closeLinkBtn();
  },
  onClickNode(evt) {
    if (this.moveLinkBegin) {
      return;
    }
    const name = evt.target.get("name");
    if (name === NameString.linkCircle) {
      evt.propagationStopped = true;
      this.dragEdgeDot(evt);
      return;
    } else if (name === NameString.collapseClick) {
      evt.propagationStopped = true;
      this.graph.editCollapse(evt.item);
      return;
    } else if (name === NameString.nodeContainer) {
      if (Date.now() - this.lastClickTime < 500)
        return;
      this.lastClickTime = Date.now();
      this.graph.editSelectedNode(evt.item, true);
    } else if (evt.item.getModel().type === NodeType.shrinkRoot) {
      if (evt.target.get("name") === "box-recover") {
        this.graph.recoverParent(evt.item);
      }
    }
  },
  contextMenu(evt) {
    evt.propagationStopped = true;
  },
  editNode(evt) {
    const model = evt.item.getModel();
    if (model.type === NodeType.shrinkRoot)
      return;
    if (model.id === "root" || !model.id)
      return;
    this.graph.editItem(evt.item);
  },
  onMouseOverNode(evt) {
    var _a, _b;
    if (this.isDragging) {
      return;
    }
    const { item: node } = evt;
    this.hoverNode = node;
    const name = evt.target.get("name");
    if (name === NameString.linkSelectDot) {
      evt.target.toFront();
      return;
    }
    if (this.graph._curSelectedNode && !this.graph._curSelectedNode.destroyed && this.graph._curSelectedNode.get("type") === "edge") {
      return;
    }
    if (this.moveLinkBegin) {
      return;
    }
    if (this.graph.tempVariable.linkNode && this.graph.tempVariable.linkNode.getModel().id === node.getModel().id) {
      return;
    }
    if (name === NameString.linkEdgeCircle) {
      return;
    }
    if (name !== NameString.nodeContainer)
      return;
    node.setState("hover", true);
    node.toFront();
    if ((_a = this.graph.tempVariable) == null ? void 0 : _a.linkNode) {
      (_b = this.graph.tempVariable) == null ? void 0 : _b.linkNode.toFront();
    }
    return true;
  },
  onMouseLeaveNode(evt) {
    if (this.isDragging) {
      return;
    }
    const { item: node } = evt;
    if (this.graph.tempVariable.linkNode && this.graph.tempVariable.linkNode.getModel().id === node.getModel().id) {
      return;
    }
    if (this.graph.tempVariable.moveLinkEdge) {
      return;
    }
    if (node.getModel().type === NodeType.defaultNode) {
      if (node.hasState("hover")) {
        node.setState("hover", false);
        this.hoverNode = null;
        if (!node.hasState("selected")) {
          node.toBack();
        }
      }
    }
  },
  dragNode(evt) {
    const { item: node } = evt;
    const model = node.get("model");
    if (model.isRoot)
      return;
    const { x, y } = this.graph.getPointByClient(evt.clientX, evt.clientY);
    this._mouseBegin = {
      clientX: evt.clientX,
      clientY: evt.clientY,
      startNode: node,
      offset: { x: (x - model.x) / model.style.width * 40 - 6, y: (y - model.y) / model.style.height * 20 }
    };
    this.dragChangeOpacity(evt.item);
    this._mouseBegin.mouseNode = this.graph.createDragNode(x - this._mouseBegin.offset.x, y - this._mouseBegin.offset.y);
    this._mouseBegin.mouseEdge = this.graph.createDragEdge({ source: this._mouseBegin.startNode.get("parent").getModel().id });
    this._mouseBegin.mouseNode.toFront();
    this._mouseBegin.mouseEdge.toFront();
  },
  dragChangeOpacity(node, opacity = 0.2) {
    if (node) {
      node.get("group").attr("opacity", opacity);
      node.get("edges").forEach((edge) => {
        edge.get("group").attr("opacity", opacity);
      });
      const children = node.get("children");
      if (children) {
        children.forEach((node2) => {
          this.dragChangeOpacity(node2, opacity);
        });
      }
    }
  },
  dragNodeMove(evt) {
    if (!this._mouseBegin) {
      return;
    }
    const { x, y } = this.graph.getPointByClient(evt.clientX, evt.clientY);
    let pos = {
      x: x - this._mouseBegin.offset.x,
      y: y - this._mouseBegin.offset.y
    };
    this.graph.updateItem(this._mouseBegin.mouseNode, pos, false);
    const edge = {
      x: evt.clientX - this._mouseBegin.offset.x - 12,
      y: evt.clientY - dragMoveSize.height * 0.5
    };
    const win = {
      width: window.document.body.clientWidth,
      height: window.document.body.clientHeight
    };
    this.checkTargetNode(pos, edge.y < 0 || edge.y > win.height || edge.x < 0 || edge.x > win.width);
  },
  checkTargetNode({ x, y }, noTarget = false) {
    if (!this._mouseBegin.startNode.get("parent"))
      return;
    const mouse = { x: x - 6, y: y + dragMoveSize.height * 0.5 };
    const offset = { left: 0, top: 0, bottom: 0, right: 18 };
    let nodes = this.graph.getNodes(), nodeParent, minVerticalDis = 99999;
    if (!noTarget) {
      for (let i = 0; i < nodes.length; ++i) {
        let node = nodes[i];
        const model = node.getModel();
        if (model.type !== "mindmap-node" || model.id === nameHideRoot) {
          continue;
        }
        if (node.get("group").attr("opacity") < 1) {
          continue;
        }
        const bbox = node.getBBox();
        const isLeft = x < bbox.x - offset.left;
        const isRight = x > bbox.x + bbox.width + offset.right;
        const isTop = y < bbox.y - offset.top;
        const isBottom = y > bbox.y + bbox.height + offset.bottom;
        if (isLeft) {
          continue;
        }
        let parent = node.get("parent");
        if (parent.getModel().id === nameHideRoot) {
          parent = void 0;
        }
        if (isRight) {
          let dis = distance(mouse, {
            x: bbox.x + bbox.width + offset.right,
            y: bbox.y + bbox.height * 0.5
          });
          if (minVerticalDis > dis) {
            minVerticalDis = dis;
            nodeParent = node;
          }
        } else if (isBottom) {
          let dis = Math.abs(y - (bbox.y + bbox.height + offset.bottom));
          if (minVerticalDis > dis) {
            minVerticalDis = dis;
            nodeParent = parent;
          }
        } else if (isTop) {
          let dis = Math.abs(bbox.y - offset.top - y);
          if (minVerticalDis > dis) {
            minVerticalDis = dis;
            nodeParent = parent;
          }
        } else {
          nodeParent = parent;
        }
      }
    }
    const source = this._mouseBegin.mouseEdge.getSource();
    if (source && (!nodeParent || nodeParent.getModel().id !== source.getModel().id)) {
      this.graph.editSelectedNode(source, false, false);
    }
    if (nodeParent) {
      this._mouseBegin.mouseEdge.show();
      this.graph.updateItem(this._mouseBegin.mouseEdge, {
        source: nodeParent.getModel().id
      }, false);
      this.graph.editSelectedNode(nodeParent, true, false);
    } else {
      this._mouseBegin.mouseEdge.hide();
    }
  },
  dragNodeEnd() {
    if (!this._mouseBegin.startNode.get("parent"))
      return;
    const source = this._mouseBegin.mouseEdge.getSource();
    const startParent = this._mouseBegin.startNode.get("parent");
    if (!source || !startParent || !this._mouseBegin.mouseEdge.get("visible"))
      return;
    const startParentModel = startParent.getModel();
    const children = source.getModel().children;
    const startModel = this._mouseBegin.startNode.getModel();
    const dragY = this._mouseBegin.mouseEdge.getTarget().getBBox().y;
    let changeIndex = -1;
    if (source.getModel().collapsed) {
      changeIndex = children.length;
    } else {
      if (children && children.length > 0) {
        for (let i = 0; i < children.length; ++i) {
          const child = children[i];
          const bbox = child;
          if (bbox.y > dragY) {
            changeIndex = i;
            break;
          }
        }
        if (changeIndex === -1) {
          changeIndex = children.length;
        }
      } else {
        changeIndex = 0;
      }
    }
    if (startParentModel.id === source.getModel().id) {
      if (changeIndex === 0) {
        if (children[changeIndex] && children[changeIndex].id === startModel.id) {
          return;
        }
      } else if (changeIndex >= children.length) {
        if (children[children.length - 1].id === startModel.id) {
          return;
        }
      } else {
        if (children[changeIndex - 1].id === startModel.id || children[changeIndex].id === startModel.id) {
          return;
        }
        let idx2 = children.findIndex((item) => item.id === startModel.id);
        if (idx2 < changeIndex) {
          changeIndex -= 1;
        }
      }
    }
    let iconType = startModel.iconType === 0 ? 99 : startModel.iconType === 0 ? 99 : startModel.iconType;
    let oldSortId = startModel.sortId;
    const updateParams = {
      articleId: startModel.id,
      title: startModel.title,
      parentId: source.getModel().id !== startModel.id && source.getModel().id !== "root" ? source.getModel().id : void 0,
      iconType,
      sort: 0
    }, updateSorts = [];
    let startData, p2, isRepaintEdge = false, idx;
    if (startParentModel.id === source.getModel().id) {
      p2 = this.graph.findDataById(source.getModel().id);
      idx = p2.children.findIndex((r) => r.id === startModel.id);
      startData = p2.children.splice(idx, 1)[0];
    } else {
      startData = this.graph.findDataById(startModel.id);
      let pdx = startParentModel.children.findIndex((r) => r.id === startModel.id);
      if (pdx !== -1) {
        for (let i = pdx + 1; i < startParentModel.children.length; ++i) {
          updateSorts.push({
            articleId: startParentModel.children[i].id,
            sort: i - 1
          });
        }
      }
      this.graph.removeChild(startModel.id);
      p2 = this.graph.findDataById(source.getModel().id);
      isRepaintEdge = true;
    }
    updateParams.sort = changeIndex >= p2.children.length ? p2.children.length : changeIndex;
    if (p2.children[0] && p2.children[0].visible === false) {
      p2.children.splice(0, 1, startData);
      updateParams.sort = 0;
    } else {
      p2.children.splice(changeIndex, 0, startData);
    }
    p2.collapsed = false;
    this.graph.data(this.graph.get("data"));
    this.graph.layout();
    if (isRepaintEdge) {
      this.graph.repaintEdge();
    }
    let ps = idx >= 0 && idx < updateParams.sort ? idx : updateParams.sort;
    for (let i = ps; i < p2.children.length; ++i) {
      if (i !== updateParams.sort) {
        updateSorts.push({
          articleId: p2.children[i].id,
          sort: i
        });
      }
    }
    updateParams.updateSorts = updateSorts;
    let newSortId = this.graph.findById(p2.id).getModel().sortId;
    const s = oldSortId.split("-");
    s.shift();
    const t = newSortId.split("-");
    t.shift();
    this.graph.emit("change", {
      type: MindmapEvent.nodeMove,
      options: {
        model: {
          oldIndexArr: s,
          newIndexArr: t,
          oldId: startModel.id,
          newId: p2.id,
          sort: updateParams.sort
        },
        updateParams,
        p: {
          nodes: startData,
          edges: this.graph.getNodeAndChildrenEdgesById(startData.id)
        }
      }
    });
  }
});
G6.registerBehavior("behavior-mobile", {
  _mouseBegin: void 0,
  dragStatus: "",
  upClientInfo: [],
  lastClickTime: 0,
  moveLinkBegin: void 0,
  enableDelegate: true,
  edgeDragOffset: { x: 0, y: 0 },
  isDragging: false,
  dragReady: void 0,
  edgeDragReady: void 0,
  getEvents() {
    return {
      "node:touchstart": "onDragStart",
      "node:touchend": "onNodeTouchEnd",
      "node:touchmove": "onDrag",
      "edge:touchend": "onClickEdge",
      "edge:touchstart": "onEdgeDragStart",
      "edge:touchmove": "onEdgeDrag",
      "canvas:touchstart": "onClickCanvas",
      "canvas:touchend": "onDragEnd",
      "canvas:touchmove": "onDrag"
    };
  },
  onEdgeDouble(evt) {
    const name = evt.target.get("name");
    if (name === NameString.edgeTitleBg) {
      this.graph.edgeEditLabel(evt.item, evt.target);
    }
  },
  cancelSelectLabel() {
    if (this.selectLabelNode && !this.selectLabelNode.destroyed) {
      this.selectLabelNode.attr({
        stroke: "transparent"
      });
      this.selectLabelNode = void 0;
    }
  },
  onClickEdge(evt) {
    var _a, _b;
    if (evt.item._cfg.currentShape === "round-poly") {
      this.graph.emit(EventName.change, {
        type: MindmapEvent.edgeClick,
        options: {
          node: evt.item
        }
      });
      return;
    }
    if (this.dragReady) {
      this.onDragEnd(evt);
      return;
    }
    if (this.isDragging) {
      this.onEdgeDragEnd(evt);
      this.edgeDragReady = void 0;
      return;
    }
    if (this.graph.tempVariable.moveLinkEdge) {
      return;
    }
    if (evt.target.get("name") === NameString.edgeTitleBg) {
      this.graph.cancelSelectNode();
      evt.target.attr(__spreadValues({}, this.graph.edgeLinkStyle.edgeLabelSelectedStyle));
      this.selectLabelNode = evt.target;
      this.graph.emit("change", {
        type: MindmapEvent.labelClick,
        options: {
          node: evt.target,
          edge: evt.item
        }
      });
      if (!this.edgeTimer) {
        this.edgeTimer = setTimeout(() => {
          this.edgeTimer = void 0;
        }, 240);
      } else {
        this.graph.emit("change", {
          type: MindmapEvent.labelDoubleClick,
          options: {
            node: evt.target
          }
        });
      }
      return;
    }
    const name = evt.item.getModel().name;
    if (name === NameString.edgeLink) {
      this.cancelSelectLabel();
      evt.item.toFront();
      this.graph.editClickEdge(evt.item, true);
      (_a = this.graph.findById(IDString.linkTargetDot)) == null ? void 0 : _a.toFront();
      (_b = this.graph.findById(IDString.linkSourceDot)) == null ? void 0 : _b.toFront();
    }
  },
  onEdgeDragReady(evt) {
    if (!this.edgeDragReady || !this.edgeDragReady.node || this.edgeDragReady.node.destroyed)
      return;
    this.isDragging = true;
    const name = this.edgeDragReady.name;
    if (name === NameString.edgeTitleBg) {
      const { dotPos } = this.edgeDragReady.node.getModel();
      let pos = this.graph.getPointByClient(evt.clientX, evt.clientY);
      this.edgeDragOffset = {
        x: pos.x - dotPos.x,
        y: pos.y - dotPos.y
      };
    } else {
      this.edgeDragOffset = {
        x: 0,
        y: 0
      };
    }
  },
  onEdgeDragStart(evt) {
    this.graph.editDisabled();
    this.edgeDragReady = {
      node: evt.item,
      name: evt.target.get("name"),
      target: evt.target
    };
  },
  onEdgeDrag(evt) {
    if (this.dragReady) {
      this.onDrag(evt);
      return;
    }
    if (!this.edgeDragReady)
      return;
    if (!this.isDragging) {
      this.onEdgeDragReady(evt);
      return;
    }
    const { name, node, target } = this.edgeDragReady;
    if (name === NameString.edgeLinkDot || name === NameString.edgeTitleBg) {
      let pos = this.graph.getPointByClient(evt.clientX, evt.clientY);
      const { start, end, labelStyle, labelStyle1, labelStyle2, labelType } = node.getModel();
      pos.x -= this.edgeDragOffset.x;
      pos.y -= this.edgeDragOffset.y;
      const control = getControlPoint(start, end, pos, 0.5);
      const textBg = node.getContainer().findAllByName(NameString.edgeTitleBg);
      if (!labelType) {
        const text = node.getContainer().findAllByName(NameString.edgeTitle)[0];
        textBg.attr({
          x: pos.x - labelStyle.width * 0.5 - EdgeTextPadding.h,
          y: pos.y - labelStyle.height * 0.5 - EdgeTextPadding.v
        });
        text.attr({
          x: pos.x - labelStyle.width * 0.5,
          y: pos.y
        });
      } else if (labelType === 2) {
        const text = node.getContainer().findAllByName(NameString.edgeTitle);
        const changePos = (node2, text2) => {
          const changeKey = node2.attr("changeKey");
          let dPos;
          let style = changeKey === "label1" ? labelStyle1 : labelStyle2;
          if (textBg.length === 1) {
            dPos = pos;
          } else {
            dPos = getDragPoint(start, end, control, changeKey === "label1" ? 0.2 : 0.8);
          }
          node2.attr({
            x: dPos.x - style.width * 0.5 - EdgeTextPadding.h,
            y: dPos.y - style.height * 0.5 - EdgeTextPadding.v
          });
          text2.attr({
            x: dPos.x - style.width * 0.5,
            y: dPos.y
          });
        };
        if (textBg[0]) {
          changePos(textBg[0], text[0]);
        }
        if (textBg[1]) {
          changePos(textBg[1], text[1]);
        }
      }
      if (textBg.length > 1) {
        const edgeArrowUp = node.getContainer().findAllByName(NameString.edgeArrowUp)[0];
        const edgeArrowDown = node.getContainer().findAllByName(NameString.edgeArrowDown)[0];
        if (edgeArrowUp) {
          let aPos = getDragPoint(start, end, control, 0.11);
          let aPos1 = getDragPoint(start, end, control, 0.1);
          let angle = getRotateByPoint(aPos, aPos1);
          setArrowPosition(edgeArrowUp, aPos.x, aPos.y, angle);
        }
        if (edgeArrowDown) {
          let aPos = getDragPoint(start, end, control, 0.91);
          let aPos1 = getDragPoint(start, end, control, 0.9);
          let angle = Math.PI + getRotateByPoint(aPos, aPos1);
          setArrowPosition(edgeArrowDown, aPos.x, aPos.y, angle);
        }
      }
      if (name === NameString.edgeTitleBg) {
        const dot = node.getContainer().findAllByName(NameString.edgeLinkDot)[0];
        if (dot) {
          dot.attr(__spreadValues({}, pos));
        }
      } else {
        target.attr(__spreadValues({}, pos));
      }
      const path = node.getContainer().findAllByName(NameString.edgeLinkPath)[0];
      path.attr({
        path: getBezierPath(start, end, control)
      });
    }
  },
  onEdgeDragEnd(evt) {
    if (!this.edgeDragReady) {
      this.isDragging = false;
      return;
    }
    const name = this.edgeDragReady.name;
    if (name === NameString.edgeLinkDot || name === NameString.edgeTitleBg) {
      const pos = this.graph.getPointByClient(evt.clientX, evt.clientY);
      pos.x -= this.edgeDragOffset.x;
      pos.y -= this.edgeDragOffset.y;
      const { start, end } = evt.item.getModel();
      const control = getControlPoint(start, end, pos, 0.5);
      let be = getBezierParams(start, end, control);
      this.graph.modifyEdgeOptions({
        target: this.edgeDragReady.node.getTarget().get("id"),
        source: this.edgeDragReady.node.getSource().get("id"),
        offset: be.offset,
        curve: be.percent
      });
    }
    this.edgeDragReady = void 0;
  },
  onNodeTouchEnd(evt) {
    this.isDragStart = false;
    this.cancelSelectLabel();
    evt.preventDefault();
    if (!this.isDragging) {
      this.dragReady = void 0;
      this.onClickNode(evt);
      if (!this.nodeTimer) {
        this.nodeTimer = setTimeout(() => {
          this.nodeTimer = void 0;
        }, 240);
      } else {
        this.editNode(evt);
      }
    } else {
      this.onDragEnd(evt);
    }
  },
  onDragReady(evt) {
    if (!this.dragReady)
      return;
    this.isDragging = true;
    if (this.moveLinkBegin) {
      return;
    }
    const name = this.dragReady.name;
    if (name === NameString.linkSelectDot || name === NameString.linkCircle) {
      this.dragEdgeDot(evt);
      return;
    }
    if (name === NameString.nodeContainer) {
      this.dragNode(evt);
    }
  },
  onDragStart(evt) {
    if (this.isDragStart)
      return;
    this.isDragStart = true;
    this.graph.editDisabled();
    evt.preventDefault();
    this.dragReady = {
      name: evt.target.get("name"),
      node: evt.item,
      target: evt.target
    };
  },
  onDrag(evt) {
    if (this.edgeDragReady) {
      this.onEdgeDrag(evt);
      return;
    }
    if (!this.dragReady)
      return;
    if (!this.isDragging) {
      this.onDragReady(evt);
      return;
    }
    if (this.moveLinkBegin) {
      this.linkMove(evt);
      return;
    }
    if (this._mouseBegin) {
      this.dragNodeMove(evt);
      return;
    }
  },
  onDragEnd(evt) {
    this.isDragStart = false;
    this.edgeDragReady = void 0;
    this.dragReady = void 0;
    if (!this.isDragging) {
      this.onClickNode(evt);
      return;
    }
    this.isDragging = false;
    if (this.moveLinkBegin) {
      if (this.moveLinkBegin.mouseNode) {
        this.moveLinkBegin.mouseNode.enableCapture(true);
        this.moveLinkBegin.mouseNode.toFront();
      }
      if (this.graph.tempVariable.moveLinkEdge) {
        this.graph.tempVariable.moveLinkEdge.enableCapture(false);
      }
      this.graph.deleteLinkBtn();
      this.linkMoveEnd(evt);
      return;
    }
    if (this._mouseBegin) {
      const moveNodeId = this._mouseBegin.startNode.get("id");
      this.dragChangeOpacity(this._mouseBegin.startNode, 1);
      this.dragNodeEnd();
      if (moveNodeId) {
        const node = this.graph.findById(moveNodeId);
        if (node) {
          this.graph.editSelectedNode(node, true, true);
        }
      }
      this.graph.removeItem(this._mouseBegin.mouseEdge);
      this.graph.removeItem(this._mouseBegin.mouseNode);
      this._mouseBegin = void 0;
    }
  },
  hideEdgeHoverStatus() {
    if (!this.hoverNodeEdge || this.hoverNodeEdge.destroyed)
      return;
    const node = this.hoverNodeEdge.get("sourceNode");
    if (node) {
      node.setState("hover", false);
      node.toBack();
    }
    this.hoverNodeEdge = null;
  },
  onCanvasMove(evt) {
    if (this.moveLinkBegin) {
      this.linkMove(evt);
    }
  },
  onClick(evt) {
    if (this.moveLinkBegin) {
      this.linkMoveEnd(evt);
      return;
    }
  },
  dragEdgeDot(evt) {
    const { node, target } = this.dragReady;
    const name = target.get("name");
    if (name === NameString.linkCircle) {
      const linkModel = target.get("model");
      this.moveLinkBegin = {
        sourceNode: node,
        startIndex: linkModel.index
      };
      this.graph.closeLinkBtn();
      this.moveLinkBegin.mouseNode = this.graph.createLinkDot(evt.x, evt.y);
      this.moveLinkBegin.mouseNode.toFront();
      this.moveLinkBegin.mouseNode.enableCapture(false);
      let edgeOptions = {
        id: "link-mouse-edge",
        source: this.moveLinkBegin.sourceNode.getModel().id,
        target: IDString.linkMouseNode,
        endIndex: 0,
        type: NodeType.linkEdge,
        startIndex: this.moveLinkBegin.startIndex,
        dragging: true
      };
      this.graph.tempVariable.moveLinkEdge = this.graph.createMouseLinkEdge(edgeOptions);
      this.graph.tempVariable.moveLinkEdge.toFront();
      this.graph.tempVariable.moveLinkEdge.enableCapture(false);
    } else if (name === NameString.linkSelectDot) {
      let selectNode = this.graph._curSelectedNode;
      if (!selectNode)
        return;
      const model = selectNode.getModel();
      if (node.get("id") === IDString.linkTargetDot || node.get("id") === IDString.linkSourceDot) {
        const { x, y } = node.getModel();
        this.moveLinkBegin = {
          sourceNode: selectNode.getSource(),
          targetNode: selectNode.getTarget(),
          startIndex: model.startIndex,
          endIndex: model.endIndex,
          modify: true,
          dotPoint: { x, y }
        };
        this.graph.tempVariable.moveLinkEdge = this.graph._curSelectedNode;
        this.moveLinkBegin.mouseNode = node;
        this.moveLinkBegin.mouseNode.enableCapture(false);
        this.graph.tempVariable.moveLinkEdge.enableCapture(false);
      }
    }
  },
  linkMove(evt) {
    let end = this.graph.getPointByClient(evt.clientX, evt.clientY);
    if (this.moveLinkBegin) {
      this.graph.updateItem(this.moveLinkBegin.mouseNode, {
        x: end.x,
        y: end.y
      }, false);
      const isDragTarget = this.moveLinkBegin.mouseNode.get("id") !== IDString.linkSourceDot;
      let nodes = this.graph.getNodes();
      let isSelected = false, isLinkDot = false;
      for (let i = 0; i < nodes.length; ++i) {
        let node = nodes[i];
        let model = node.get("model");
        if (model.type === NodeType.defaultNode && model.style.visible) {
          let rect = {
            x: model.x - 10,
            y: model.y - 10,
            width: model.style.width + 40,
            height: model.style.height + 40
          };
          if (end.x > rect.x && end.x < rect.x + rect.width && end.y > rect.y && end.y < rect.y + rect.height) {
            const isValid = !isDragTarget && node.get("id") !== this.moveLinkBegin.targetNode.get("id") || isDragTarget && node.get("id") !== this.moveLinkBegin.sourceNode.get("id");
            if (isValid) {
              if (this.moveLinkBegin.curSelectNode && this.moveLinkBegin.curSelectNode.get("id") !== node.get("id")) {
                this.graph.updateItem(this.moveLinkBegin.curSelectNode, {
                  readyLink: void 0
                }, false);
              }
              this.moveLinkBegin.curSelectNode = node;
              isSelected = true;
              let readyLink = -1;
              const { x, y, style: { width, height, beforeWidth, afterWidth } } = node.get("model");
              const points = getDotPoints({ width, height, beforeWidth, afterWidth });
              for (let k = 0; k < points.length; ++k) {
                let pos = points[k];
                let dis = distance(end, { x: x + pos.x, y: y + pos.y });
                if (dis < 30) {
                  isLinkDot = true;
                  const edgeModel = this.graph.tempVariable.moveLinkEdge.getModel();
                  if (isDragTarget && (edgeModel.target !== model.id || edgeModel.endIndex !== k)) {
                    this.graph.updateItem(this.graph.tempVariable.moveLinkEdge, {
                      target: model.id,
                      endIndex: k
                    }, false);
                  } else if (!isDragTarget && (edgeModel.source !== model.id || edgeModel.startIndex !== k)) {
                    this.graph.updateItem(this.graph.tempVariable.moveLinkEdge, {
                      source: model.id,
                      startIndex: k
                    }, false);
                  }
                  readyLink = k;
                  break;
                }
              }
              if (model.readyLink !== readyLink) {
                this.graph.updateItem(node, {
                  readyLink
                }, false);
              }
            }
            break;
          }
        }
      }
      if (!isLinkDot) {
        if (!isDragTarget) {
          this.graph.updateItem(this.graph.tempVariable.moveLinkEdge, {
            source: this.moveLinkBegin.mouseNode.get("id"),
            startIndex: void 0
          }, false);
        } else {
          this.graph.updateItem(this.graph.tempVariable.moveLinkEdge, {
            target: this.moveLinkBegin.mouseNode.get("id"),
            endIndex: void 0
          }, false);
        }
      }
      if (!isSelected) {
        if (this.moveLinkBegin.curSelectNode) {
          this.graph.updateItem(this.moveLinkBegin.curSelectNode, {
            readyLink: void 0
          }, false);
          this.moveLinkBegin.curSelectNode = void 0;
        }
      }
    }
  },
  linkMoveEnd() {
    if (this.moveLinkBegin.mouseNode) {
      const { moveLinkEdge } = this.graph.tempVariable;
      if (moveLinkEdge) {
        let edgeModel = moveLinkEdge.get("model");
        if (edgeModel.target === IDString.linkTargetDot) {
          this.dragLinkReset(true, true);
          return;
        } else if (edgeModel.source === IDString.linkSourceDot) {
          this.dragLinkReset(true, false);
          return;
        } else if (edgeModel.target === IDString.linkMouseNode) {
          this.dragLinkReset(false, false);
          return;
        }
        const options = {
          startIndex: edgeModel.startIndex,
          endIndex: edgeModel.endIndex,
          target: edgeModel.target,
          source: edgeModel.source
        };
        if (this.moveLinkBegin.sourceNode && this.moveLinkBegin.targetNode) {
          const old = {
            startIndex: this.moveLinkBegin.startIndex,
            endIndex: this.moveLinkBegin.endIndex,
            target: this.moveLinkBegin.targetNode.get("id"),
            source: this.moveLinkBegin.sourceNode.get("id")
          };
          if (old.startIndex === options.startIndex && old.endIndex === options.endIndex && old.target === options.target && old.source === options.source) {
            this.dragLinkReset(false, false);
            this.graph.resetEdge(__spreadValues(__spreadValues({}, edgeModel), options));
            return;
          }
          if ((old.target !== options.target || old.source !== options.source) && this.graph.exsitLink(options.source, options.target)) {
            this.dragLinkReset(false, false);
            this.graph.resetEdge(__spreadValues(__spreadValues({}, edgeModel), old));
            return;
          }
          const modify = {
            old,
            options
          };
          this.dragLinkReset(false, false);
          this.graph.modifyEdgeTargetOrSource(modify);
          return;
        } else {
          this.dragLinkReset(false, false);
          this.graph.createEdge(options);
        }
      }
    }
  },
  dragLinkReset(reset = false, isTarget = false) {
    var _a, _b, _c, _d, _e;
    const { moveLinkEdge } = this.graph.tempVariable;
    if (this.moveLinkBegin.curSelectNode) {
      this.graph.updateItem(this.moveLinkBegin.curSelectNode, {
        readyLink: void 0
      }, false);
    }
    if (reset) {
      if (isTarget) {
        this.graph.updateItem(moveLinkEdge, {
          target: this.moveLinkBegin.targetNode.get("id"),
          endIndex: this.moveLinkBegin.endIndex
        }, false);
      } else {
        this.graph.updateItem(moveLinkEdge, {
          source: this.moveLinkBegin.sourceNode.get("id"),
          startIndex: this.moveLinkBegin.startIndex
        }, false);
      }
      this.graph.updateItem(this.moveLinkBegin.mouseNode, __spreadValues({}, this.moveLinkBegin.dotPoint));
      this.moveLinkBegin.mouseNode.toFront();
    } else {
      const dotId = this.moveLinkBegin.mouseNode.get("id");
      this.graph.cancelSelect();
      if (dotId === IDString.linkSourceDot || dotId === IDString.linkTargetDot) {
        if (this.moveLinkBegin.mouseNode && !((_a = this.moveLinkBegin.mouseNode) == null ? void 0 : _a.destroyed)) {
          this.moveLinkBegin.mouseNode.enableCapture(true);
        }
        this.moveLinkBegin.mouseNode = void 0;
        if (this.graph.tempVariable.moveLinkEdge && !((_b = this.graph.tempVariable.moveLinkEdge) == null ? void 0 : _b.destroyed)) {
          this.graph.removeItem(this.graph.tempVariable.moveLinkEdge, false);
        }
      } else {
        this.graph.removeItem(this.graph.tempVariable.moveLinkEdge, false);
        this.graph.removeItem(this.moveLinkBegin.mouseNode, false);
      }
      if (this.graph.tempVariable.moveLinkEdge && !((_c = this.graph.tempVariable.moveLinkEdge) == null ? void 0 : _c.destroyed)) {
        this.graph.tempVariable.moveLinkEdge.enableCapture(true);
      }
      this.graph.tempVariable.moveLinkEdge = void 0;
      if (this.moveLinkBegin.mouseNode && !((_d = this.moveLinkBegin.mouseNode) == null ? void 0 : _d.destroyed)) {
        this.moveLinkBegin.mouseNode.enableCapture(true);
      }
      this.moveLinkBegin.mouseNode = void 0;
    }
    if (this.moveLinkBegin.sourceNode) {
      this.moveLinkBegin.sourceNode.toBack();
    }
    if (this.moveLinkBegin.targetNode) {
      this.moveLinkBegin.targetNode.toBack();
    }
    if (this.graph.tempVariable.moveLinkEdge && !((_e = this.graph.tempVariable.moveLinkEdge) == null ? void 0 : _e.destroyed)) {
      this.graph.tempVariable.moveLinkEdge.enableCapture(true);
    }
    this.graph.tempVariable.moveLinkEdge = void 0;
    this.moveLinkBegin = void 0;
  },
  onClickCanvas(evt) {
    this.graph.editDisabled();
    this.cancelSelectLabel();
    this.graph.cancelSelect();
    this.graph.closeLinkBtn();
    this.graph.emit("change", {
      type: MindmapEvent.canvasClick
    });
  },
  onClickNode(evt) {
    if (this.moveLinkBegin) {
      return;
    }
    const name = evt.target.get("name");
    if (name === NameString.linkCircle) {
      this.dragEdgeDot(evt);
      return;
    } else if (name === NameString.collapseClick) {
      this.graph.editCollapse(evt.item);
      return;
    } else if (name === NameString.nodeContainer) {
      if (Date.now() - this.lastClickTime < 500)
        return;
      this.lastClickTime = Date.now();
      this.graph.editSelectedNode(evt.item, true);
    } else if (evt.item && evt.item.getModel().type === NodeType.shrinkRoot) {
      if (evt.target.get("name") === "box-recover") {
        this.graph.recoverParent(evt.item);
      }
    }
  },
  editNode(evt) {
    this.graph.editDisabled();
    const model = evt.item.getModel();
    if (model.type === NodeType.shrinkRoot)
      return;
    if (model.id === "root" || !model.id)
      return;
    this.graph.editItem(evt.item);
  },
  dragNode(evt) {
    const { node } = this.dragReady;
    const model = node.get("model");
    if (model.isRoot)
      return;
    const { x, y } = this.graph.getPointByClient(evt.clientX, evt.clientY);
    this._mouseBegin = {
      clientX: evt.clientX,
      clientY: evt.clientY,
      startNode: node,
      offset: { x: (x - model.x) / model.style.width * 40 - 6, y: (y - model.y) / model.style.height * 20 }
    };
    this.dragChangeOpacity(node);
    this._mouseBegin.mouseNode = this.graph.createDragNode(x - this._mouseBegin.offset.x, y - this._mouseBegin.offset.y);
    this._mouseBegin.mouseEdge = this.graph.createDragEdge({ source: this._mouseBegin.startNode.get("parent").getModel().id });
    this._mouseBegin.mouseNode.toFront();
    this._mouseBegin.mouseEdge.toFront();
  },
  dragChangeOpacity(node, opacity = 0.2) {
    if (node) {
      node.get("group").attr("opacity", opacity);
      node.get("edges").forEach((edge) => {
        edge.get("group").attr("opacity", opacity);
      });
      const children = node.get("children");
      if (children) {
        children.forEach((node2) => {
          this.dragChangeOpacity(node2, opacity);
        });
      }
    }
  },
  dragNodeMove(evt) {
    if (!this._mouseBegin) {
      return;
    }
    const { x, y } = this.graph.getPointByClient(evt.clientX, evt.clientY);
    let pos = {
      x: x - this._mouseBegin.offset.x,
      y: y - this._mouseBegin.offset.y
    };
    this.graph.updateItem(this._mouseBegin.mouseNode, pos, false);
    const edge = {
      x: evt.clientX - this._mouseBegin.offset.x - 12,
      y: evt.clientY - dragMoveSize.height * 0.5
    };
    const win = {
      width: window.document.body.clientWidth,
      height: window.document.body.clientHeight
    };
    this.checkTargetNode(pos, edge.y < 0 || edge.y > win.height || edge.x < 0 || edge.x > win.width);
  },
  checkTargetNode({ x, y }, noTarget = false) {
    if (!this._mouseBegin.startNode.get("parent"))
      return;
    const mouse = { x: x - 6, y: y + dragMoveSize.height * 0.5 };
    const offset = { left: 0, top: 0, bottom: 0, right: 18 };
    let nodes = this.graph.getNodes(), nodeParent, minVerticalDis = 99999;
    if (!noTarget) {
      for (let i = 0; i < nodes.length; ++i) {
        let node = nodes[i];
        const model = node.getModel();
        if (model.type !== "mindmap-node" || model.isRoot) {
          continue;
        }
        if (node.get("group").attr("opacity") < 1) {
          continue;
        }
        const bbox = node.getBBox();
        const isLeft = x < bbox.x - offset.left;
        const isRight = x > bbox.x + bbox.width + offset.right;
        const isTop = y < bbox.y - offset.top;
        const isBottom = y > bbox.y + bbox.height + offset.bottom;
        if (isLeft) {
          continue;
        }
        let parent = node.get("parent");
        if (parent.getModel().id === nameHideRoot) {
          parent = void 0;
        }
        if (isRight) {
          let dis = distance(mouse, {
            x: bbox.x + bbox.width + offset.right,
            y: bbox.y + bbox.height * 0.5
          });
          if (minVerticalDis > dis) {
            minVerticalDis = dis;
            nodeParent = node;
          }
        } else if (isBottom) {
          let dis = Math.abs(y - (bbox.y + bbox.height + offset.bottom));
          if (minVerticalDis > dis) {
            minVerticalDis = dis;
            nodeParent = parent;
          }
        } else if (isTop) {
          let dis = Math.abs(bbox.y - offset.top - y);
          if (minVerticalDis > dis) {
            minVerticalDis = dis;
            nodeParent = parent;
          }
        } else {
          nodeParent = parent;
        }
      }
    }
    const source = this._mouseBegin.mouseEdge.getSource();
    if (source && (!nodeParent || nodeParent.getModel().id !== source.getModel().id)) {
      this.graph.editSelectedNode(source, false, false);
    }
    if (nodeParent) {
      this._mouseBegin.mouseEdge.show();
      this.graph.updateItem(this._mouseBegin.mouseEdge, {
        source: nodeParent.getModel().id
      }, false);
      this.graph.editSelectedNode(nodeParent, true, false);
    } else {
      this._mouseBegin.mouseEdge.hide();
    }
  },
  dragNodeEnd() {
    if (!this._mouseBegin.startNode.get("parent"))
      return;
    const source = this._mouseBegin.mouseEdge.getSource();
    const startParent = this._mouseBegin.startNode.get("parent");
    if (!source || !startParent || !this._mouseBegin.mouseEdge.get("visible"))
      return;
    const startParentModel = startParent.getModel();
    const children = source.getModel().children;
    const startModel = this._mouseBegin.startNode.getModel();
    const dragY = this._mouseBegin.mouseEdge.getTarget().getBBox().y;
    let changeIndex = -1;
    if (source.getModel().collapsed) {
      changeIndex = children.length;
    } else {
      if (children && children.length > 0) {
        for (let i = 0; i < children.length; ++i) {
          const child = children[i];
          const bbox = child;
          if (bbox.y === void 0) {
            changeIndex = -1;
            break;
          }
          if (bbox.y > dragY) {
            changeIndex = i;
            break;
          }
        }
        if (changeIndex === -1) {
          changeIndex = children.length;
        }
      } else {
        changeIndex = 0;
      }
    }
    if (startParentModel.id === source.getModel().id) {
      if (changeIndex === 0) {
        if (children[changeIndex] && children[changeIndex].id === startModel.id) {
          return;
        }
      } else if (changeIndex >= children.length) {
        if (children[children.length - 1].id === startModel.id) {
          return;
        }
      } else {
        if (children[changeIndex - 1].id === startModel.id || children[changeIndex].id === startModel.id) {
          return;
        }
        let idx2 = children.findIndex((item) => item.id === startModel.id);
        if (idx2 < changeIndex) {
          changeIndex -= 1;
        }
      }
    }
    let iconType = startModel.iconType === 0 ? 99 : startModel.iconType === 0 ? 99 : startModel.iconType;
    let oldSortId = startModel.sortId;
    const updateParams = {
      articleId: startModel.id,
      title: startModel.title,
      parentId: source.getModel().id !== startModel.id && source.getModel().id !== "root" ? source.getModel().id : void 0,
      iconType,
      sort: 0
    }, updateSorts = [];
    let startData, p2, isRepaintEdge = false, idx;
    if (startParentModel.id === source.getModel().id) {
      p2 = this.graph.findDataById(source.getModel().id);
      idx = p2.children.findIndex((r) => r.id === startModel.id);
      startData = p2.children.splice(idx, 1)[0];
    } else {
      startData = this.graph.findDataById(startModel.id);
      let pdx = startParentModel.children.findIndex((r) => r.id === startModel.id);
      if (pdx !== -1) {
        for (let i = pdx + 1; i < startParentModel.children.length; ++i) {
          updateSorts.push({
            articleId: startParentModel.children[i].id,
            sort: i - 1
          });
        }
      }
      this.graph.removeChild(startModel.id);
      p2 = this.graph.findDataById(source.getModel().id);
      isRepaintEdge = true;
    }
    updateParams.sort = changeIndex >= p2.children.length ? p2.children.length : changeIndex;
    p2.children.splice(changeIndex, 0, startData);
    p2.collapsed = false;
    this.graph.data(this.graph.get("data"));
    this.graph.layout();
    if (isRepaintEdge) {
      this.graph.repaintEdge();
    }
    let ps = idx >= 0 && idx < updateParams.sort ? idx : updateParams.sort;
    for (let i = ps; i < p2.children.length; ++i) {
      if (i !== updateParams.sort) {
        updateSorts.push({
          articleId: p2.children[i].id,
          sort: i
        });
      }
    }
    updateParams.updateSorts = updateSorts;
    let newSortId = this.graph.findById(p2.id).getModel().sortId;
    const s = oldSortId.split("-");
    s.shift();
    const t = newSortId.split("-");
    t.shift();
    this.graph.emit("change", {
      type: MindmapEvent.nodeMove,
      options: {
        model: {
          oldIndexArr: s,
          newIndexArr: t,
          oldId: startModel.id,
          newId: p2.id,
          sort: updateParams.sort
        },
        updateParams,
        p: {
          nodes: startData,
          edges: this.graph.getNodeAndChildrenEdgesById(startData.id)
        }
      }
    });
  }
});
G6.registerBehavior("behavior-canvas", {
  options: {
    shouldBegin: (ctrl) => true
  },
  getEvents: function getEvents() {
    return {
      wheel: "onWheel"
    };
  },
  reCalcDir: true,
  timer: null,
  onWheel: function onWheel(ev) {
    ev.preventDefault();
    const shouldBegin = this.get("shouldBegin");
    if (ev.ctrlKey) {
      if (!shouldBegin(true))
        return;
      const canvas = this.graph.get("canvas");
      const point = canvas.getPointByClient(ev.clientX, ev.clientY);
      let ratio = this.graph.getZoom();
      if (ev.wheelDelta > 0) {
        ratio = ratio + ratio * 0.05;
      } else {
        ratio = ratio - ratio * 0.05;
      }
      this.graph.zoomTo(ratio, {
        x: point.x,
        y: point.y
      });
    } else {
      if (!shouldBegin(false))
        return;
      let direction = "all";
      let x = ev.deltaX || ev.movementX;
      let y = ev.deltaY || ev.movementY;
      if (controlMoveDirection.value) {
        direction = Math.abs(x) < Math.abs(y) ? "v" : "h";
        this.reCalcDir = false;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.reCalcDir = true;
        }, 1e3);
      }
      if (!y && navigator.userAgent.indexOf("Firefox") > -1)
        y = -ev.wheelDelta * 125 / 3;
      if (direction === "h") {
        y = 0;
      } else if (direction === "v") {
        x = 0;
      }
      this.graph.translate(-x, -y);
    }
  }
});
G6.registerBehavior("behavior-shortcut", {
  focusCanvasId: "mxs-mindmap_container",
  options: {
    hotList: [],
    shouldBegin: () => true
  },
  getEvents: function getEvents2() {
    return {
      keydown: "handleKeydown"
    };
  },
  handleKeydown(evt) {
    if (document.activeElement !== this.graph.get("container"))
      return;
    const { key, shiftKey, ctrlKey, altKey, metaKey } = evt;
    let handler = this.get("hotList").filter((item) => item.key === key) || [];
    if (shiftKey || ctrlKey || altKey || metaKey) {
      if (shiftKey) {
        handler = handler.filter((item) => {
          var _a;
          return ((_a = item.control) == null ? void 0 : _a.indexOf("shift")) > -1;
        });
      }
      if (ctrlKey) {
        handler = handler.filter((item) => {
          var _a;
          return ((_a = item.control) == null ? void 0 : _a.indexOf("ctrl")) > -1;
        });
      }
      if (metaKey) {
        handler = handler.filter((item) => {
          var _a;
          return ((_a = item.control) == null ? void 0 : _a.indexOf("cmd")) > -1;
        });
      }
      if (altKey) {
        handler = handler.filter((item) => {
          var _a;
          return ((_a = item.control) == null ? void 0 : _a.indexOf("alt")) > -1;
        });
      }
    } else if (handler.length === 1 && handler[0].control) {
      handler = [];
    }
    if (!this.get("shouldBegin")(this.graph) || !handler.length)
      return;
    evt.preventDefault();
    handler[0].Event.call(this, this.graph);
  }
});
G6.registerBehavior("behavior-default-node", {
  getEvents() {
    return {
      "node:click": "onClickNode",
      "node:mouseover": "onMouseOverNode",
      "node:mouseleave": "onMouseLeaveNode"
    };
  },
  onClickNode(evt) {
    const name = evt.target.get("name");
    if (name === NameString.collapseClick) {
      evt.propagationStopped = true;
      this.graph.editCollapse(evt.item);
      return;
    }
  },
  onMouseOverNode(evt) {
    const { item: node } = evt;
    const name = evt.target.get("name");
    if (name !== NameString.nodeContainer)
      return;
    if (node.getModel().children.length > 0) {
      {
        node.setState("hover", true);
      }
      node.toFront();
    }
  },
  onMouseLeaveNode(evt) {
    const { item: node } = evt;
    if (node.getModel().type === NodeType.defaultNode) {
      if (node.hasState("hover")) {
        {
          node.setState("hover", false);
        }
        node.toBack();
      }
    }
  }
});
function getHeight(preNode, node, align, heightField = "height") {
  return align === "center" ? (preNode[heightField] + node[heightField]) / 2 : preNode.height;
}
var util = {
  assign: mix,
  getHeight
};
const PEM = 18;
const DEFAULT_HEIGHT = PEM * 2;
const DEFAULT_GAP = PEM;
const DEFAULT_OPTIONS$6 = {
  getId(d) {
    return d.id || d.name;
  },
  getPreH(d) {
    return d.preH || 0;
  },
  getPreV(d) {
    return d.preV || 0;
  },
  getHGap(d) {
    return d.hgap || DEFAULT_GAP;
  },
  getVGap(d) {
    return d.vgap || DEFAULT_GAP;
  },
  getChildren(d) {
    return d.children;
  },
  getHeight(d) {
    return d.height || DEFAULT_HEIGHT;
  },
  getWidth(d) {
    const label = d.label || " ";
    return d.width || label.split("").length * PEM;
  }
};
function Node(data, options) {
  const me = this;
  me.vgap = me.hgap = 0;
  if (data instanceof Node)
    return data;
  me.data = data;
  const hgap = options.getHGap(data);
  const vgap = options.getVGap(data);
  me.preH = options.getPreH(data);
  me.preV = options.getPreV(data);
  me.width = options.getWidth(data);
  me.height = options.getHeight(data);
  me.width += me.preH;
  me.height += me.preV;
  me.id = options.getId(data);
  me.x = me.y = 0;
  me.depth = 0;
  if (!me.children) {
    me.children = [];
  }
  me.addGap(hgap, vgap);
  return me;
}
util.assign(Node.prototype, {
  isRoot() {
    return this.depth === 0;
  },
  isLeaf() {
    return this.children.length === 0;
  },
  addGap(hgap, vgap) {
    const me = this;
    me.hgap += hgap;
    me.vgap += vgap;
    me.width += 2 * hgap;
    me.height += 2 * vgap;
  },
  eachNode(callback) {
    const me = this;
    let nodes = [me];
    let current;
    while (current = nodes.shift()) {
      callback(current);
      nodes = current.children.concat(nodes);
    }
  },
  DFTraverse(callback) {
    this.eachNode(callback);
  },
  BFTraverse(callback) {
    const me = this;
    let nodes = [me];
    let current;
    while (current = nodes.shift()) {
      callback(current);
      nodes = nodes.concat(current.children);
    }
  },
  getBoundingBox() {
    const bb = {
      left: Number.MAX_VALUE,
      top: Number.MAX_VALUE,
      width: 0,
      height: 0
    };
    this.eachNode((node) => {
      bb.left = Math.min(bb.left, node.x);
      bb.top = Math.min(bb.top, node.y);
      bb.width = Math.max(bb.width, node.x + node.width);
      bb.height = Math.max(bb.height, node.y + node.height);
    });
    return bb;
  },
  translate(tx = 0, ty = 0) {
    this.eachNode((node) => {
      node.x += tx;
      node.y += ty;
      node.x += node.preH;
      node.y += node.preV;
    });
  },
  right2left() {
    const me = this;
    const bb = me.getBoundingBox();
    me.eachNode((node) => {
      node.x = node.x - (node.x - bb.left) * 2 - node.width;
    });
    me.translate(bb.width, 0);
  },
  bottom2top() {
    const me = this;
    const bb = me.getBoundingBox();
    me.eachNode((node) => {
      node.y = node.y - (node.y - bb.top) * 2 - node.height;
    });
    me.translate(0, bb.height);
  }
});
function hierarchy$1(data, options = {}, isolated) {
  options = util.assign({}, DEFAULT_OPTIONS$6, options);
  const root = new Node(data, options);
  const nodes = [root];
  let node;
  if (!isolated && !data.collapsed) {
    while (node = nodes.shift()) {
      if (!node.data.collapsed) {
        const children = options.getChildren(node.data);
        const length = children ? children.length : 0;
        node.children = new Array(length);
        if (children && length) {
          for (let i = 0; i < length; i++) {
            const child = new Node(children[i], options);
            node.children[i] = child;
            nodes.push(child);
            child.parent = node;
            child.depth = node.depth + 1;
          }
        }
      }
    }
  }
  return root;
}
class Layout {
  constructor(root, options = {}) {
    const me = this;
    me.options = options;
    me.rootNode = hierarchy$1(root, options);
  }
  execute() {
    throw new Error("please override this method");
  }
}
function WrappedTree$1(w, h, y, c = []) {
  const me = this;
  me.w = w || 0;
  me.h = h || 0;
  me.y = y || 0;
  me.x = 0;
  me.c = c || [];
  me.cs = c.length;
  me.prelim = 0;
  me.mod = 0;
  me.shift = 0;
  me.change = 0;
  me.tl = null;
  me.tr = null;
  me.el = null;
  me.er = null;
  me.msel = 0;
  me.mser = 0;
}
WrappedTree$1.fromNode = (root, isHorizontal2) => {
  if (!root)
    return null;
  const children = [];
  root.children.forEach((child) => {
    children.push(WrappedTree$1.fromNode(child, isHorizontal2));
  });
  if (isHorizontal2)
    return new WrappedTree$1(root.height, root.width, root.x, children);
  return new WrappedTree$1(root.width, root.height, root.y, children);
};
function moveRight(node, move, isHorizontal2) {
  if (isHorizontal2) {
    node.y += move;
  } else {
    node.x += move;
  }
  node.children.forEach((child) => {
    moveRight(child, move, isHorizontal2);
  });
}
function getMin(node, isHorizontal2) {
  let res = isHorizontal2 ? node.y : node.x;
  node.children.forEach((child) => {
    res = Math.min(getMin(child, isHorizontal2), res);
  });
  return res;
}
function normalize(node, isHorizontal2) {
  const min = getMin(node, isHorizontal2);
  moveRight(node, -min, isHorizontal2);
}
function convertBack$1(converted, root, isHorizontal2) {
  if (isHorizontal2) {
    root.y = converted.x;
  } else {
    root.x = converted.x;
  }
  converted.c.forEach((child, i) => {
    convertBack$1(child, root.children[i], isHorizontal2);
  });
}
function layer(node, isHorizontal2, d = 0) {
  if (isHorizontal2) {
    node.x = d;
    d += node.width;
  } else {
    node.y = d;
    d += node.height;
  }
  node.children.forEach((child) => {
    layer(child, isHorizontal2, d);
  });
}
var nonLayeredTidyTree = (root, options = {}) => {
  const isHorizontal2 = options.isHorizontal;
  function firstWalk(t) {
    if (t.cs === 0) {
      setExtremes(t);
      return;
    }
    firstWalk(t.c[0]);
    let ih = updateIYL(bottom(t.c[0].el), 0, null);
    for (let i = 1; i < t.cs; ++i) {
      firstWalk(t.c[i]);
      const min = bottom(t.c[i].er);
      separate(t, i, ih);
      ih = updateIYL(min, i, ih);
    }
    positionRoot(t);
    setExtremes(t);
  }
  function setExtremes(t) {
    if (t.cs === 0) {
      t.el = t;
      t.er = t;
      t.msel = t.mser = 0;
    } else {
      t.el = t.c[0].el;
      t.msel = t.c[0].msel;
      t.er = t.c[t.cs - 1].er;
      t.mser = t.c[t.cs - 1].mser;
    }
  }
  function separate(t, i, ih) {
    let sr = t.c[i - 1];
    let mssr = sr.mod;
    let cl = t.c[i];
    let mscl = cl.mod;
    while (sr !== null && cl !== null) {
      if (bottom(sr) > ih.low)
        ih = ih.nxt;
      const dist = mssr + sr.prelim + sr.w - (mscl + cl.prelim);
      if (dist > 0) {
        mscl += dist;
        moveSubtree(t, i, ih.index, dist);
      }
      const sy = bottom(sr);
      const cy = bottom(cl);
      if (sy <= cy) {
        sr = nextRightContour(sr);
        if (sr !== null)
          mssr += sr.mod;
      }
      if (sy >= cy) {
        cl = nextLeftContour(cl);
        if (cl !== null)
          mscl += cl.mod;
      }
    }
    if (!sr && !!cl) {
      setLeftThread(t, i, cl, mscl);
    } else if (!!sr && !cl) {
      setRightThread(t, i, sr, mssr);
    }
  }
  function moveSubtree(t, i, si, dist) {
    t.c[i].mod += dist;
    t.c[i].msel += dist;
    t.c[i].mser += dist;
    distributeExtra(t, i, si, dist);
  }
  function nextLeftContour(t) {
    return t.cs === 0 ? t.tl : t.c[0];
  }
  function nextRightContour(t) {
    return t.cs === 0 ? t.tr : t.c[t.cs - 1];
  }
  function bottom(t) {
    return t.y + t.h;
  }
  function setLeftThread(t, i, cl, modsumcl) {
    const li = t.c[0].el;
    li.tl = cl;
    const diff = modsumcl - cl.mod - t.c[0].msel;
    li.mod += diff;
    li.prelim -= diff;
    t.c[0].el = t.c[i].el;
    t.c[0].msel = t.c[i].msel;
  }
  function setRightThread(t, i, sr, modsumsr) {
    const ri = t.c[i].er;
    ri.tr = sr;
    const diff = modsumsr - sr.mod - t.c[i].mser;
    ri.mod += diff;
    ri.prelim -= diff;
    t.c[i].er = t.c[i - 1].er;
    t.c[i].mser = t.c[i - 1].mser;
  }
  function positionRoot(t) {
    t.prelim = (t.c[0].prelim + t.c[0].mod + t.c[t.cs - 1].mod + t.c[t.cs - 1].prelim + t.c[t.cs - 1].w) / 2 - t.w / 2;
  }
  function secondWalk2(t, modsum) {
    modsum += t.mod;
    t.x = t.prelim + modsum;
    addChildSpacing(t);
    for (let i = 0; i < t.cs; i++) {
      secondWalk2(t.c[i], modsum);
    }
  }
  function distributeExtra(t, i, si, dist) {
    if (si !== i - 1) {
      const nr = i - si;
      t.c[si + 1].shift += dist / nr;
      t.c[i].shift -= dist / nr;
      t.c[i].change -= dist - dist / nr;
    }
  }
  function addChildSpacing(t) {
    let d = 0;
    let modsumdelta = 0;
    for (let i = 0; i < t.cs; i++) {
      d += t.c[i].shift;
      modsumdelta += d + t.c[i].change;
      t.c[i].mod += modsumdelta;
    }
  }
  function updateIYL(low, index, ih) {
    while (ih !== null && low >= ih.low) {
      ih = ih.nxt;
    }
    return {
      low,
      index,
      nxt: ih
    };
  }
  layer(root, isHorizontal2);
  const wt = WrappedTree$1.fromNode(root, isHorizontal2);
  firstWalk(wt);
  secondWalk2(wt, 0);
  convertBack$1(wt, root, isHorizontal2);
  normalize(root, isHorizontal2);
  return root;
};
var separateTree = (root, options) => {
  const left = hierarchy$1(root.data, options, true);
  const right = hierarchy$1(root.data, options, true);
  const treeSize = root.children.length;
  const rightTreeSize = Math.round(treeSize / 2);
  const getSide = options.getSide || function(child, index) {
    if (index < rightTreeSize) {
      return "right";
    }
    return "left";
  };
  for (let i = 0; i < treeSize; i++) {
    const child = root.children[i];
    const side = getSide(child, i);
    if (side === "right") {
      right.children.push(child);
    } else {
      left.children.push(child);
    }
  }
  left.eachNode((node) => {
    if (!node.isRoot()) {
      node.side = "left";
    }
  });
  right.eachNode((node) => {
    if (!node.isRoot()) {
      node.side = "right";
    }
  });
  return {
    left,
    right
  };
};
const VALID_DIRECTIONS$1 = [
  "LR",
  "RL",
  "TB",
  "BT",
  "H",
  "V"
];
const HORIZONTAL_DIRECTIONS = [
  "LR",
  "RL",
  "H"
];
const isHorizontal = (direction) => HORIZONTAL_DIRECTIONS.indexOf(direction) > -1;
const DEFAULT_DIRECTION$1 = VALID_DIRECTIONS$1[0];
var doTreeLayout = (root, options, layoutAlgrithm) => {
  const direction = options.direction || DEFAULT_DIRECTION$1;
  options.isHorizontal = isHorizontal(direction);
  if (direction && VALID_DIRECTIONS$1.indexOf(direction) === -1) {
    throw new TypeError(`Invalid direction: ${direction}`);
  }
  if (direction === VALID_DIRECTIONS$1[0]) {
    layoutAlgrithm(root, options);
  } else if (direction === VALID_DIRECTIONS$1[1]) {
    layoutAlgrithm(root, options);
    root.right2left();
  } else if (direction === VALID_DIRECTIONS$1[2]) {
    layoutAlgrithm(root, options);
  } else if (direction === VALID_DIRECTIONS$1[3]) {
    layoutAlgrithm(root, options);
    root.bottom2top();
  } else if (direction === VALID_DIRECTIONS$1[4] || direction === VALID_DIRECTIONS$1[5]) {
    const { left, right } = separateTree(root, options);
    layoutAlgrithm(left, options);
    layoutAlgrithm(right, options);
    options.isHorizontal ? left.right2left() : left.bottom2top();
    right.translate(left.x - right.x, left.y - right.y);
    root.x = left.x;
    root.y = right.y;
    const bb = root.getBoundingBox();
    if (options.isHorizontal) {
      if (bb.top < 0) {
        root.translate(0, -bb.top);
      }
    } else {
      if (bb.left < 0) {
        root.translate(-bb.left, 0);
      }
    }
  }
  let fixedRoot = options.fixedRoot;
  if (fixedRoot === void 0)
    fixedRoot = true;
  if (fixedRoot) {
    root.translate(-(root.x + root.width / 2 + root.hgap), -(root.y + root.height / 2 + root.vgap));
  }
  return root;
};
class CompactBoxTreeLayout extends Layout {
  execute() {
    const me = this;
    return doTreeLayout(me.rootNode, me.options, nonLayeredTidyTree);
  }
}
const DEFAULT_OPTIONS$5 = {};
function compactBoxLayout(root, options) {
  options = util.assign({}, DEFAULT_OPTIONS$5, options);
  return new CompactBoxTreeLayout(root, options).execute();
}
function WrappedTree(height = 0, children = []) {
  const me = this;
  me.x = me.y = 0;
  me.leftChild = me.rightChild = null;
  me.height = 0;
  me.children = children;
}
const DEFAULT_OPTIONS$4 = {
  isHorizontal: true,
  nodeSep: 20,
  nodeSize: 20,
  rankSep: 200,
  subTreeSep: 10
};
function convertBack(converted, root, isHorizontal2) {
  if (isHorizontal2) {
    root.x = converted.x;
    root.y = converted.y;
  } else {
    root.x = converted.y;
    root.y = converted.x;
  }
  converted.children.forEach((child, i) => {
    convertBack(child, root.children[i], isHorizontal2);
  });
}
var dendrogram = (root, options = {}) => {
  options = util.assign({}, DEFAULT_OPTIONS$4, options);
  let maxDepth = 0;
  function wrappedTreeFromNode(n) {
    if (!n)
      return null;
    n.width = 0;
    if (n.depth && n.depth > maxDepth) {
      maxDepth = n.depth;
    }
    const children = n.children;
    const childrenCount = children.length;
    const t = new WrappedTree(n.height, []);
    children.forEach((child, i) => {
      const childWT = wrappedTreeFromNode(child);
      t.children.push(childWT);
      if (i === 0) {
        t.leftChild = childWT;
      }
      if (i === childrenCount - 1) {
        t.rightChild = childWT;
      }
    });
    t.originNode = n;
    t.isLeaf = n.isLeaf();
    return t;
  }
  function getDrawingDepth(t) {
    if (t.isLeaf || t.children.length === 0) {
      t.drawingDepth = maxDepth;
    } else {
      const depths = t.children.map((child) => getDrawingDepth(child));
      const minChildDepth = Math.min.apply(null, depths);
      t.drawingDepth = minChildDepth - 1;
    }
    return t.drawingDepth;
  }
  let prevLeaf;
  function position(t) {
    t.x = t.drawingDepth * options.rankSep;
    if (t.isLeaf) {
      t.y = 0;
      if (prevLeaf) {
        t.y = prevLeaf.y + prevLeaf.height + options.nodeSep;
        if (t.originNode.parent !== prevLeaf.originNode.parent) {
          t.y += options.subTreeSep;
        }
      }
      prevLeaf = t;
    } else {
      t.children.forEach((child) => {
        position(child);
      });
      t.y = (t.leftChild.y + t.rightChild.y) / 2;
    }
  }
  const wt = wrappedTreeFromNode(root);
  getDrawingDepth(wt);
  position(wt);
  convertBack(wt, root, options.isHorizontal);
  return root;
};
class DendrogramLayout extends Layout {
  execute() {
    const me = this;
    me.rootNode.width = 0;
    return doTreeLayout(me.rootNode, me.options, dendrogram);
  }
}
const DEFAULT_OPTIONS$3 = {};
function dendrogramLayout(root, options) {
  options = util.assign({}, DEFAULT_OPTIONS$3, options);
  return new DendrogramLayout(root, options).execute();
}
function positionNode(node, previousNode, indent, dropCap, align) {
  const displacementX = typeof indent === "function" ? indent(node) : indent * node.depth;
  if (!dropCap) {
    try {
      if (node.id === node.parent.children[0].id) {
        node.x += displacementX;
        node.y = previousNode ? previousNode.y : 0;
        return;
      }
    } catch (e) {
    }
  }
  node.x += displacementX;
  if (previousNode) {
    node.y = previousNode.y + util.getHeight(previousNode, node, align);
    if (previousNode.parent && node.parent.id !== previousNode.parent.id) {
      const prevParent = previousNode.parent;
      const preY = prevParent.y + util.getHeight(prevParent, node, align);
      node.y = preY > node.y ? preY : node.y;
    }
  } else {
    node.y = 0;
  }
  return;
}
var indentedTree = (root, indent, dropCap, align) => {
  let previousNode = null;
  root.eachNode((node) => {
    positionNode(node, previousNode, indent, dropCap, align);
    previousNode = node;
  });
};
const VALID_DIRECTIONS = [
  "LR",
  "RL",
  "H"
];
const DEFAULT_DIRECTION = VALID_DIRECTIONS[0];
class IndentedLayout extends Layout {
  execute() {
    const me = this;
    const options = me.options;
    const root = me.rootNode;
    options.isHorizontal = true;
    const { indent = 20, dropCap = true, direction = DEFAULT_DIRECTION, align } = options;
    if (direction && VALID_DIRECTIONS.indexOf(direction) === -1) {
      throw new TypeError(`Invalid direction: ${direction}`);
    }
    if (direction === VALID_DIRECTIONS[0]) {
      indentedTree(root, indent, dropCap, align);
    } else if (direction === VALID_DIRECTIONS[1]) {
      indentedTree(root, indent, dropCap, align);
      root.right2left();
    } else if (direction === VALID_DIRECTIONS[2]) {
      const { left, right } = separateTree(root, options);
      indentedTree(left, indent, dropCap, align);
      left.right2left();
      indentedTree(right, indent, dropCap, align);
      const bbox = left.getBoundingBox();
      right.translate(bbox.width, 0);
      root.x = right.x - root.width / 2;
    }
    return root;
  }
}
const DEFAULT_OPTIONS$2 = {};
function indentedLayout(root, options) {
  options = util.assign({}, DEFAULT_OPTIONS$2, options);
  return new IndentedLayout(root, options).execute();
}
function secondWalk(node, options) {
  let totalHeight = 0;
  if (!node.children.length) {
    totalHeight = node.height;
  } else {
    node.children.forEach((c) => {
      totalHeight += secondWalk(c, options);
    });
  }
  node._subTreeSep = options.getSubTreeSep(node.data);
  node.totalHeight = Math.max(node.height, totalHeight) + 2 * node._subTreeSep;
  return node.totalHeight;
}
function thirdWalk(node) {
  const children = node.children;
  const len = children.length;
  if (len) {
    children.forEach((c) => {
      thirdWalk(c);
    });
    const first = children[0];
    const last = children[len - 1];
    const childrenHeight = last.y - first.y + last.height;
    let childrenTotalHeight = 0;
    children.forEach((child) => {
      childrenTotalHeight += child.totalHeight;
    });
    if (childrenHeight > node.height) {
      node.y = first.y + childrenHeight / 2 - node.height / 2;
    } else if (children.length !== 1 || node.height > childrenTotalHeight) {
      const offset = node.y + (node.height - childrenHeight) / 2 - first.y;
      children.forEach((c) => {
        c.translate(0, offset);
      });
    } else {
      node.y = (first.y + first.height / 2 + last.y + last.height / 2) / 2 - node.height / 2;
    }
  }
}
const DEFAULT_OPTIONS$1 = {
  getSubTreeSep() {
    return 0;
  }
};
var mindmap = (root, options = {}) => {
  options = util.assign({}, DEFAULT_OPTIONS$1, options);
  root.parent = {
    x: 0,
    width: 0,
    height: 0,
    y: 0
  };
  if (root.data.isHor) {
    root.x = 0;
    let maxX = 0;
    root.children.forEach((c) => {
      let lastX = 0;
      let isFirst = true;
      c.BFTraverse((node) => {
        if (isFirst) {
          node.x = maxX + node.parent.x + node.parent.width + 50;
          isFirst = false;
        } else {
          node.x = node.parent.x + node.parent.width;
        }
        lastX = node.x + node.width;
      });
      maxX = lastX;
    });
  } else {
    root.BFTraverse((node) => {
      node.x = node.parent.x + node.parent.width;
    });
  }
  root.parent = null;
  if (root.data.isHor) {
    let maxHeight = root.height;
    root.children.forEach((c) => {
      c.parent.y = 0;
      c.parent.height = 0;
      const totalHeight = secondWalk(c, options);
      maxHeight = Math.max(totalHeight, maxHeight);
    });
    root.totalHeight = maxHeight;
  } else {
    secondWalk(root, options);
  }
  root.startY = 0;
  root.y = root.totalHeight / 2 - root.height / 2;
  if (root.data.isHor) {
    root.startY = 0;
    root.y = root.totalHeight / 2 - root.height / 2;
    root.totalHeight / 2 - root.height / 2;
    root.children.forEach((c) => {
      c.startY = (root.totalHeight - c.totalHeight) / 2;
      c.y = root.totalHeight / 2 - c.height / 2;
      c.eachNode((node) => {
        const children = node.children;
        const len = children.length;
        if (len) {
          const first = children[0];
          first.startY = node.startY + node._subTreeSep;
          if (len === 1) {
            first.y = node.y + node.height / 2 - first.height / 2;
          } else {
            first.y = first.startY + first.totalHeight / 2 - first.height / 2;
            for (let i = 1; i < len; i++) {
              const c2 = children[i];
              c2.startY = children[i - 1].startY + children[i - 1].totalHeight;
              c2.y = c2.startY + c2.totalHeight / 2 - c2.height / 2;
            }
          }
        }
      });
    });
  } else {
    root.eachNode((node) => {
      const children = node.children;
      const len = children.length;
      if (len) {
        const first = children[0];
        first.startY = node.startY + node._subTreeSep;
        if (len === 1) {
          first.y = node.y + node.height / 2 - first.height / 2;
        } else {
          first.y = first.startY + first.totalHeight / 2 - first.height / 2;
          for (let i = 1; i < len; i++) {
            const c = children[i];
            c.startY = children[i - 1].startY + children[i - 1].totalHeight;
            c.y = c.startY + c.totalHeight / 2 - c.height / 2;
          }
        }
      }
    });
  }
  if (root.data.isHor) {
    root.children.forEach((c) => {
      thirdWalk(c);
    });
  } else {
    thirdWalk(root);
  }
};
class MindmapLayout extends Layout {
  execute() {
    const me = this;
    return doTreeLayout(me.rootNode, me.options, mindmap);
  }
}
const DEFAULT_OPTIONS = {};
function mindmapLayout(root, options) {
  options = util.assign({}, DEFAULT_OPTIONS, options);
  return new MindmapLayout(root, options).execute();
}
const hierarchy = {
  compactBox: compactBoxLayout,
  dendrogram: dendrogramLayout,
  indented: indentedLayout,
  mindmap: mindmapLayout
};
const defaultEditStyle = {
  "display": "block",
  "position": "fixed",
  "box-sizing": "border-box",
  "white-space": "normal",
  "word-break": "break-all",
  "word-wrap": "break-word",
  "overflow": `auto`,
  "resize": `none`,
  "outline": `none`,
  "z-index": 10,
  "transform-origin": "0 0",
  "background-color": "transparent",
  "height": "auto",
  "width": "auto",
  "min-width": "auto",
  "max-width": "auto"
};
class TreeEdit {
  constructor(props) {
    this.type = 0;
    this.heightOffset = 0;
    this.maxHeight = 120;
    this.maxWidth = 200;
    this.paddingH = 0;
    this.value = "";
    this.originateValue = "";
    this.isFocus = false;
    this.visibility = true;
    this.el = props.editEl;
    this.el.setAttribute("data-key", "mindmap-input");
    this.graph = props.graph;
    if (this.el) {
      this.el.addEventListener("input", this.onChange.bind(this));
      this.el.addEventListener("focus", this.onFocus.bind(this));
      this.el.addEventListener("blur", this.onBlur.bind(this));
      this.el.addEventListener("keydown", this.onKeyDown.bind(this));
    }
    if (this.graph.isMobile) {
      document.addEventListener("touchstart", this.disabledInput.bind(this));
    }
  }
  onChange() {
    if (!this.node)
      return;
    if (this.type === 0) {
      let height = this.el.scrollHeight + this.heightOffset;
      height = height > this.maxHeight ? this.maxHeight : height;
      if (height - this.el.offsetHeight > 4) {
        this.el.style.height = height + "px";
      }
      if (this.el.innerText !== this.value) {
        this.value = this.el.innerText;
        this.graph.emit(EventName.change, {
          type: MindmapEvent.nodeTitleChange,
          options: {
            model: this.node.getModel(),
            title: this.value
          }
        });
      }
    } else if (this.type === 1) {
      let ratio = this.graph.getZoom();
      const size = this.graph.getTextSize(this.el.innerText ? this.el.innerText.replace(/\n/g, "") : defaultLabelText, __spreadValues({}, this.edgeLabelTextStyle));
      let width = size.width + this.paddingH;
      if (width >= this.maxWidth) {
        width = this.maxWidth;
      }
      this.el.style.width = width + "px";
      this.el.style.left = `${this.center.x - width * 0.5 * ratio}px`;
      let height = this.el.scrollHeight + this.heightOffset;
      this.el.style.top = `${this.center.y - height * 0.5 * ratio}px`;
      this.el.scrollTop = this.el.scrollHeight - height;
      if (this.el.innerText !== this.value) {
        this.value = this.el.innerText;
        this.graph.emit(EventName.change, {
          type: MindmapEvent.edgeTitleChange,
          options: {
            model: this.node.getModel(),
            title: this.value
          }
        });
      }
    }
  }
  blur() {
    if (this.node) {
      this.el.blur();
    }
  }
  focus() {
    if (this.node) {
      this.el.focus();
    }
  }
  disabledInput(e) {
    let key = e.target.getAttribute("data-key");
    if (key === "mindmap-input") {
      return;
    }
    this.blur();
  }
  onFocus(e) {
    this.isFocus = true;
    this.graph.emit(EventName.change, {
      type: MindmapEvent.focus,
      options: {
        target: e.target
      }
    });
    if (!this.node)
      return;
  }
  onBlur(e) {
    this.isFocus = false;
    this.graph.emit(EventName.change, {
      type: MindmapEvent.blur,
      options: {
        target: e.target
      }
    });
    if (!this.node)
      return;
    if (this.type === 0) {
      if (this.value !== this.node.getModel().title) {
        this.graph.emit(EventName.change, {
          type: MindmapEvent.nodeTitleBlur,
          options: {
            model: this.node.getModel(),
            title: this.value.trim()
          }
        });
        if (this.value) {
          this.graph.updateNodeTitle(this.node, this.value);
        }
      }
    } else if (this.type === 1) {
      if (this.value !== this.node.getModel()[this.changeKey]) {
        let model = this.node.getModel();
        let text = this.value.replace(/\n/g, "");
        const labelStyle = this.graph.getTextSize(text || defaultLabelText, __spreadValues({}, this.edgeLabelTextStyle));
        const options = {
          source: model.source,
          target: model.target
        };
        options[this.changeKey] = text;
        if (this.changeKey === "title") {
          options.labelStyle = labelStyle;
        } else if (this.changeKey === "label1") {
          options.labelStyle1 = labelStyle;
        } else if (this.changeKey === "label2") {
          options.labelStyle2 = labelStyle;
        }
        this.graph.modifyEdgeOptions(options);
      }
    }
    this.el.style.display = "none";
    this.el.style.top = "-300px";
    this.el.style.left = "-300px";
    if (this.type === 1) {
      if (this.target.getParent())
        this.target.getParent().show();
    } else {
      this.node.show();
    }
    this.node = void 0;
    if (this.originateValue === this.value && !this.visibility) {
      return;
    }
    if (!this.graph.isMobile) {
      let timer = setTimeout(() => {
        this.graph.get("container").focus();
        clearTimeout(timer);
      }, 500);
    }
  }
  onKeyDown(e) {
    if (!this.node)
      return;
    if (!this.visibility) {
      if (this.graph.checkShortcut(e)) {
        e.preventDefault();
        return false;
      }
      if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) {
        e.preventDefault();
        return false;
      }
      this.visibility = true;
      this.node.hide();
      this.el.style.opacity = "1";
      this.el.style.cursor = "text";
      this.el.style.pointerEvents = "auto";
    }
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      this.el.blur();
      return false;
    }
  }
  buildStyle(obj) {
    let res = "";
    for (let key in obj) {
      res += `${key}:${obj[key]};`;
    }
    return res;
  }
  showEdgeLabel(node, target) {
    if (!this.el)
      return;
    this.visibility = true;
    this.type = 1;
    this.node = node;
    const title = target.getParent().findAllByName(NameString.edgeTitle)[0];
    const { edgeLabelBgStyle, edgeLabelTextStyle } = node.getModel().style;
    this.edgeLabelTextStyle = edgeLabelTextStyle;
    const attrs = target.get("attrs");
    const bgBBox = target.getBBox();
    const textAttr = title.get("attrs");
    const textBBox = title.getBBox();
    this.target = target;
    target.getParent().hide();
    this.changeKey = attrs.changeKey;
    let ratio = this.graph.getZoom();
    let pos = this.graph.getClientByPoint(attrs.x, attrs.y);
    pos.x += attrs.width * 0.5 * ratio;
    pos.y += attrs.height * 0.5 * ratio;
    this.center = pos;
    this.paddingH = bgBBox.width - textBBox.width;
    this.maxWidth = (textAttr.maxWidth || edgeLabelTextStyle.maxWidth) + this.paddingH;
    const configStyle = {
      transform: `scale(${ratio})`,
      "background-color": edgeLabelBgStyle.fill,
      "font-size": `${edgeLabelTextStyle.fontSize}px`,
      "font-weight": edgeLabelTextStyle.fontWeight,
      "line-height": `${edgeLabelTextStyle.lineHeight}px`,
      "font-family": `${edgeLabelTextStyle.fontFamily}`,
      "color": `${edgeLabelTextStyle.fill}`,
      "border-radius": `${4}px`,
      "max-width": `${this.maxWidth}px`,
      "padding": `${EdgeTextPadding.v}px ${EdgeTextPadding.h}px`
    };
    this.el.style.cssText = this.buildStyle(__spreadProps(__spreadValues(__spreadValues({}, defaultEditStyle), configStyle), {
      "text-align": "left"
    }));
    this.el.innerText = textAttr.text !== defaultLabelText ? textAttr.text || "" : "";
    this.el.setAttribute("placeholder", "\u8BF7\u8F93\u5165\u6807\u7B7E");
    this.value = this.el.innerText;
    this.originateValue = this.el.innerText;
    if (attrs.width) {
      this.el.style.width = `${attrs.width}px`;
    }
    let top = this.center.y - this.el.offsetHeight * 0.5 * ratio;
    let left = this.center.x - this.el.offsetWidth * 0.5 * ratio;
    this.el.style.top = `${top}px`;
    this.el.style.left = `${left}px`;
    this.heightOffset = this.el.offsetHeight - this.el.scrollHeight;
    this.focusEnd();
  }
  show(node, isReady = false) {
    var _a, _b, _c;
    if (this.node && this.node.getModel().id === this.node.getModel().id && this.visibility)
      return;
    if (!this.el || !((_a = node._cfg) == null ? void 0 : _a.bboxCache))
      return;
    this.visibility = !isReady;
    this.type = 0;
    this.node = node;
    if (this.visibility) {
      this.node.hide();
    }
    const { x: pointX, y: pointY } = (_b = node._cfg) == null ? void 0 : _b.bboxCache;
    const {
      style: {
        stroke,
        beforeWidth
      },
      nameStyle,
      btnStyle,
      btnTextStyle,
      btnSelectedStyle
    } = (_c = node._cfg) == null ? void 0 : _c.model;
    node.getContainer().findAllByName("title")[0];
    let ratio = this.graph.getZoom();
    let { x, y } = this.graph.getClientByPoint(pointX, pointY);
    this.el.style.cssText = this.buildStyle(__spreadProps(__spreadValues({}, defaultEditStyle), {
      transform: `scale(${ratio})`,
      top: `${y - btnStyle.lineWidth * 0.5 * ratio}px`,
      left: `${beforeWidth * ratio + x - stroke * 0.5 * ratio}px`,
      "max-width": `${nameStyle.maxWidth + paddingH * 2}px`,
      "font-size": `${btnTextStyle.fontSize}px`,
      "font-family": `${btnTextStyle.fontFamily}`,
      "font-weight": `${btnTextStyle.fontWeight}`,
      "font-style": `${btnTextStyle.fontStyle}`,
      "text-align": "left",
      padding: `0 ${paddingH - btnStyle.lineWidth * 0.5}px`,
      "line-height": `${btnTextStyle.lineHeight}px`,
      "background-color": btnStyle.fill === "transparent" ? "" : btnStyle.fill,
      border: `${stroke}px solid ${btnSelectedStyle.stroke}`,
      color: btnTextStyle.fill,
      "border-radius": `${radius + 1}px`,
      "opacity": this.visibility ? "1" : "0",
      "cursor": this.visibility ? "text" : "pointer",
      "pointer-events": this.visibility ? "auto" : "none"
    }));
    this.el.innerText = placeholderText === nameStyle.text ? "" : nameStyle.text;
    this.value = nameStyle.text || "";
    this.originateValue = this.value;
    this.el.setAttribute("placeholder", placeholderText);
    this.heightOffset = this.el.offsetHeight - this.el.scrollHeight;
    this.el.contentEditable = "false";
    this.focusEnd();
  }
  focusEnd() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.el.contentEditable = "true";
      this.el.focus();
      if (window.getSelection) {
        const range = window.getSelection();
        range.selectAllChildren(this.el);
        range.collapseToEnd();
      }
    }, this.graph.isMobile ? 300 : 300);
  }
}
class MindGraph extends TreeGraph {
  constructor(props, options) {
    super(props);
    this.tempVariable = {
      linkNode: void 0,
      moveLinkEdge: void 0
    };
    this._edges = [];
    this._isInit = false;
    this._tempShirnkMap = /* @__PURE__ */ new Map();
    this.initShowDepth = 3;
    this.isMobile = false;
    this.clickEdgeShowLabel = false;
    this.quadtreeType = "ver";
    this.scaleRatio = 1;
    this.quadtrees = [];
    this.links = [];
    this._cache = {};
    this.selectEditEnabled = false;
    this._config = options.config;
    this._hideEdge = options.hideEdge;
    this.initShowDepth = options.initShowDepth;
    this.clickEdgeShowLabel = options.clickEdgeShowLabel;
    this.isMobile = options.isMobile;
    this.quadtreeType = options.quadtreeType;
    this.scaleRatio = options.config.scaleRatio;
    this.shortcuts = options.shortcuts || [];
    this.mode = options.mode;
    this.setTheme(options);
    this.links = options.links;
    this._editor = new TreeEdit({
      graph: this,
      editEl: options.editEl
    });
    if (options.mode === "edit")
      ;
  }
  checkShortcut(e) {
    if (this.mode !== "edit")
      return true;
    const idx = this.shortcuts.findIndex((shortcut) => {
      return shortcut.key.toLowerCase() === e.key.toLowerCase() && (!shortcut.control || shortcut.control && (e.ctrlKey || e.metaKey));
    });
    if (idx !== -1 && this.shortcuts[idx].Event) {
      this.shortcuts[idx].Event(this);
      return true;
    }
    return false;
  }
  setTheme(theme) {
    const themeColor = theme.nodeStyle && theme.nodeStyle.themeColor || "#5a6ef0";
    this.nodeStyle = __spreadValues({
      btnStyle: {
        fill: "transparent",
        stroke: "transparent",
        lineWidth: 2
      },
      btnStyles: [
        { fill: themeColor, stroke: "transparent", lineWidth: 2 },
        { fill: "#e9e9e9", stroke: "#e9e9e9", lineWidth: 2 }
      ],
      btnHoverStyle: {
        stroke: themeColor
      },
      btnHoverStyles: [
        {
          stroke: themeColor
        }
      ],
      btnSelectedStyle: {
        stroke: themeColor
      },
      btnSelectedStyles: [
        {
          stroke: themeColor
        }
      ],
      btnTypeStyles: {
        1: {
          hoverFill: "#ffd6d6",
          selectedFill: "#ffd6d6",
          hoverStroke: "#DF7271",
          selectStroke: "#DF7271",
          hoverTextColor: "#333",
          selectTextColor: "#333",
          show: false
        }
      },
      specialStyle: {
        1: {
          fontFamily: "iconfont",
          fill: "#DF7271",
          text: "\uE604",
          fontSize: 14,
          fontWeight: 700
        }
      },
      btnTextStyle: {
        fill: "#444",
        fontSize: 13,
        fontStyle: "normal",
        fontWeight: 400,
        fontFamily: '"Microsoft YaHei", "PingFang SC", "Microsoft JhengHei", sans-serif',
        textBaseline: "middle",
        lineHeight: 25,
        maxCount: 16,
        maxWidth: 200
      },
      btnTextStyles: [
        { fill: "#fff", fontWeight: 700, fontSize: 16 },
        { fill: "#444", fontWeight: 600, fontSize: 14 }
      ],
      collapsedNumberTextStyle: {
        fill: themeColor,
        fontSize: 12
      },
      collapsedNumberStyle: {
        fill: "transparent"
      },
      collapsedSelectedStyle: {
        r: 9,
        lineWidth: 2,
        fill: themeColor,
        stroke: themeColor
      },
      collapsedSelectedTextStyle: {
        fill: "white",
        fontSize: 16,
        lineHeight: 18,
        fontWeight: 600,
        fontFamily: "iconfont"
      },
      doubleIconStyle: {
        fontFamily: "iconfont",
        fill: "#A48AFF",
        text: "\uE8D3",
        fontSize: 14,
        fontWeight: 700
      },
      doubleIconBg: {
        fill: "#291F42",
        stroke: "#6C6ADF",
        radius: 6
      },
      linkReadyStyle: {
        stroke: "#3dcc3d",
        btnStyle: {
          fill: "#3dcc3d"
        },
        btnTextStyle: {
          fontFamily: "iconfont",
          fill: "#fff",
          text: "\uEAF3",
          fontWeight: 600,
          fontSize: 10
        }
      },
      linkDotStyle: {
        fill: "#3dcc3d",
        r: 4
      },
      linkLabelBgStyle: {
        fill: "#3dcc3d"
      },
      linkLabelTextStyle: {
        fontStyle: "normal",
        fontFamily: '"Microsoft YaHei", "PingFang SC", "Microsoft JhengHei", sans-serif',
        fill: "white",
        fontSize: 12,
        fontWeight: 400,
        textAlign: "left",
        textBaseline: "middle",
        lineHeight: 20,
        maxWidth: 200
      },
      dragStyle: {
        opacity: 0.6,
        radius: 4,
        themeColor,
        dragMoveSize: { width: 40, height: 20 }
      },
      shrinkRoot: {
        virtual: 14,
        width: 22,
        height: 22,
        fill: "#fff",
        fontColor: "#333",
        stroke: "#5F65EF",
        fontFamily: "MiSans",
        lineWidth: 2,
        radius: 8
      }
    }, theme.nodeStyle);
    const lineThemeColor = theme.edgeLinkStyle && theme.edgeLinkStyle.lineThemeColor || "#a9ea7a";
    this.edgeLinkStyle = __spreadValues({
      edgeLabelBgStyle: {
        fill: lineThemeColor
      },
      edgeLabelSelectedStyle: {
        stroke: "blue",
        lineWidth: 2
      },
      edgeLabelTextStyle: {
        fontStyle: "normal",
        fontFamily: '"Microsoft YaHei", "PingFang SC", "Microsoft JhengHei", sans-serif',
        fill: "#222",
        fontSize: 12,
        fontWeight: 400,
        textAlign: "left",
        textBaseline: "middle",
        lineHeight: 20,
        maxWidth: 200
      },
      edgePathStyle: {
        stroke: lineThemeColor,
        shadowColor: "#4f8946"
      },
      edgeDotStyle: {
        fill: lineThemeColor,
        r: 2
      },
      circleDotStyle: {
        r: 4,
        lineWidth: 2,
        stroke: lineThemeColor,
        fill: "#fff"
      },
      arrowStyle: {
        path: `M 0,0 L 9,9, L 0,0 L 9,-9 Z`,
        stroke: lineThemeColor,
        fill: lineThemeColor,
        lineDash: [1, 1]
      }
    }, theme.edgeLinkStyle);
  }
  getLayout() {
    const layout = this.get("layout");
    if (!layout) {
      return null;
    }
    if (typeof layout === "function") {
      return layout;
    }
    if (!layout.type) {
      layout.type = "dendrogram";
    }
    if (!layout.direction) {
      layout.direction = layout.type === "indented" ? "LR" : "TB";
    }
    if (layout.radial) {
      return (data) => {
        const layoutData = hierarchy[layout.type](data, layout);
        return layoutData;
      };
    }
    return (data) => hierarchy[layout.type](data, layout);
  }
  data(data, maxDepth = -1, isReadyCache = false) {
    super.data(this.formatData(data, maxDepth, isReadyCache));
  }
  setConfig(config) {
    this._config = config;
  }
  formatData(items, maxDepth = -1, isReadyCache = false) {
    let _data;
    if ((items == null ? void 0 : items.length) > 1) {
      _data = {
        id: nameHideRoot,
        children: items,
        visible: false,
        branchColor: "transparent"
      };
    } else if ((items == null ? void 0 : items.length) == 1) {
      if (items[0].id !== nameHideRoot) {
        _data = {
          id: nameHideRoot,
          visible: false,
          children: [items[0]]
        };
      } else {
        _data = items[0];
      }
    } else {
      if (items.id !== nameHideRoot) {
        _data = {
          id: nameHideRoot,
          visible: false,
          children: [items]
        };
      } else {
        _data = items;
      }
    }
    const data = this.createDataFromData(_data, -1, maxDepth, "0", true, isReadyCache);
    return data;
  }
  createDataFromData(item, depth = -1, maxDepth = -1, sortId = "0", isChildren = true, isReadyCache = false) {
    const {
      children,
      _children,
      collapsed,
      isSubView,
      id,
      style
    } = item;
    let nStyle = this.getNodeStyle(__spreadValues({}, Object.assign({}, item, style, { name: item.title, depth, iconDetail: item.iconDetail })));
    if (item.type === NodeType.shrinkRoot) {
      nStyle.style.width += this.nodeStyle.shrinkRoot.width * Math.sqrt(2) + 4 + this.nodeStyle.shrinkRoot.virtual;
      nStyle.shrinkRoot = __spreadValues({}, this.nodeStyle.shrinkRoot);
      nStyle.lineStyle = __spreadValues({}, this.cfg.defaultEdge.style);
    }
    const labelStyle = item.label && item.type !== NodeType.shrinkRoot ? this.getTextSize(item.label, __spreadValues({}, this.nodeStyle.linkLabelTextStyle)) : void 0;
    if (labelStyle && item.type !== NodeType.shrinkRoot) {
      nStyle.nodeStyle = {
        width: nStyle.style.width,
        height: nStyle.style.height
      };
      nStyle.style.width += labelStyle.width + EdgeTextPadding.h * 2;
      nStyle.style.height = Math.max(labelStyle.height + EdgeTextPadding.v * 2, nStyle.style.height);
    }
    if (item.isDoubleLabel && item.type !== NodeType.shrinkRoot) {
      nStyle.style.width += IconLabelSize.width;
    }
    let isCollapsed = !children || children.length === 0 ? false : maxDepth > 0 && depth >= maxDepth ? true : collapsed || false;
    if (isReadyCache && (this._cache[id] === false || this._cache[id] === true)) {
      isCollapsed = !this._cache[id];
    }
    const data = __spreadProps(__spreadValues({
      isHor: item.isHor,
      id,
      visible: item.visible,
      side: item.side,
      sortId,
      hideNum: item.hideNum,
      isSubView: isSubView || false,
      collapsed: isCollapsed,
      children: [],
      _children: [],
      isRoot: depth < 1,
      depth,
      realDepth: depth,
      label: item.label,
      type: item.type || NodeType.defaultNode,
      isDoubleLabel: item.isDoubleLabel,
      iconType: item.iconType,
      iconDetail: item.iconDetail,
      labelStyle
    }, nStyle), {
      edgeConfig: this.links[item.id]
    });
    if (children && isChildren) {
      data.children = children.filter((t) => !t.destroyed).map((child, idx) => {
        child.side = item.side;
        return this.createDataFromData(child, depth + 1, maxDepth, sortId + "-" + idx, true, isReadyCache);
      });
    }
    if (_children && isChildren) {
      data._children = _children.filter((t) => !t.destroyed).map((child, idx) => {
        child.side = item.side;
        return this.createDataFromData(child, depth + 1, maxDepth, sortId + "-" + idx, true, isReadyCache);
      });
    }
    return data;
  }
  getNodeStyle({
    name = placeholderText,
    desc = "",
    depth,
    iconType = 0,
    nodeStyle,
    visible = true,
    iconDetail
  }) {
    name === "" && (name = placeholderText);
    const btnTextStyle = __spreadValues(__spreadValues({}, this.nodeStyle.btnTextStyle), this.nodeStyle.btnTextStyles[depth]);
    const fontSize = btnTextStyle.fontSize || 12;
    const fontWeight = btnTextStyle.fontWeight || 400;
    const descFontWeight = 400;
    const maxNodeSize = fontSize * maxFontCount + paddingH * 2;
    const descFontSize = fontSize - 2;
    let headIcon, btnTypeStyle;
    const imageIconWidth = (btnTypeStyle == null ? void 0 : btnTypeStyle.show) && headIcon ? paddingH : 0;
    if (!iconDetail && iconType === 1 || iconDetail && iconDetail.marked) {
      headIcon = this.nodeStyle.specialStyle[iconType] || this.nodeStyle.specialStyle[1];
      btnTypeStyle = this.nodeStyle.btnTypeStyles[iconType] || this.nodeStyle.btnTypeStyles[1];
    }
    const nameStyle = this.getTextSize(name, btnTextStyle);
    const desStyle = this.getTextSize(desc, __spreadProps(__spreadValues({}, btnTextStyle), {
      fontSize: descFontSize,
      fontWeight: descFontWeight
    }));
    const height = nameStyle.height + ((desStyle == null ? void 0 : desStyle.height) || 0) + 2;
    let beforeWidth = 0, afterWidth = 0;
    if (depth >= 2) {
      beforeWidth = 0;
      afterWidth = 0;
    } else {
      beforeWidth = 10;
      afterWidth = 10;
    }
    const obj = __spreadProps(__spreadValues({
      title: name,
      desc,
      style: {
        fontSize,
        fontWeight,
        descFontSize,
        width: visible ? Math.max(nameStyle.width, (desStyle == null ? void 0 : desStyle.width) || 0) + paddingH * 2 : 0,
        maxWidth: maxNodeSize,
        height: visible ? height : 0,
        stroke: 2,
        nameHeight: nameStyle.height,
        descHeight: (desStyle == null ? void 0 : desStyle.height) || 0,
        descFontWeight,
        imageIconWidth,
        headIcon,
        visible,
        beforeWidth,
        afterWidth,
        nodeStyle
      },
      nameStyle,
      desStyle
    }, this.nodeStyle), {
      btnStyle: this.nodeStyle.btnStyles[depth] || this.nodeStyle.btnStyle,
      btnTextStyle,
      btnHoverStyle: this.nodeStyle.btnHoverStyles[depth] || this.nodeStyle.btnHoverStyle,
      btnSelectedStyle: this.nodeStyle.btnSelectedStyles[depth] || this.nodeStyle.btnSelectedStyle,
      btnTypeStyle
    });
    return obj;
  }
  getLinkEdgeStyle() {
    return __spreadValues({}, this.edgeLinkStyle);
  }
  hideLinkBtn(selected = false) {
    if (!this.tempVariable.linkNode)
      return;
    let node = this.tempVariable.linkNode;
    const group = node.getContainer();
    if (node.hasState("link")) {
      node.clearStates("link");
      let linkCircles = group.findAllByName(NameString.linkCircle);
      let linkTexts = group.findAllByName("link-add");
      linkCircles.forEach((circle) => {
        circle.stopAnimate();
        circle.animate((ratio) => {
          return {
            r: (1 - ratio) * addRadius,
            opacity: 1 - ratio
          };
        }, {
          duration: 250
        });
      });
      linkTexts.forEach((text) => {
        text.stopAnimate();
        text.animate((ratio) => {
          return {
            fontSize: (1 - ratio) * 18,
            opacity: 1 - ratio
          };
        }, {
          duration: 250
        });
      });
    }
    if (!selected) {
      let wrapper = group.findAllByName(NameString.nodeWrapper)[0];
      wrapper == null ? void 0 : wrapper.attr("stroke", "transparent");
    }
  }
  closeLinkBtn(selected = false) {
    if (!this.tempVariable.linkNode)
      return;
    if (!this.tempVariable.linkNode.hasState("link")) {
      this.deleteLinkBtn(this.tempVariable.linkNode);
      this.tempVariable.linkNode = void 0;
      return;
    }
    this.hideLinkBtn(selected);
    let node = this.tempVariable.linkNode;
    this.tempVariable.linkNode = void 0;
    setTimeout(() => {
      this.deleteLinkBtn(node);
    }, 250);
  }
  deleteLinkBtn(node = this.tempVariable.linkNode) {
    this.tempVariable.linkNode = void 0;
    if (!node)
      return;
    const group = node.getContainer();
    let linkGroup = group.findAllByName(NameString.linkGroup)[0];
    if (linkGroup) {
      group.removeChild(linkGroup);
    }
  }
  checkValidEdge(options) {
    const node = this.findById(options.source);
    if (!node)
      return false;
    const node2 = this.findById(options.target);
    if (!node2)
      return false;
    return true;
  }
  editAddEdge(options) {
    if (!this.checkValidEdge(options))
      return;
    this.newEdge(options, false);
  }
  createEdge(options) {
    this.emit(EventName.change, {
      type: MindmapEvent.edgeCreate,
      options: {
        data: options,
        sourceData: this.findDataById(options.source),
        targetData: this.findDataById(options.target),
        type: this._tempAddLinkType
      }
    });
  }
  editCreateEdge(options, type) {
    this._tempAddLinkType = type;
    this.newEdge(options);
  }
  refreshData() {
    this.data(this.get("data"));
    this.layout();
  }
  newEdge(options, isNotify = true) {
    options.id = getLinkId(options.source, options.target);
    if (this._tempAddLinkType) {
      options.labelType = this._tempAddLinkType;
    }
    let p2 = this.findById(options.id);
    if (p2) {
      if (isNotify) {
        this.emit(EventName.change, {
          type: MindmapEvent.edgeExist
        });
      }
      return false;
    }
    this._edges.push(options);
    const edge = this.addItem("edge", __spreadProps(__spreadValues({
      name: NameString.edgeLink
    }, options), {
      zIndex: 5,
      type: NodeType.linkEdge,
      style: this.getLinkEdgeStyle()
    }));
    if (this._tempAddLinkType || options.labelType === 2) {
      let data1 = this.findDataById(options.target);
      data1.isDoubleLabel = true;
      let data2 = this.findDataById(options.source);
      data2.isDoubleLabel = true;
      this.refreshData();
      this.edgeEditDoubleLable(edge, false);
    } else {
      this.editClickEdge(edge, true);
      if (isNotify) {
        this.edgeEditLabel(edge);
      }
    }
    if (isNotify) {
      this.emit(EventName.change, {
        type: MindmapEvent.edgeAdd,
        options: {
          data: options,
          edges: this._edges
        }
      });
    }
    return true;
  }
  resetEdge(options) {
    let p2 = this.findById(options.id);
    if (p2) {
      return false;
    }
    const edge = this.addItem("edge", __spreadProps(__spreadValues({
      name: NameString.edgeLink
    }, options), {
      zIndex: 5,
      type: NodeType.linkEdge,
      selected: this.clickEdgeShowLabel ? true : false,
      style: this.getLinkEdgeStyle()
    }));
    this._curSelectedNode = void 0;
    this.editClickEdge(edge, true);
  }
  editChangeEdge({ newItem, oldItem }) {
    if (oldItem && (newItem.target !== oldItem.target || newItem.source !== oldItem.source)) {
      oldItem.id = getLinkId(oldItem.source, oldItem.target);
      this.cancelSelect();
      this.closeLinkBtn();
      this.deleteEdgeByModel(oldItem, false);
      if (this.checkValidEdge(newItem)) {
        if (newItem.labelType === 2) {
          newItem.labelStyle1 = this.getTextSize(newItem.label1 || defaultLabelText, this.edgeLinkStyle.edgeLabelTextStyle);
          newItem.labelStyle2 = this.getTextSize(newItem.label2 || defaultLabelText, this.edgeLinkStyle.edgeLabelTextStyle);
        } else {
          newItem.labelStyle = this.getTextSize(newItem.title, this.edgeLinkStyle.edgeLabelTextStyle);
        }
        this.newEdge(newItem, false);
      }
    } else {
      if (!this.checkValidEdge(newItem))
        return;
      this.cancelSelect();
      this.closeLinkBtn();
      const linkId = getLinkId(newItem.source, newItem.target);
      const model = this.findById(linkId).getModel();
      if (model.title !== newItem.title) {
        newItem.labelStyle = this.getTextSize(newItem.title, this.edgeLinkStyle.edgeLabelTextStyle);
      } else {
        newItem.labelStyle = model.labelStyle;
      }
      if (model.label1 !== newItem.label1) {
        newItem.labelStyle1 = this.getTextSize(newItem.label1 || defaultLabelText, this.edgeLinkStyle.edgeLabelTextStyle);
      } else {
        newItem.labelStyle1 = model.labelStyle1;
      }
      if (model.label2 !== newItem.label2) {
        newItem.labelStyle2 = this.getTextSize(newItem.label2 || defaultLabelText, this.edgeLinkStyle.edgeLabelTextStyle);
      } else {
        newItem.labelStyle2 = model.labelStyle2;
      }
      this.modifyEdgeOptions(newItem, false);
    }
  }
  modifyEdgeTargetOrSource(modify, isNotify = true) {
    this.cancelSelect();
    modify.options.id = getLinkId(modify.options.source, modify.options.target);
    let p2 = this.findById(modify.options.id);
    if (p2) {
      if (isNotify) {
        this.emit("change", {
          type: MindmapEvent.edgeExist
        });
      }
      return false;
    }
    const idx = this._edges.findIndex((r) => r.target === modify.old.target && r.source === modify.old.source);
    let old = {};
    if (idx !== -1) {
      old = this._edges.splice(idx, 1)[0];
    }
    let options = __spreadValues(__spreadValues({}, old), modify.options);
    this._edges.push(options);
    if (old.source && old.labelType === 2) {
      let checkId = modify.options.source === old.source ? old.target : old.source;
      if (!this.checkHasDoubleLabel(checkId)) {
        let data2 = this.findDataById(checkId);
        if (data2) {
          data2.isDoubleLabel = false;
        }
      }
      checkId = modify.options.source === old.source ? modify.options.target : modify.options.source;
      let data = this.findDataById(checkId);
      if (data) {
        data.isDoubleLabel = true;
      }
      this.refreshData();
    }
    const edge = this.addItem("edge", __spreadProps(__spreadValues({
      name: NameString.edgeLink
    }, options), {
      zIndex: 5,
      type: NodeType.linkEdge,
      selected: this.clickEdgeShowLabel ? true : true,
      style: this.getLinkEdgeStyle()
    }));
    this.editClickEdge(edge, true);
    if (isNotify) {
      this.emit("change", {
        type: MindmapEvent.edgeChange,
        options: {
          modify: modify.options,
          old,
          edge: options,
          edges: this._edges
        }
      });
    }
    return true;
  }
  updateNodeTitleById(nodeId, title) {
    const node = this.findById(nodeId);
    if (node) {
      this.updateNodeTitle(node, title);
    }
  }
  updateNodeTitle(node, title, isFocus = false, isTrim = true) {
    const model = node.getModel();
    model.title = isTrim ? title.trim() : title;
    let newModel = this.createDataFromData(model, model.realDepth, -1, model.sortId);
    if (model.nodeStyle) {
      model.nodeStyle = newModel.nodeStyle;
    }
    model.nameStyle = newModel.nameStyle;
    model.style = newModel.style;
    model.isFocus = isFocus;
    this.layout();
  }
  updateModel(id, model) {
    const oldModel = this.findDataById(id);
    if (!oldModel)
      return;
    let newModel = this.createDataFromData(__spreadValues(__spreadValues({}, oldModel), model), oldModel.realDepth, -1, oldModel.sortId, false);
    if (model.nodeStyle) {
      model.nodeStyle = newModel.nodeStyle;
    }
    if (newModel.iconDetail) {
      model.iconDetail = newModel.iconDetail;
    }
    if (newModel.btnTypeStyle) {
      model.btnTypeStyle = newModel.btnTypeStyle;
    }
    if (newModel.headIcon) {
      model.headIcon = newModel.headIcon;
    }
    model.nameStyle = newModel.nameStyle;
    model.style = newModel.style;
    this.updateItem(this.findById(id), __spreadValues({}, model));
  }
  modifyEdgeLabel(edgeId, { label1, label2, title }) {
    const idx = this._edges.findIndex((r) => r.id === edgeId);
    if (idx !== -1) {
      const options = {};
      if (label1) {
        options.label1 = label1;
        options.labelStyle1 = this.getTextSize(label1 || defaultLabelText, this.edgeLinkStyle.edgeLabelTextStyle);
      }
      if (label2) {
        options.label2 = label2;
        options.labelStyle2 = this.getTextSize(label2 || defaultLabelText, this.edgeLinkStyle.edgeLabelTextStyle);
      }
      if (title) {
        options.title = title;
        options.labelStyle = this.getTextSize(title || defaultLabelText, this.edgeLinkStyle.edgeLabelTextStyle);
      }
      options.source = this._edges[idx].source;
      options.target = this._edges[idx].target;
      this.modifyEdgeOptions(options);
    }
  }
  modifyEdgeOptions(options, isNotify = true) {
    options.id = getLinkId(options.source, options.target);
    const idx = this._edges.findIndex((r) => r.target === options.target && r.source === options.source);
    const old = this._edges[idx];
    if (idx !== -1) {
      this._edges[idx] = __spreadValues(__spreadValues({}, this._edges[idx]), options);
    }
    let node = this.findById(options.id);
    if (node) {
      if (this._edges[idx].labelType !== 2) {
        this.updateItem(node, __spreadProps(__spreadValues({}, this._edges[idx]), {
          editType: void 0
        }));
      } else {
        this.updateItem(options.id, __spreadValues({}, this._edges[idx]));
      }
    }
    if (isNotify) {
      let p2 = __spreadValues({}, options);
      delete p2.labelStyle;
      delete p2.labelStyle1;
      delete p2.labelStyle2;
      this.emit("change", {
        type: MindmapEvent.edgeChange,
        options: {
          modify: p2,
          old: __spreadValues({}, old),
          edge: __spreadValues({}, this._edges[idx]),
          edges: this._edges
        }
      });
    }
  }
  checkHasDoubleLabel(id) {
    return this._edges.findIndex((r) => {
      return r.labelType === 2 && (r.target === id || r.source === id);
    }) !== -1;
  }
  deleteEdgeByModel(model, isNotify = true) {
    if (!model.id)
      model.id = getLinkId(model.source, model.target);
    let p2 = this.findById(model.id);
    if (p2) {
      if (this._curSelectedNode && model.id === this._curSelectedNode.getModel().id) {
        this.checkCloseSelected(p2);
      }
      if (!p2.destroyed) {
        this.removeItem(p2);
      }
    }
    const idx = this._edges.findIndex((r) => r.target === model.target && r.source === model.source);
    if (idx !== -1) {
      this._edges.splice(idx, 1);
      let isUpdateNode = false;
      if (!this.checkHasDoubleLabel(model.target)) {
        let data = this.findDataById(model.target);
        if (data) {
          data.isDoubleLabel = false;
          isUpdateNode = true;
        }
      }
      if (!this.checkHasDoubleLabel(model.source)) {
        let data = this.findDataById(model.source);
        if (data) {
          data.isDoubleLabel = false;
          isUpdateNode = true;
        }
      }
      if (isUpdateNode) {
        this.refreshData();
      }
    }
    if (isNotify) {
      this.emit("change", {
        type: MindmapEvent.edgeDelete,
        options: {
          data: {
            source: model.source,
            target: model.target
          },
          edges: this._edges
        }
      });
    }
  }
  deleteEdge(node, isNotify = true) {
    const options = node.getModel();
    this.deleteEdgeByModel(options, isNotify);
  }
  edgeEditLabel(node, target) {
    if (!target) {
      let model = node.getModel();
      const idx = this._edges.findIndex((r) => r.target === model.target && r.source === model.source);
      const labelStyle = this.getTextSize(model.title || defaultLabelText, this.edgeLinkStyle.edgeLabelTextStyle);
      const options = {
        labelStyle
      };
      if (idx !== -1) {
        this._edges[idx] = __spreadValues(__spreadValues({}, this._edges[idx]), options);
      }
      this.updateItem(model.id, __spreadProps(__spreadValues({}, options), {
        editType: 0,
        labelStyle
      }));
      target = node.getContainer().findAllByName(NameString.edgeTitleBg)[0];
    }
    this._editor.showEdgeLabel(node, target);
  }
  edgeEditDoubleLable(node, isNotify = true) {
    let model = node.getModel();
    const idx = this._edges.findIndex((r) => r.target === model.target && r.source === model.source);
    const labelStyle1 = this.getTextSize(model.label1 || defaultLabelText, this.edgeLinkStyle.edgeLabelTextStyle);
    const labelStyle2 = this.getTextSize(model.label2 || defaultLabelText, this.edgeLinkStyle.edgeLabelTextStyle);
    const options = {
      labelType: 2,
      labelStyle1,
      labelStyle2
    };
    if (idx !== -1) {
      this._edges[idx] = __spreadValues(__spreadValues({}, this._edges[idx]), options);
    }
    this.updateItem(node, __spreadProps(__spreadValues({}, options), {
      editType: 0
    }));
    node.toFront();
    if (isNotify) {
      this.emit("change", {
        type: MindmapEvent.edgeChange,
        options: {
          modify: options,
          edge: __spreadValues({}, this._edges[idx]),
          edges: this._edges
        }
      });
    }
  }
  edgeDeleteLabel(node, isNotify = true) {
    const model = node.getModel();
    this.modifyEdgeOptions({
      source: model.source,
      target: model.target,
      title: "",
      labelStyle: void 0,
      editType: void 0
    }, isNotify);
  }
  toData(data) {
    if (data.info) {
      data = __spreadProps(__spreadValues({}, data.info), {
        children: data.children ? data.children.map((child) => this.toData(child)) : []
      });
    }
    data.isDoubleLabel = this._edges.findIndex((r) => r.labelType === 2 && (r.source === data.id || r.target === data.id)) !== -1;
    return data;
  }
  replaceChildren(data, ids) {
    if (data.children && data.children.length > 0) {
      let tdx = -1;
      for (let i = 0; i < data.children.length; ++i) {
        let idx = ids.findIndex((id) => id === data.children[i].id);
        if (idx !== -1) {
          if (tdx === -1) {
            tdx = idx;
          }
          this.removeChild(ids[idx]);
          ids.splice(idx, 1);
        }
        let pdx = this.replaceChildren(data.children[i], ids);
        if (pdx !== -1) {
          if (tdx === -1) {
            tdx = pdx;
          }
        }
      }
      return tdx;
    }
    return -1;
  }
  replaceQuadtreeData(data, ids) {
    let idx = ids.findIndex((id) => id === data.id);
    if (idx !== -1)
      return false;
    idx = this.replaceChildren(data, ids);
    return idx;
  }
  addQuadtreeData(data) {
    var _a;
    let model = this.get("data");
    const ids = model.children.map((item) => item.id);
    let items = this.toData(data);
    const idx = this.replaceQuadtreeData(items, ids);
    if (idx === false) {
      return;
    }
    if (idx >= 0) {
      model.children[idx] = items;
      this.data(model);
      this.layout();
    } else {
      if (this.quadtreeType === "double") {
        items.side = model.children.length % 2 === 1 ? "left" : "right";
      } else {
        items.side = "right", items.posType = "right";
      }
      if (this.quadtreeType === "hor") {
        model.isHor = true;
      } else {
        model.isHor = false;
      }
      let sort = model.children.length;
      let s = this.createDataFromData(items, 0, this.initShowDepth, "0-" + sort);
      model.children.push(s);
      this.layout();
      if (this.quadtreeType === "hor") {
        const m = (_a = this.findById(s.id)) == null ? void 0 : _a.getModel();
        if (m) {
          this.editMoveTo(m.x, m.y);
        }
      }
    }
    if (this._curSelectedNode && this._curSelectedNode.destroyed) {
      this._curSelectedNode = void 0;
    }
    if (this._curSelectedNode && this._curSelectedNode.getType() !== "edge") {
      this.showEdge(this._curSelectedNode);
    }
  }
  changeQuadtreeType(type) {
    if (this.quadtreeType === type)
      return;
    this.quadtreeType = type;
    const model = this.get("data");
    model.isHor = this.quadtreeType === "hor";
    this.layout();
    this.fitCenter();
  }
  editMoveTo(x, y) {
    let bound = this.getContainer().getBoundingClientRect();
    var viewCenter = {
      x: bound.width / 2,
      y: bound.height / 2
    };
    var modelCenter = this.getPointByCanvas(viewCenter.x, viewCenter.y);
    var viewportMatrix = this.get("group").getMatrix();
    var dx = (modelCenter.x - x) * viewportMatrix[0];
    var dy = (modelCenter.y - y) * viewportMatrix[4];
    this.translate(dx, dy);
  }
  randomUUID() {
    return "xxxxxxxx4xxxyxxxxxxx".replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0, v = c === "x" ? r : r & 3 | 8;
      return v.toString(16);
    });
  }
  getLastModel() {
    let maxNode;
    let nodes = [];
    this.getNodes().forEach((node) => {
      const model = node.getModel();
      if (model.type === "mindmap-node" && model.visible !== false) {
        if (model.children.length === 0) {
          if (!maxNode) {
            maxNode = node;
            nodes = [node];
          } else if (maxNode.getModel().x < node.getModel().x) {
            maxNode = node;
            nodes = [node];
          } else if (maxNode.getModel().x === node.getModel().x) {
            nodes.push(node);
          }
        }
      }
    });
    if (nodes.length > 0) {
      let idx = parseInt((nodes.length / 2).toString());
      idx = idx > nodes.length - 1 ? nodes.length - 1 : idx;
      return nodes[idx].getModel();
    }
  }
  updateData(data, edges, cache = {}) {
    this._cache = cache;
    if (!Array.isArray(data) && typeof data === "object") {
      data = [data];
    }
    if (!(data == null ? void 0 : data.length))
      return;
    let d = data.map((item) => this.toData(item));
    this.data(d, this._isInit ? -1 : this.initShowDepth || 3, true);
    this.layout();
    if (edges && edges.length > 0) {
      this.formatEdge(edges);
      this._edges = edges;
      this.repaintEdge();
    }
    if (!this._isInit) {
      this._isInit = true;
      const { x, y } = this.getCenterPoint();
      this.zoomTo(this.scaleRatio, { x, y });
    }
    this.fitCenter();
    this.emit(EventName.change, {
      type: MindmapEvent.loaded
    });
  }
  updateEdges(edges) {
    if (!edges || edges.length === 0)
      return;
    if (edges) {
      this.formatEdge(edges);
      this._edges = edges;
      this.repaintEdge();
    } else {
      this.repaintEdge();
    }
  }
  appendEdges(edges) {
    if (!edges || edges.length === 0)
      return;
    let newEdges = edges.filter((edge) => this._edges.findIndex((r) => r.source === edge.source && r.target !== edge.target) === -1);
    this.formatEdge(newEdges);
    this._edges.push(...newEdges);
    this.repaintEdge();
  }
  getTextSize(text, attrs) {
    var _a;
    if (!text)
      return void 0;
    const ctx2 = (_a = this.get("canvas")) == null ? void 0 : _a.get("context");
    if (!ctx2)
      return;
    const textArr = text.split("\n");
    let fontSize = attrs.fontSize || 12;
    let lineHeight = attrs.lineHeight || fontSize;
    let width = 0, maxWidth = attrs.maxWidth || 99999;
    ctx2.font = `${attrs.fontWeight || "normal"} ${fontSize}px ${attrs.fontFamily || ""}`;
    let displayStr = "";
    let line = 0;
    let lastWidth = 0;
    textArr.forEach((str) => {
      let w = ctx2.measureText(str).width;
      if (w <= maxWidth) {
        width = Math.max(width, w);
        lastWidth = w;
        displayStr += (displayStr ? "\n" : "") + str;
        line++;
      } else {
        let lineWidth = 0;
        let p2 = 0;
        let lastStr = "";
        for (let i = 0; i < str.length; ++i) {
          let m = ctx2.measureText(str[i]);
          lineWidth += m.width;
          if (lineWidth > maxWidth) {
            line++;
            const lineStr = str.substring(p2, i - 1);
            displayStr += (displayStr ? "\n" : "") + lineStr;
            width = Math.max(width, ctx2.measureText(lineStr).width);
            lineWidth = m.width;
            p2 = i - 1;
            lastStr = "";
          }
          lastStr += str[i];
        }
        if (p2 < str.length - 1) {
          if (width < lineWidth) {
            width = lineWidth;
          }
          displayStr += (displayStr ? "\n" : "") + str.substring(p2, str.length);
          line++;
          lastWidth = ctx2.measureText(str.substring(p2, str.length)).width;
        } else {
          lastWidth = lineWidth;
        }
      }
    });
    if (text === "\u65B0\u5EFA\u6A21\u578B") {
      lastWidth = 0;
    }
    const style = { width, height: lineHeight * line, text: displayStr, maxWidth, lineHeight, lastWidth };
    return style;
  }
  formatEdge(edges) {
    edges.forEach((edge) => {
      edge.id = getLinkId(edge.source, edge.target);
      if (edge.labelType === 2) {
        edge.labelStyle1 = this.getTextSize(edge.label1 || defaultLabelText, this.edgeLinkStyle.edgeLabelTextStyle);
        edge.labelStyle2 = this.getTextSize(edge.label2 || defaultLabelText, this.edgeLinkStyle.edgeLabelTextStyle);
        let data = this.findDataById(edge.target);
        if (data) {
          data.isDoubleLabel = true;
        }
        let data2 = this.findDataById(edge.source);
        if (data2) {
          data2.isDoubleLabel = true;
        }
      } else {
        edge.labelStyle = this.getTextSize(edge.title || defaultLabelText, this.edgeLinkStyle.edgeLabelTextStyle);
      }
    });
    this.data(this.get("data"));
    this.layout();
  }
  initData(data, edges = []) {
    this.data(data, this.initShowDepth);
    this.layout(true);
    this.formatEdge(edges);
    this._edges = edges;
    this.repaintEdge();
  }
  hideEdge(node) {
    const model = node.getModel();
    if (this._hideEdge) {
      const edges2 = this._edges.filter((r) => r.source === model.id || r.target === model.id);
      edges2.forEach((edge) => {
        if (!this._tempNode || edge.id !== this._tempNode.getModel().id) {
          if (this.findById(edge.id)) {
            this.removeItem(edge.id);
          }
        }
      });
    }
    const edges = node.getEdges().filter((r) => {
      let m = r.getModel();
      return m.source === model.id || m.target === model.id;
    });
    edges.forEach((edge) => {
      let m = edge.getModel();
      if (m.labelType === 2) {
        this.updateItem(edge, {
          editType: void 0
        });
      }
    });
  }
  showEdge(node) {
    if (this._hideEdge) {
      this.repaintEdge(node);
    }
    const model = node.getModel();
    const edges = node.getEdges().filter((r) => {
      let m = r.getModel();
      return m.source === model.id || m.target === model.id;
    });
    edges.forEach((edge) => {
      let m = edge.getModel();
      if (m.labelType === 2) {
        this.updateItem(m.id, {
          editType: m.source === model.id ? 0 : 1
        });
      }
    });
  }
  repaintEdge(node) {
    if (!this._hideEdge) {
      this._edges.forEach((options) => {
        let p2 = this.findById(options.id);
        if (p2)
          return false;
        let s = this.findById(options.source);
        let t = this.findById(options.target);
        if (!s || !t)
          return;
        this.addItem("edge", __spreadProps(__spreadValues({
          name: NameString.edgeLink
        }, options), {
          zIndex: 5,
          type: NodeType.linkEdge,
          style: this.getLinkEdgeStyle()
        }));
      });
    } else if (node) {
      const model = node.getModel();
      const edges = this._edges.filter((r) => r.source === model.id || r.target === model.id);
      edges.forEach((options) => {
        let p2 = this.findById(options.id);
        if (p2)
          return false;
        let s = this.findById(options.source);
        let t = this.findById(options.target);
        if (!s || !t)
          return;
        this.addItem("edge", __spreadProps(__spreadValues({
          name: NameString.edgeLink
        }, options), {
          zIndex: 5,
          type: NodeType.linkEdge,
          style: this.getLinkEdgeStyle()
        }));
      });
    }
  }
  editItem(node, isReady = false) {
    this._editor.show(node, isReady);
  }
  editDisabled() {
    this._editor.blur();
  }
  menuExpand(node, expand) {
    const model = node.getModel();
    if (model.collapsed != expand) {
      model.collapsed = expand;
      this._cache[model.id] = !expand;
      this.layout();
      node.toFront();
    }
  }
  expandAll(node, expand) {
    const model = node.getModel();
    model.collapsed = expand;
    this._cache[model.id] = !expand;
    if (model.children) {
      model.children.forEach((child) => {
        this.updateCollapsed(child, expand);
      });
    }
    this.layout();
    node.toFront();
  }
  updateCollapsed(model, expand) {
    model.collapsed = expand;
    this._cache[model.id] = !expand;
    if (model.children) {
      model.children.forEach((child) => {
        this.updateCollapsed(child, expand);
      });
    }
  }
  editCollapse(node, expand = false) {
    let model = node.getModel();
    if (expand) {
      if (model.collapsed) {
        model.collapsed = false;
        this.layout();
      }
      return;
    }
    {
      if (node.hasState("selected") && !model.collapsed || model.children.length === 0) {
        this.emit(EventName.change, {
          type: MindmapEvent.nodeAdd,
          options: {
            node
          }
        });
      } else if (!model.collapsed) {
        model.collapsed = true;
        this._cache[model.id] = false;
        if (this._curSelectedNode || this.tempVariable.linkNode) {
          const ids = this.getChildrenIds(model);
          ids.splice(0, 1);
          if (this._curSelectedNode) {
            this._tempCollapsedSelected = this._curSelectedNode.getModel().id;
            if (ids.includes(this._curSelectedNode.getModel().id)) {
              this.cancelSelect();
            }
          }
          if (this.tempVariable.linkNode && ids.includes(this.tempVariable.linkNode.getModel().id)) {
            this.deleteLinkBtn();
            this.tempVariable.linkNode = void 0;
          }
        }
        this.layout();
      } else {
        model.collapsed = false;
        this._cache[model.id] = true;
        this.layout();
        this.repaintEdge();
        if (this._tempCollapsedSelected && !this._curSelectedNode) {
          this.editSelectedNode(this.findById(this._tempCollapsedSelected), true, false);
        }
        this._tempCollapsedSelected = void 0;
        this.emit(EventName.change, {
          type: MindmapEvent.nodeCollapsed,
          options: {
            node
          }
        });
      }
    }
  }
  editAddNodeById(id, item, isEdit = true) {
    const node = this.findById(id);
    if (!node)
      return;
    this.editAddNode(node, item);
  }
  editAddNode(node, item, isEdit = true) {
    const model = node.getModel();
    const newItem = this.createDataFromData(__spreadValues({}, item), model.realDepth + 1, -1, model.sortId + "-" + model.children.length);
    delete newItem.sort;
    if (item.sort >= 0) {
      model.children.splice(item.sort, 0, newItem);
    } else {
      model.children.push(newItem);
    }
    this.on("afterlayout", () => {
      this.editCollapse(node, true);
      this.editSelectedNodeById(item.id, true);
      if (isEdit) {
        this.editItem(this.findById(newItem.id));
      }
    }, true);
    this.layout();
  }
  editFitCenter() {
    this.fitCenter();
    const { x, y } = this.getCenterPoint();
    this.zoomTo(this._config.scaleRatio, { x, y });
  }
  getCenterPoint() {
    const { width, height } = this.getContainer().getBoundingClientRect();
    return {
      x: parseInt((width / 2).toString()),
      y: parseInt((height / 2).toString())
    };
  }
  editZoomOut() {
    const currentZoom = this.getZoom();
    const ratioOut = 1 / (1 - 0.05 * 2);
    const maxZoom = this.get("maxZoom");
    const { x, y } = this.getCenterPoint();
    if (ratioOut * currentZoom > maxZoom) {
      return;
    }
    this.zoomTo(currentZoom * ratioOut, { x, y });
  }
  editZoomIn() {
    const currentZoom = this.getZoom();
    const ratioIn = 1 - 0.05 * 2;
    const minZoom = this.get("minZoom");
    if (ratioIn * currentZoom < minZoom) {
      return;
    }
    const { x, y } = this.getCenterPoint();
    this.zoomTo(currentZoom * ratioIn, { x, y });
  }
  getChildrenIds(model) {
    let p2 = [model.id];
    if (model.children) {
      model.children.forEach((child) => {
        let s = this.getChildrenIds(child);
        p2.push(...s);
      });
    }
    return p2;
  }
  removeAllEdges(model) {
    let ids = this.getChildrenIds(model);
    let d = this._edges.filter((item) => ids.includes(item.source) || ids.includes(item.target));
    this._edges = this._edges.filter((item) => !ids.includes(item.source) && !ids.includes(item.target));
    return d;
  }
  deleteNodeById({ id, deleteIds, deleteEdges }, isNotify = false) {
    deleteIds.forEach((id2) => {
      const node = this.findById(id2);
      if (!node)
        return;
      this.editDeleteNode(node, isNotify);
    });
    deleteEdges.forEach((edge) => {
      let idx = this._edges.findIndex((r) => r.source === edge.source && r.target === edge.target);
      if (idx !== -1) {
        this._edges.splice(idx, 1);
      }
    });
    this.updateHasDoubleLabel(deleteEdges, id);
    this.refreshData();
  }
  updateHasDoubleLabel(edges, id) {
    if (!edges || edges.length === 0)
      return;
    edges.forEach((edge) => {
      if (edge.source === id && !this.checkHasDoubleLabel(edge.target)) {
        let data = this.findDataById(edge.target);
        if (data) {
          data.isDoubleLabel = false;
        }
      } else if (edge.target === id && !this.checkHasDoubleLabel(edge.source)) {
        let data = this.findDataById(edge.source);
        if (data) {
          data.isDoubleLabel = false;
        }
      }
    });
    this.refreshData();
  }
  closeSelectByFilterNode(model) {
    let ids = this.getChildrenIds(model);
    if (this._curSelectedNode && ids.includes(this._curSelectedNode.getModel().id)) {
      this.cancelSelect();
    }
    if (this.tempVariable.linkNode && ids.includes(this.tempVariable.linkNode.getModel().id)) {
      this.closeLinkBtn();
    }
  }
  editDeleteNode(node, isNotify = true) {
    var _a;
    let parentNode = node.get("parent");
    let nextSelectNodeId = parentNode == null ? void 0 : parentNode.get("id");
    const model = node.getModel();
    this.closeSelectByFilterNode(model);
    let deleteEdges = isNotify ? this.removeAllEdges(model) : void 0;
    this.removeChild(node.get("id"));
    this.refreshData();
    if (isNotify) {
      this.updateHasDoubleLabel(deleteEdges, model.id);
      this.emit(EventName.change, {
        type: MindmapEvent.nodeDelete,
        options: {
          model,
          deleteIds: this.getChildrenIds(model),
          edges: this._edges,
          deleteEdges
        }
      });
    }
    if (parentNode && parentNode.getModel().visible === false) {
      nextSelectNodeId = (_a = parentNode.get("parent")) == null ? void 0 : _a.get("id");
      this.removeChild(parentNode.get("id"));
    }
    if (!this._curSelectedNode && nextSelectNodeId && nextSelectNodeId !== nameHideRoot) {
      this.editSelectedNodeById(nextSelectNodeId, true, true);
    }
    return deleteEdges;
  }
  editSelectedNodeById(id, selected = true, isNotify = false) {
    const node = this.findById(id);
    if (node) {
      this.editSelectedNode(node, selected, isNotify);
      return true;
    } else {
      this.cancelSelect();
    }
    return false;
  }
  getNodeAndChildrenEdgesById(id) {
    const node = this.findById(id);
    if (node) {
      return this.getNodeAndChildrenEdges(node);
    } else {
      return [];
    }
  }
  getNodeAndChildrenEdges(node) {
    const ids = this.getChildrenIds(node.getModel());
    const edges = this._edges.filter((r) => ids.includes(r.source) && ids.includes(r.target));
    return edges;
  }
  resetData(data, edges) {
    if (!Array.isArray(data) && typeof data === "object") {
      data = [data];
    }
    if (!(data == null ? void 0 : data.length))
      return;
    this._curSelectedNode = void 0;
    this.tempVariable.linkNode = void 0;
    this.tempVariable.moveLinkEdge = void 0;
    const d = data.map((item) => this.toData(item));
    this.changeData(this.formatData(d, -1));
    this.layout(true);
    const { x, y } = this.getCenterPoint();
    this.zoomTo(this.scaleRatio, { x, y });
  }
  editChangeRoot(id, isNotify = true) {
    const node = this.findById(id);
    if (node) {
      const model = node.getModel();
      const sortId = model.sortId;
      const ids = this.getChildrenIds(model);
      ids.push(nameHideRoot);
      const nodes = this.getNodes().filter((node2) => !ids.includes(node2.getModel().id));
      nodes.forEach((node2) => {
        this.removeItem(node2, false);
      });
      let root = this.get("data");
      if (root.id === nameHideRoot) {
        root.children = [model];
      }
      this._curSelectedNode = void 0;
      this.tempVariable.linkNode = void 0;
      this.tempVariable.moveLinkEdge = void 0;
      this.data(root);
      this.render();
      this.fitCenter();
      if (isNotify) {
        this.emit(EventName.change, {
          type: MindmapEvent.nodeChangeRoot,
          options: {
            id,
            sortId
          }
        });
      }
      return true;
    }
    return false;
  }
  editSelectedNode(node, selected = true, isNotify = true, isShowEdge = true) {
    if (!node || node.destroyed)
      return;
    this._tempCollapsedSelected = void 0;
    this.checkCloseSelected(node);
    if (!selected) {
      this.checkNodeEditTitle(node);
    }
    node.setState && node.setState("selected", selected, node);
    this._curSelectedNode = selected ? node : void 0;
    selected && this._curSelectedNode.toFront();
    if (selected && this.mode === "edit") {
      this.editItem(node, true);
    }
    if (selected && isShowEdge) {
      this.showEdge(node);
    }
    if (isNotify) {
      this.emit(EventName.change, {
        type: MindmapEvent.nodeSelect,
        options: {
          node
        }
      });
    }
  }
  cancelSelectNode() {
    if (this._curSelectedNode) {
      if (this._curSelectedNode.getType() === "edge") {
        this.updateItem(this._curSelectedNode, {
          selected: false,
          editType: void 0
        }, false);
      } else {
        this.checkNodeEditTitle(this._curSelectedNode);
        this._curSelectedNode.setState("selected", false, this._curSelectedNode);
      }
      this._curSelectedNode = this.undoStack;
    }
  }
  cancelSelect() {
    if (this._curSelectedNode && this._curSelectedNode.destroyed) {
      this._curSelectedNode = void 0;
    }
    if (this._curSelectedNode) {
      if (this._curSelectedNode.getType() === "edge") {
        this._curSelectedNode.getSource().toBack();
        this._curSelectedNode.getTarget().toBack();
        this._curSelectedNode.toBack();
        this.updateItem(this._curSelectedNode, {
          selected: false,
          editType: void 0
        }, false);
        let node = this.findById(IDString.linkTargetDot);
        if (node) {
          this.removeItem(node, false);
        }
        node = this.findById(IDString.linkSourceDot);
        if (node) {
          this.removeItem(node, false);
        }
        if (this._hideEdge) {
          this.removeItem(this._curSelectedNode.getModel().id, false);
        }
      } else {
        this.checkNodeEditTitle(this._curSelectedNode);
        this._curSelectedNode.setState("selected", false, this._curSelectedNode);
        this.hideEdge(this._curSelectedNode);
      }
      this._curSelectedNode = void 0;
    }
  }
  checkNodeEditTitle(node) {
    if (!node)
      return;
    const model = node.getModel();
    if (model.type === NodeType.defaultNode && model.isFocus) {
      model.isFocus = false;
      this.updateNodeTitle(node, model.title);
      this.emit(EventName.change, {
        type: MindmapEvent.nodeTitleBlur,
        options: {
          model,
          title: model.title.trim()
        }
      });
    }
  }
  editSelectLink(node, type = void 0) {
    this._tempAddLinkType = type;
    this.cancelSelect();
    if (this.tempVariable.linkNode && this.tempVariable.linkNode.getModel().id === node.getModel().id) {
      return;
    }
    if (this.tempVariable.linkNode) {
      this.closeLinkBtn();
    }
    this.tempVariable.linkNode = node;
    node.setState("link", true, node);
  }
  updateEdgeState(edge, state) {
    if (state.hover) {
      edge.setState("hover", true, edge);
    } else {
      edge.setState("hover", false, edge);
    }
    if (this._curSelectedNode && this._curSelectedNode.getModel().id !== edge.getModel().id) {
      edge.toFront();
    } else {
      edge.toBack();
    }
  }
  checkCloseSelected(node) {
    if (this.tempVariable.linkNode) {
      this.closeLinkBtn(this.tempVariable.linkNode.get("id") === node.get("id"));
    }
    this.cancelSelect();
  }
  editClickEdge(node, selected) {
    if (this._curSelectedNode && node.get("id") === this._curSelectedNode.get("id"))
      return;
    this._tempNode = node;
    this.checkCloseSelected(node);
    this._tempNode = void 0;
    this._curSelectedNode = selected ? node : void 0;
    if (selected) {
      this.emit(EventName.change, {
        type: MindmapEvent.edgeClick,
        options: {
          node: this._curSelectedNode
        }
      });
    }
    if (this.clickEdgeShowLabel) {
      this.updateItem(node, {
        selected
      }, false);
    }
    if (selected) {
      node.toBack();
    } else {
      node.toBack();
    }
    if (selected) {
      this.readyDotIndex(node);
      node.toFront();
    }
  }
  addDotToCanvas(node, index, id) {
    const pos = getCanvasPointByNode(node, index);
    let p2 = this.addItem("node", __spreadProps(__spreadValues({
      id,
      name: NameString.linkSelectDot
    }, pos), {
      type: "node-dot",
      capture: true,
      draggable: true,
      style: this.edgeLinkStyle.circleDotStyle
    }));
    p2.toFront();
  }
  readyDotIndex(node) {
    const model = node.getModel();
    this.addDotToCanvas(node.getTarget(), model.endIndex, IDString.linkTargetDot);
    this.addDotToCanvas(node.getSource(), model.startIndex, IDString.linkSourceDot);
  }
  changeNodeTitle({ id, title }, isNotify = false) {
    let node = this.findById(id);
    if (node) {
      this.updateNodeTitle(node, title);
      if (isNotify) {
        this.emit(EventName.change, {
          type: MindmapEvent.nodeTitleBlur,
          options: {
            model: node.getModel(),
            title
          }
        });
      }
    }
  }
  changeTheme(theme) {
    this.setTheme(theme);
    if (theme.edgeStyle) {
      this.cfg.defaultEdge.style = theme.edgeStyle;
      this.getEdges().forEach((edge) => {
        if (edge.getModel().type === NodeType.defaultEdge) {
          edge.update({
            style: theme.edgeStyle
          });
        } else if (edge.getModel().type === NodeType.linkEdge) {
          edge.update({
            style: this.getLinkEdgeStyle()
          });
        }
      });
    }
    this.data(this.get("data"), -1);
    this.layout();
  }
  updateGraphItem(id, data) {
    const node = this.findById(id);
    if (!node)
      return;
    const model = node.getModel();
    for (let key in data) {
      model[key] = data[key];
    }
    this.data(this.get("data"));
    this.layout();
  }
  moveNode({
    parentId,
    moveId,
    sort,
    p: p2
  }) {
    var _a;
    if (moveId === this.get("data").id)
      return;
    this.cancelSelect();
    this.closeLinkBtn();
    const node = this.findById(moveId);
    if (node) {
      this.removeChild(moveId);
    }
    let source;
    if (!parentId || parentId === "root") {
      let data = this.get("data");
      if (!data.id || data.id === "root") {
        source = data;
      }
    } else {
      source = (_a = this.findById(parentId)) == null ? void 0 : _a.getModel();
    }
    if (!source)
      return;
    source.children.splice(sort, 0, p2.nodes);
    this.data(this.get("data"));
    this.layout();
    p2.edges.forEach((edge) => {
      const idx = this._edges.findIndex((r) => r.target !== edge.target && r.source === edge.source);
      if (idx === -1) {
        edge.id = getLinkId(edge.source, edge.target);
        this._edges.push(edge);
      }
    });
    this.repaintEdge();
  }
  setEdgeVisible(hide) {
    this._hideEdge = hide;
    if (!hide) {
      this.repaintEdge();
    } else {
      let edges = this.getEdges().filter((r) => r.getModel().type === NodeType.linkEdge);
      edges.forEach((edge) => {
        this.removeItem(edge);
      });
    }
  }
  exsitLink(source, target) {
    return !!this.findById(getLinkId(source, target));
  }
  getQuadtreeNodes(nodeId) {
    const map = /* @__PURE__ */ new Set();
    this._edges.filter((edge) => {
      if (edge.target === nodeId || edge.source === nodeId) {
        let otherId = edge.target === nodeId ? edge.source : edge.target;
        let ms = this.findDataById(otherId);
        if (!ms && !map.has(otherId)) {
          map.add(otherId);
        }
      }
    });
    return Array.from(map);
  }
  getNodeCorrelations(nodeId) {
    let result = [];
    const map = /* @__PURE__ */ new Set();
    this._edges.filter((edge) => {
      if (edge.target === nodeId || edge.source === nodeId) {
        let ms;
        if (edge.labelType === 2) {
          ms = edge.target === nodeId ? this.findDataById(edge.source) : this.findDataById(edge.target);
        } else if (edge.source === nodeId) {
          ms = this.findDataById(edge.target);
        }
        if (ms && !map.has(ms.id)) {
          map.add(ms.id);
          result.push(ms);
        }
      }
    });
    return result;
  }
  getChildrenByFilter(map, children) {
    let s = [];
    children.forEach((child) => {
      if (!map.has(child.id)) {
        map.add(child.id);
        s.push(__spreadProps(__spreadValues({}, child), {
          children: this.getChildrenByFilter(map, child.children),
          isDoubleLabel: false
        }));
      }
    });
    return s;
  }
  getShowEdgesAndChildrens(node) {
    const model = node.getModel();
    const newChildren = [];
    let map = /* @__PURE__ */ new Set();
    map.add(model.id);
    const items = [];
    this._edges.forEach((edge) => {
      let item, label;
      if (edge.labelType === 2 && (edge.target === model.id || edge.source === model.id)) {
        item = this.findDataById(edge.target === model.id ? edge.source : edge.target);
        label = edge.target === model.id ? edge.label2 : edge.label1;
      } else if (edge.source === model.id) {
        item = this.findDataById(edge.target);
        label = edge.title;
      }
      if (item && !map.has(item.id)) {
        map.add(item.id);
        items.push({ item, label });
      }
    });
    items.forEach(({ item, label }) => {
      newChildren.push(__spreadProps(__spreadValues({}, item), {
        children: this.getChildrenByFilter(map, item.children),
        style: __spreadProps(__spreadValues({}, item.style), {
          beforeWidth: void 0,
          afterWidth: void 0
        }),
        label,
        isDoubleLabel: false
      }));
    });
    return __spreadProps(__spreadValues({}, model), {
      isDoubleLabel: false,
      children: newChildren
    });
  }
  createLinkDot(x, y) {
    return this.addItem("node", {
      id: IDString.linkMouseNode,
      visible: false,
      x,
      y,
      type: "node-dot",
      style: this.edgeLinkStyle.circleDotStyle
    }, false);
  }
  createMouseLinkEdge(options) {
    return this.addItem("edge", __spreadProps(__spreadValues({}, options), {
      style: this.getLinkEdgeStyle()
    }), false);
  }
  createDragNode(x, y) {
    let options = {
      id: "move-node",
      label: "",
      x,
      y,
      type: "node-move",
      zIndex: 3,
      style: this.nodeStyle.dragStyle
    };
    return this.addItem("node", options, false);
  }
  createDragEdge(options) {
    return this.addItem("edge", __spreadValues({
      id: "move-edge",
      target: "move-node",
      type: "edge-default",
      zIndex: 3
    }, options), false);
  }
  cloneTo(item) {
    const parentId = item.parentId || item.parent && item.parent.id;
    const parentModel = this.findDataById(parentId);
    if (!parentModel)
      return;
    if (!parentModel.children) {
      parentModel.children = [];
    }
    const len = parentModel.children.length;
    const newData = this.createDataFromData(item, parentModel.realDepth + 1, -1, parentModel.sortId + "-" + len);
    this.addChild(newData, parentModel.id);
  }
  destory() {
    if (this._editor) {
      delete this._editor;
      this._editor = void 0;
    }
    super.destroy();
  }
  changeEdgeShowLabel(show) {
    this.clickEdgeShowLabel = show;
  }
  changeEdgeStyle(edge, options) {
    const targetId = edge.getTarget().getModel().id;
    const sourceId = edge.getSource().getModel().id;
    if (!this.links[sourceId]) {
      this.links[sourceId] = [];
    }
    this.links[sourceId][targetId] = __spreadValues(__spreadValues({}, this.links[sourceId][targetId]), options);
    edge.getSource().getModel().edgeConfig = this.links[sourceId];
    edge.draw();
  }
  canHideParent(node) {
    let parent = node.get("parent");
    if (!parent || parent._cfg.id === "hide-root") {
      return false;
    }
    parent = parent.get("parent");
    return !(!parent || parent._cfg.id === "hide-root");
  }
  hideParent(node) {
    const parent = node.get("parent");
    if (!parent || parent._cfg.id === "hide-root")
      return;
    let root = parent.get("parent");
    while (root.get("parent") && root.get("parent")._cfg.id !== "hide-root") {
      root = root.get("parent");
    }
    if (root) {
      const data = this.get("data");
      const newRoot = parent.getModel();
      const idx = data.children.findIndex((r) => r.id === root._cfg.id);
      if (idx !== -1) {
        this.cancelSelect();
        this._tempShirnkMap.set(newRoot.id, __spreadValues({}, root.getModel()));
        this.removeChild(root._cfg.id);
        newRoot.type = NodeType.shrinkRoot;
        newRoot.hideNum = newRoot.depth;
        data.children.splice(idx, 0, newRoot);
      }
      this.data(data);
      this.layout();
    }
  }
  recoverParent(node) {
    const model = node.getModel();
    model.type = NodeType.defaultNode;
    const data = this.get("data");
    const idx = data.children.findIndex((r) => r.id === model.id);
    if (idx !== -1) {
      let curSelectId;
      if (this._curSelectedNode) {
        curSelectId = this._curSelectedNode.getModel().id;
      }
      this.cancelSelect();
      const oldRoot = this._tempShirnkMap.get(model.id);
      this.removeChild(model.id);
      data.children.splice(idx, 1, oldRoot);
      const oldModel = this.findDataById(model.id);
      oldModel.children = model.children;
      oldModel.type = NodeType.defaultNode;
      oldModel.style = void 0;
      this.data(data);
      this.layout();
      this._tempShirnkMap.delete(model.id);
      if (curSelectId) {
        this.editSelectedNode(this.findById(curSelectId), true, false);
      }
    }
  }
  hasLink(edge) {
    const targetId = edge.getTarget().getModel().id;
    const sourceId = edge.getSource().getModel().id;
    if (this.links[sourceId] && this.links[sourceId][targetId]) {
      return this.links[sourceId][targetId].arrowType > 0;
    }
    return false;
  }
}
var TABLE;
var TABLE_TR;
var FRAGMENT_REG;
var CONTAINERS;
function initConstants() {
  TABLE = document.createElement("table");
  TABLE_TR = document.createElement("tr");
  FRAGMENT_REG = /^\s*<(\w+|!)[^>]*>/;
  CONTAINERS = {
    tr: document.createElement("tbody"),
    tbody: TABLE,
    thead: TABLE,
    tfoot: TABLE,
    td: TABLE_TR,
    th: TABLE_TR,
    "*": document.createElement("div")
  };
}
function createDom(str) {
  if (!TABLE) {
    initConstants();
  }
  var name = FRAGMENT_REG.test(str) && RegExp.$1;
  if (!name || !(name in CONTAINERS)) {
    name = "*";
  }
  var container = CONTAINERS[name];
  str = typeof str === "string" ? str.replace(/(^\s*)|(\s*$)/g, "") : str;
  container.innerHTML = "" + str;
  var dom = container.childNodes[0];
  if (dom && container.contains(dom)) {
    container.removeChild(dom);
  }
  return dom;
}
function modifyCSS(dom, css) {
  if (dom) {
    for (var key in css) {
      if (css.hasOwnProperty(key)) {
        dom.style[key] = css[key];
      }
    }
  }
  return dom;
}
class PluginBase {
  constructor(cfgs) {
    this._cfgs = deepMix(this.getDefaultCfgs(), cfgs);
    this._events = {};
    this.destroyed = false;
  }
  getDefaultCfgs() {
    return {};
  }
  initPlugin(graph) {
    const self = this;
    self.set("graph", graph);
    const events = self.getEvents();
    const bindEvents = {};
    each(events, (v, k) => {
      const event = wrapBehavior(self, v);
      bindEvents[k] = event;
      graph.on(k, event);
    });
    this._events = bindEvents;
    this.init();
  }
  getEvents() {
    return {};
  }
  get(key) {
    var _a;
    return (_a = this._cfgs) == null ? void 0 : _a[key];
  }
  set(key, val) {
    this._cfgs[key] = val;
  }
  destroy() {
  }
  destroyPlugin() {
    this.destroy();
    const graph = this.get("graph");
    const events = this._events;
    each(events, (v, k) => {
      graph.off(k, v);
    });
    this._events = null;
    this._cfgs = null;
    this.destroyed = true;
  }
}
var insertCss$2 = { exports: {} };
var containers = [];
var styleElements = [];
var usage = "insert-css: You need to provide a CSS string. Usage: insertCss(cssString[, options]).";
function insertCss(css, options) {
  options = options || {};
  if (css === void 0) {
    throw new Error(usage);
  }
  var position = options.prepend === true ? "prepend" : "append";
  var container = options.container !== void 0 ? options.container : document.querySelector("head");
  var containerId = containers.indexOf(container);
  if (containerId === -1) {
    containerId = containers.push(container) - 1;
    styleElements[containerId] = {};
  }
  var styleElement;
  if (styleElements[containerId] !== void 0 && styleElements[containerId][position] !== void 0) {
    styleElement = styleElements[containerId][position];
  } else {
    styleElement = styleElements[containerId][position] = createStyleElement();
    if (position === "prepend") {
      container.insertBefore(styleElement, container.childNodes[0]);
    } else {
      container.appendChild(styleElement);
    }
  }
  if (css.charCodeAt(0) === 65279) {
    css = css.substr(1, css.length);
  }
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText += css;
  } else {
    styleElement.textContent += css;
  }
  return styleElement;
}
function createStyleElement() {
  var styleElement = document.createElement("style");
  styleElement.setAttribute("type", "text/css");
  return styleElement;
}
insertCss$2.exports = insertCss;
insertCss$2.exports.insertCss = insertCss;
var insertCss$1 = insertCss$2.exports;
typeof document !== "undefined" && insertCss$1(`
  .plugin-popover-container {
  background: #262626;
  color: #fefefe;
  border-radius: 6px;
  font-size: 14px;
  line-height: 1.4;
  &::after{
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    border: 4px solid transparent;
    border-top-color: #262626;
    transform: translate(-50%,99%);
  }

  &>ul {
    display: flex;
    padding: 6px;
    margin:0;
  }

  & li {
    padding: 3px 5px;
    list-style:none;
  }

  & li+li {
    position: relative;
    &::before {
      content: '';
      width: 1px;
      height: 60%;
      position: absolute;
      left: 0;
      top: 50%;
      background: #fefefe;
      transform: translateY(-50%);
      border-radius: 4px;
      opacity: 0.3;
    }
  }
}
`);
class Popover extends PluginBase {
  constructor(config) {
    super(config);
  }
  getDefaultCfgs() {
    return {
      handleClick: void 0,
      offsetX: 0,
      offsetY: 10,
      itemTypes: ["node"],
      getContent: (e) => {
        return `
          <ul>
            <li>\u83DC\u5355\u98791</li>
            <li>\u83DC\u5355\u98792</li>
          </ul>
        `;
      },
      shouldBegin: (e) => {
        return true;
      }
    };
  }
  getEvents() {
    return {
      click: "onMenuShow",
      touchend: "onMenuShow",
      wheel: "onMenuHide",
      touchmove: "onMenuHide"
    };
  }
  init() {
    const className = this.get("className");
    const menu = createDom(`<div class=${className || "plugin-popover-container"}></div>`);
    modifyCSS(menu, { top: "0px", position: "absolute", visibility: "hidden" });
    let container = this.get("container");
    if (!container) {
      container = this.get("graph").get("container");
    }
    if (isString(container)) {
      container = document.getElementById(container);
    }
    container.appendChild(menu);
    this.set("menu", menu);
  }
  onMenuShow(e) {
    const self = this;
    e.preventDefault();
    const itemTypes = this.get("itemTypes");
    if (!e.item) {
      if (itemTypes.indexOf("canvas") === -1) {
        self.onMenuHide();
        return;
      }
    } else {
      if (e.item && e.item.getType && itemTypes.indexOf(e.item.getType()) === -1) {
        self.onMenuHide();
        return;
      }
    }
    const shouldBegin = this.get("shouldBegin");
    if (!shouldBegin(e))
      return;
    const menuDom = this.get("menu");
    const getContent = this.get("getContent");
    const graph = this.get("graph");
    const menu = getContent(e, graph);
    if (isString(menu)) {
      menuDom.innerHTML = menu;
    } else {
      menuDom.innerHTML = menu.outerHTML;
    }
    this.removeMenuEventListener();
    const handleClick = this.get("handleClick");
    if (handleClick) {
      const handleMenuClickWrapper = (evt) => {
        handleClick(evt.target, e.item, graph);
      };
      this.set("handleMenuClickWrapper", handleMenuClickWrapper);
      menuDom.addEventListener("click", handleMenuClickWrapper);
    }
    const bbox = menuDom.getBoundingClientRect();
    const offsetX = this.get("offsetX") || 0;
    const offsetY = this.get("offsetY") || 0;
    const cbox = graph.getContainer().getBoundingClientRect();
    const { x: nodeX, y: nodeY, height: nodeHeight, width: nodeWidth } = e.item.getBBox();
    const { x: nodeClientX, y: nodeClientY } = graph.getClientByPoint(nodeX, nodeY);
    const zoom = graph.getZoom();
    let x = nodeClientX - cbox.x - offsetX * zoom + (nodeWidth * zoom - bbox.width) / 2;
    let y = nodeClientY - cbox.y - offsetY * zoom - bbox.height;
    modifyCSS(menuDom, {
      top: `${y}px`,
      left: `${x}px`,
      visibility: "visible",
      transform: `scale(${zoom})`,
      transformOrigin: `0 0`
    });
    let triggeredByFirstClick = this.get("trigger") === "click";
    const handler = (evt) => {
      if (triggeredByFirstClick) {
        triggeredByFirstClick = false;
        return;
      }
      self.onMenuHide();
    };
    document.body.addEventListener("click", handler);
    this.set("handler", handler);
  }
  removeMenuEventListener() {
    const handleMenuClickWrapper = this.get("handleMenuClickWrapper");
    const handler = this.get("handler");
    if (handleMenuClickWrapper) {
      const menuDom = this.get("menu");
      menuDom.removeEventListener("click", handleMenuClickWrapper);
      this.set("handleMenuClickWrapper", null);
    }
    if (handler) {
      document.body.removeEventListener("click", handler);
    }
  }
  onMenuHide() {
    const menuDom = this.get("menu");
    if (menuDom) {
      modifyCSS(menuDom, { visibility: "hidden" });
    }
    this.removeMenuEventListener();
  }
  hide() {
    this.onMenuHide();
  }
  destroy() {
    const menu = this.get("menu");
    this.removeMenuEventListener();
    if (menu) {
      let container = this.get("container");
      if (!container) {
        container = this.get("graph").get("container");
      }
      if (isString(container)) {
        container = document.getElementById(container);
      }
      container.removeChild(menu);
    }
  }
}
export { EventName, IDString, MindGraph, MindmapEvent, NameString, NodeType, Popover, isMobile, isSafari, isWin, nameHideRoot, resizeObserver };
